// Traditional Chinese (generated from en.js structure; values from existing tc.js + batch translations)
const tc = {
    btnLogin: "登入",
    btnChangeUser: "變更用戶",
    msgLoginTimeout: "已逾時自動登出。",
    msgProfileNotFound: "找不到設定檔",
    msgLoginFail: "用戶名稱或密碼不正確，請重試。",
    msgLockAccount: "帳戶已鎖定，請重設密碼以解鎖。",
    msgUserNotActivate: "用戶未啟用",
    msgChangeUserFail: "用戶名稱不正確或用戶未啟用",
    msgChangeUserNoAccess: "你沒有轉換用戶的權限",
    lbRegister: "註冊",
    msgHaveSISAccount: "你是否有 SIS 帳戶？",
    lbRegisterWithSIS: "是",
    lbRegisterWithoutSIS: "否",
    lbForgotPW: "忘記密碼",
    lbResetPW: "重置密碼",
    lbTermsOfUse: "使用條款",
    lbTermsOfUseContent: "法律免責聲明：本系統不得作為唯一資訊工具，用以推衍日後向 M+R Spedag Group 任何成員及其聯屬公司和／或代理就服務表現提出的任何申索。在任何情況下，M+R Spedag Group 任何成員及其聯屬公司和／或代理均毋須因存取或使用本系統，或無法存取或使用本系統而導致的任何損害（包括但不限於特殊或間接損害）承擔責任。本系統所載資料均不就其準確性、可靠性或完整性作出任何明示或默示的保證。",
    lbSignUp: "註冊",
    rw: {
        lbHeader: "表頭",
        lbSearch: "搜尋",
        lbResult: "結果",
        lbReportName: "報表名稱",
        lbCreatedBy: "建立者",
        lbDescription: "描述",
        lbShare: "共享",
        lbShareOffice: "共享辦事處",
        lbShareUser: "共享用戶",
        lbTags: "標籤",
        lbFields: "欄位",
        lbETD: "ETD",
        lbExportToExcel: "匯出至 Excel",
        msgPleaseSelect: "請同時選取："
    },
    privacyPolicy: {
        header: "私隱政策",
        privacyPolicy1: "本私隱政策僅適用於 M+R Spedag Group 網站 www.mrspedag.com。",
        privacyPolicy2: "我們的目標是確保您的個人資料在符合法律規定下處理。我們的網站可能載有外部網站的連結，本資料保護聲明對該等外部網站無效。",
        personalData: "個人資料",
        personalDataContent: "我們不會於網站系統性收集個人資料。網站訪客仍可能向我們傳送個人資料，例如透過聯絡表格與我們聯絡。",
        useOfPersonalData: "個人資料的使用",
        useOfPersonalDataContent: "用戶透過網上表格、電郵或類似方式提交個人資料，即表示同意處理該等資料。這可能是回覆查詢或提供服務所必需。如個人資料傳送予我們，該等資料只會用於內部流程，並按照法律規定管理。",
        deletionOfPersonalData: "個人資料的刪除",
        deletionOfPersonalDataContent: "資料當事人可要求查閱個人資料，以及要求更改或刪除個人資料。M+R Spedag Group 將審視有關要求，並按照法律規定執行。",
        contract: "聯絡",
        contractContent: "有關您資料的資訊可透過電郵發送予您：info@mrspedag.com",
        passongOfPersonalData: "個人資料的轉移",
        passongOfPersonalDataContent: "原則上，個人資料不會轉移予第三方。然而，如為遵守適用的法律及法規，及／或我們認為有需要以保障我們的權利及／或保護我們的財產，我們保留採取此步驟的權利。",
        cookies: "Cookies",
        cookiesContent: "本網站的完整功能有賴使用 Cookies。這些是儲存於訪客電腦的小型檔案。Cookies 用於儲存某些設定或偏好。這些 Cookies 不會對用戶的電腦構成任何風險。",
        webAnalysisTools: "網站分析工具",
        webAnalysisToolsContent: "本網站使用 Google Analytics（Google Inc. 的網站分析服務）。有關網站使用的資訊（包括訪客的 IP 位址）會傳送至 Google 伺服器（通常位於美國）並儲存於該處。此服務用於評估網站的使用情況。Google 於網頁連結「https://tools.google.com/dlpage/gaoptout」為最常用的網頁瀏覽器提供附加元件，可停用 Google Analytics。",
    },
    lbMR: "華隆瑞鋒貨運有限公司",
    lblConfirm: "確定",
    lblCancel: "取消",
    lblOK: "OK",
    lblBack: "返回",
    lblEdit: "編輯",
    lblOMSPO: "OMS PO",
    lblNext: "下一頁",
    lblSubmit: "提交",
    lblSearch: "搜尋",
    lblApply: "套用",
    lblCreate: "建立",
    lblYes: "是",
    lblNo: "否",
    lbAcceptRejectAllText: "接受／拒絕所有變更",
    msgConfirmAcceptRejectAll: "請在接受或拒絕前審閱所有變更",
    lbShowLatestEBookingText: "顯示最新電子訂艙",
    lbShowLatestEBookingTooltipText: "付貨人已將 OMS 訂艙儲存為「草稿」。請先要求付貨人提交訂艙，然後才接受最新的電子訂艙變更。",
    lbShowLatestContainerPODetailFromEBooking: "顯示電子訂艙的最新貨櫃／PO 詳情",
    lbRejectAll: "全部拒絕",
    lbAcceptAll: "全部接受",
    lblContinueSave: "繼續儲存",
    lblResetAndSave: "重設並儲存",
    lblUserType: "角色",
    lblLocation: "位置",
    lblLocationToolTip: "付貨人所在位置",
    lblReferred: "介紹人",
    lblReferredToolTip: "M+R 員工姓名",
    lblReferredOffice: "介紹人辦事處",
    lblReferredOfficeToolTip: "上述 M+R 員工所屬辦事處",
    lbUserID: "用戶 ID",
    lbLoinID: "登入 ID",
    lbLoinIDToolTip: "請輸入你的電郵地址作為登入 ID",
    msgLoinIDRequired: "請輸入登入 ID",
    lbPassword: "密碼",
    msgPasswordRequired: "請輸入密碼",
    msgStrongPWRequired: "密碼必須包含至少 8 個字符，包括數字、大寫字母及小寫字母。",
    msgPwNotMatch: "密碼不符",
    msgInvalidPassword: "密碼無效",
    msgInvalidCurrentPassword: "現有密碼無效",
    msgRepeatPassword: "密碼曾經使用，請使用新密碼。",
    msgForceChangePassword: "你的密碼已過期，請立即更改密碼。",
    msgActivateACSuccessfullly: "請登入以開始新體驗",
    lbConfirmPassword: "確認密碼",
    msgConfirmPasswordRequired: "請確認密碼",
    msgPasswordInconsistent: "兩次輸入的密碼不一致",
    lbFamilyName: "姓",
    msgFamilyNameRequired: "請輸入姓氏",
    lbGivenName: "名",
    msgGiveNameRequired: "請輸入名字",
    lbAddress: "地址",
    msgAddressRequired: "請輸入地址",
    lbZipPostal: "郵政編碼",
    lbCountryCode: "國家代碼",
    lbFDCountryCode: "FD 國家代碼",
    lbEmail: "電郵",
    msgEmailRequired: "請輸入電郵",
    msgEmailInvalid: "輸入的電郵格式不正確",
    lbPhoneNumber: "電話",
    msgPhoneNumberRequired: "請輸入電話號碼",
    msgCompanyRequired: "請輸入公司",
    lbFax: "傳真",
    msgFaxRequired: "請輸入傳真",
    lbCompany: "公司",
    lbPosition: "職位",
    lbDepartment: "部門",
    lbSalesCode: "銷售代碼",
    lbLanguage: "語言",
    msgLanguageRequired: "請輸入語言",
    lbProfile: "設定檔",
    msgProfileRequired: "請選擇設定檔",
    lbUserLevel: "用戶等級",
    lbRole: "角色",
    msgRoleRequired: "請輸入角色",
    lbPartyAccessType: "客戶存取類型",
    msgPartyAccessTypeRequired: "請輸入客戶存取類型",
    msgPartyGroupRequired: "請輸入客戶群組",
    lbTradelane: "貿易航線",
    lbAccessibleSalesCode: "可存取銷售代碼",
    lbAccessibleSalesCode_Tooltips: "如銷售員姓名前有斜號，即表示該銷售員／銷售代碼在系統中未生效。將未生效的銷售代碼新增為可存取銷售代碼時請留意。",
    msgLoginIdDuplicate: "登入 ID 已存在",
    msgEnterSISID: "如要註冊，請輸入現有的 SIS 登入名稱及密碼",
    msgSISIDVerified: "SIS 帳戶已驗證。請在下方輸入資料以註冊你的個人帳戶。",
    lbSISLoginID: "SIS 登入名稱",
    lbOPSLogin: "OPS 登入",
    lbOPSID: "OPS ID",
    msgInvalidSISLoginID: "SIS 登入名稱或密碼無效，請輸入有效的登入名稱及密碼",
    msgCannotMapUserProfiles: "無法以 SIS ID 對應用戶設定檔，請註冊不含 SIS ID 的新帳戶",
    msgLoginIDAleadyRegistered: "登入 ID 已註冊",
    msgDuplicateOPSUser: "同一 OPS 用戶已存在使用中的帳戶。",
    msgOPSLoginIdRequired: "請輸入 OPS ID",
    msgOPSOfficeRequired: "請選擇 OPS 辦事處",
    msgOPSIdOfficeNotInProfile: "請在設定檔輸入 OPS ID 及辦事處",
    msgListOPSIdOfficeNotInProfile: "OPS ID \"{{ops_user_id}}\"（辦事處 \"{{party_office_code}}\"）",
    msgProfileOPSIdNotInOPSIds: "請在 OPS ID 清單中輸入設定檔的 OPS ID 及辦事處",
    msgListProfileOPSIdNotInOPSIds: "OPS ID \"{{ops_user_id}}\"（辦事處 \"{{party_office_code}}\"）",
    msgSISLoginIDRequire: "請輸入 SIS 登入 ID",
    lbPageSize: "每頁顯示數量",
    btnSave: "儲存",
    btnRemindMeLater: "稍後提醒我",
    msgUpdatePassword: "請更新你的密碼",
    msgPasswordExpireInDays: "你的密碼將於 {{password_expire_in_days}} 天後過期。請更改密碼。",
    msgPasswordExpireSoon: "密碼即將過期",
    msgPasswordExpired: "你的密碼已過期。請更改密碼。",
    btnCancel: "取消",
    btnOk: "OK",
    btnApply: "套用",
    btnReset: "重設",
    btnDelete: "刪除",
    btnClose: "關閉",
    lbContainerSize: "貨櫃尺寸",
    msgContainerSizeRequired: "請選擇貨櫃尺寸",
    msgContainerQtyRequired: "請選擇貨櫃數量",
    lbQty: "數量",
    lbCargoReadyDate: "貨物完成日期",
    lbDepartureDate: "離港日期",
    lbArrivalDate: "到港日期",
    lbTransshipmentPort: "轉運港",
    lbDepartureFrom: "出發地",
    lbPOL: "裝貨港",
    msgPOLRequired: "請選擇起運港（POL）",
    msgPOLHBLRequired: "請在 HBL 輸入起運港（POL）",
    lbETD: "ETD",
    msgETDRequired: "請輸入 ETD",
    msgETDInvalid: "ETD 無效",
    lbPOD: "卸貨港",
    msgPODRequired: "請選擇卸貨港（POD）",
    msgPODHBLRequired: "請在 HBL 輸入卸貨港（POD）",
    lbETA: "ETA",
    msgETARequired: "請輸入 ETA",
    msgETAInvalid: "ETA 無效",
    lbMotherVesselVoyage: "母船航次",
    lbFeederVesselVoyage: "駁船航次",
    msgPortRequired: "請選擇轉運港",
    lbCarrier: "船公司",
    lbCopyFromSailingOption: "從船期選項複製",
    lbCopyFromSailingOptionTooltip: "選擇並套用來自船期選項的航次",
    lbCopyFromSailingScheduleOption: "從船期複製",
    lbCopyFromSailingScheduleTooltip: "選擇並套用來自船期維護及船期資料供應商的航次。輸入承運人代碼、承運人名稱、母船船名、母航次代碼、POL ETD 或 POD ETA 進行搜尋。",
    lbIsTBCSailing: "是否 TBC 航次",
    lbType: "類型",
    msgCarrierRequired: "請輸入承運人",
    lbColoader: "同載商",
    msgColoaderRequired: "請輸入同載商",
    lbPLD: "提貨地點",
    msgPLDRequired: "請選擇交貨地點（PLD）",
    msgPLDHBLRequired: "請在 HBL 輸入交貨地點（PLD）",
    msgShipModeRequired: "請選擇運輸方式",
    lbFD: "最終目的地",
    msgFDRequired: "請選擇最終目的地（FD）",
    msgFDHBLRequired: "請在 HBL 輸入最終目的地（FD）",
    msgFDCountryRequired: "請選擇最終目的地國家",
    msgInvalidCountryCode: "國家代碼無效",
    lbMainOffice: "主辦事處",
    msgUpdatePOLFromSailing: "你已選擇起運港為 {{sailing_pol_name}} 的航次選項。目前訂艙的 POL 為 {{so_pol_name}}。確定選擇此 {{sailing_pol_name}} 航次並將訂艙 POL 更新為 {{sailing_pol_name}}？請注意，如船期的 POL 與訂艙的 POL 不一致，訂艙將無法確認。",
    msgUpdatePODFromSailing: "你已選擇卸貨港為 {{sailing_pod_name}} 的航次選項。目前訂艙的 POD 為 {{so_pod_name}}。確定選擇此 {{sailing_pod_name}} 航次並將訂艙 POD 更新為 {{sailing_pod_name}}？請注意，如船期的 POD 與訂艙的 POD 不一致，訂艙將無法確認。",
    lbLegETD: "第 {{leg}} 段 ETD",
    lbLegVessel: "第 {{leg}} 段船名",
    lbLegVoyage: "第 {{leg}} 段航次代碼",
    lbLegServiceName: "第 {{leg}} 段服務名稱",
    lbLegServiceCode: "第 {{leg}} 段服務代碼",
    lbLegPort: "第 {{leg}} 段港口",
    lbCFS: "CFS (LCL)",
    lbCY: "CY",
    lbCyClosingDate: "CY 截止日期",
    lbVGM: "VGM",
    lbVgmCutOffDate: "VGM 截止日期",
    lbSI: "SI",
    lbSiCutOffDate: "SI 截止日期",
    lbItsCutOffDate: "ITS 截止日期",
    lbRoutes: "航線",
    lbRoute: "航線",
    lbServiceName: "服務名稱",
    lbServiceCode: "服務代碼",
    lbMotherServiceName: "母船服務名稱",
    lbMotherServiceCode: "母船服務代碼",
    msgServiceCodeRequired: "請輸入服務代碼",
    lbVessel: "船名",
    lbVesselName: "船名",
    lbVesselIMONumber: "船隻 IMO 編號",
    msgVesselNameRequired1: "請輸入船名",
    msgVesselNameRequired2: "請從轉運中選擇母船",
    lbVoyage: "航次",
    lbVoyageCode: "航次代碼",
    msgVoyageCodeRequired1: "請輸入航次",
    msgVoyageCodeRequired2: "請從轉運中選擇母船",
    lbVesselImoNumber: "IMO 編號",
    lbVesselOperator: "營運人",
    lbTransshipmentCode: "轉運港",
    lbUserProfile: "用戶設定檔",
    lbUserPassword: "用戶密碼",
    lbNewPassword: "新密碼",
    lbCurrentPassword: "現時密碼",
    lbConfirmNewPassword: "確認新密碼",
    lbContractType: "合約類別",
    lbContractNo: "合約編號",
    lbCarrierBookingNo: "船公司訂艙編號",
    lbCarrierBookingDate: "承運人訂艙日期",
    lbCarrierConfirmBookingDate: "船公司確認訂艙",
    //Azure 10976: carrier booking milestone dates
    lbCarrierSOReleased: "承運人SO已放",
    lbMRSOReleased: "M+R SO已放",
    lbSOReference: "S/O 參考編號",
    lbSOReferenceTooltip: "落貨紙的參考編號",
    lbSORefNil: "S/O 參考編號不適用",
    lbSORefNilTooltip: "如此訂艙不適用參考編號，請勾選此核取方塊",
    msgUpdatePwSuccessfully: "更新密碼成功",
    msgUpdatePwFail: "更新密碼失敗",
    msgUpdatedUserProfileSuccessfully: "更新用戶設定檔成功",
    msgUpdatUserProfileFail: "更新用戶設定檔失敗",
    msgUserProfileNotUnique: "設定檔類別必須唯一",
    msgUserProfileNotAssignedFuncRole: "請為每個設定檔指派至少 1 個系統功能角色",
    msgVirusScanning: "（病毒掃描中...）{{file_name}}",
    msgLoading: "載入中…",
    msgSaving: "儲存中…",
    errSaveUnknown: "無法儲存，原因不明。",
    msgSureToDelete: "確定刪除？",
    msgNoRecordFound: "沒有資料",
    msgNoRateRecordFound: "找不到運價記錄",
    msgRateApiError: "運價搜尋失敗。請重試。{{error_message}}",
    msgNoDashboardItem: "找不到儀表板項目。",
    msgLoadAutoSave: "發現一筆自動儲存記錄（儲存於 {{datetime}}），是否要載入？",
    msgAutoSaveLoaded: "已載入自動儲存",
    msgAutoSaveSaved: "訂艙已自動儲存",
    msgSureToLeave: "是否確定要離開？(tc)",
    msgSureToReset: "確定重設為預設設定？",
    lblSelectColumn: "請選擇欄位",
    lblColumnOption: "欄位選項",
    lblColumn: "欄位",
    msgColumnOptions: "最多可顯示 30 個欄位，可自行新增或移除欄位。如要更改欄位順序，請拖放欄位。",
    lblAddColumn: "新增欄位",
    errExportFailed: "無法匯出檔案。",
    errGetScheduleEmailFailed: "無法取得船期電郵。",
    lblFrom: "寄件人",
    lblTo: "收件人",
    lblMotherVessel: "母船",
    lblMotherVesselName: "母船船名",
    lblMotherVesselIMONumber: "母船 IMO 編號",
    lblMotherVoyageCode: "母航次代碼",
    msgMotherVesselRequired1: "請輸入母船航次",
    msgMotherVesselRequired2: "請選擇母船航次",
    lblTransshipmentCount: "轉運次數",
    lbMotherVesselLeg: "母船航段",
    colOffice: "辦事處",
    pnlRelatedSailingSchedule: "相關船期",
    pnlRelatedBookings: "相關訂艙",
    pnlRelatedConsol: "相關拼櫃",
    pnlSailingHistory: "船期歷史",
    msgChangeETDETAWarning: "你正在覆寫 ETD／ETA 並轉為人手船期。此航次將不再接受資料供應商／船公司的自動更新。請確保輸入的資料正確。",
    colFeederVessel: "駁船",
    colFeederVoyage: "駁船航次",
    colPLD: "交貨地點（PLD）",
    colPLDEta: "PLD ETA",
    msgConfirmCreateSailingSchedule: "已存在相同承運人、船隻、航次、POL 或 POD 的船期。是否繼續？",
    msgConfirmRelatedSailingSchedule: "所有相關訂艙的船期（包括截止日期）將會更新。確定繼續？如有需要，請諮詢相關操作團隊。",
    msgConfirmRelatedShipmentsAndConsol: "所有相關訂艙及拼櫃的船期（包括截止日期）將會更新。確定繼續？如有需要，請諮詢相關操作團隊。",
    colField: "欄位",
    colValue: "數值",
    lblVesselVoyage: "船隻航次",
    msgSubmitting: "提交中",
    msgSubmitForgotPwSuccessfully: "提交成功。將發送電郵以重設密碼。",
    msgSubmitForgotPwFail: "找不到記錄。",
    msgResetPwSuccessfully: "重設成功。",
    msgResetPwFail: "重設密碼失敗。",
    msgRecordNotLatest: "此記錄未更新。該記錄已被其他用戶更改。",
    msgRecordNotLatestOrSOHandleByOPS: "此貨件已被其他用戶更新、已取消，或已由 OPS 處理。",
    msgSOHandleByOPS: "此貨件已由 OPS 處理。",
    msgExceedMaxFileSize: "檔案超過每個檔案的大小上限（{{max_file_size}} MB）",
    msgIncorrectInput: "輸入不正確",
    msgSavedSuccess: "已儲存",
    lblColumnOptions: "欄位選項",
    lblRelatedSailingScheduleToolTip1: "相同母船及航次、從不同 POL 出發但到達相同 POD 的航次。例如母船先在鹽田裝貨，再在廈門裝貨，並於長灘卸貨。",
    lblRelatedSailingScheduleToolTip2: "或相同母船及航次、從相同 POL 出發但到達不同 POD 的航次。例如母船從鹽田出發，先於長灘卸貨，再於溫哥華卸貨。",
    msgTBCSailingWarning: "TBC 船期的 ETD 將於每月第 16 天自動更新至下月最後一天。",
    lblActive: "生效",
    lblInactive: "失效",
    msgVirusDetected: "檔案上傳失敗——偵測到懷疑病毒",
    lbSearchRate: "搜尋運價",
    lbPortOrDoorRate: "港口／門運價",
    lbPortOrDoorRateHover: "港到港：以起運地 = POL、目的地 = POD 搜尋運價\n港到門：以起運地 = POL、目的地 = PLD 搜尋運價\n門到港：以起運地 = POR、目的地 = POD 搜尋運價\n門到門：以起運地 = POR、目的地 = PLD 搜尋運價",
    lbContractInfo: "合約類型",
    lbRateSource: "運價來源",
    lbInfoForSearchRateOnly: "以下資料僅用於搜尋運價",
    lbRateMapDate: "運價日期",
    lbRateMapDateHover: "「航次 ETD 後 N 天」的運價日期用於搜尋適用的 Cargosphere／Local Deal 運價。\nOP 可根據承運人的要求，將運價日期調整為預計 ATD／ETB／CY 進閘日期。\n如屬美國航線，輸入 CY 進閘日期後，運價日期不可再修改，並相等於所有貨櫃中最晚的 CY 進閘日期。",
    lbPanelRateMapDateHover: "運價日期用於重新整理適用的 Cargosphere／Local Deal 運價。\nOP 可根據承運人的要求，將運價日期調整為預計 ATD／ETB／CY 進閘日期。\n如屬美國航線，輸入 CY 進閘日期後，運價日期不可再修改，並相等於所有貨櫃中最晚的 CY 進閘日期。",
    lbCopyFromRate: "複製自 ",
    lbPanelCopyFromRateHover: "選擇並套用來自現有 ",
    lbRateID: "運價 ID",
    lbPreviewAddCost: "預覽附加費用",
    lbShowHideMarkUp: "點擊此處以顯示／隱藏資料",
    lbPreviewAddCostTooltip: "開啟此按鈕以預覽套用「Add Cost to Summarized Rate List」範本後的總成本",
    msgWarningMasterFreightDiff: "所選合約 [{{contract_no}}] 的主運費 [{{contract_master_freight}}] 與輸入的主運費 [{{master_freight}}] 不同。確定繼續？",
    bl: {
        lbMasterBLSample: "主提單樣本",
        lbHeader: "表頭",
        lbStatus: "狀態",
        lbMainSO: "主要 SO",
        mainSOTooltip: "請選擇一個 SO 作為此主提單樣本的主要 SO。主要 SO 的資料將代表此主提單樣本。",
        msgChangeMainSO: "主要 SO 已變更，主提單樣本內的相關資料已隨之更新。請再次核對資料。",
        lbMasterBLHDOffice: "主提單處理辦事處",
        masterBLHDOfficeTooltip: "請選擇處理此主提單樣本的 M+R 辦事處。",
        lbCarrierMBLNo: "承運人 MBL#",
        lbMBLIssuedAt: "MBL 簽發地",
        lbMasterFreight: "主運費",
        lbMBLType: "主運輸單據",
        lbMasterPortDoorDelivery: "主提單港口／門交貨",
        lbFreightPayableAt: "運費支付地",
        lbUNDGNo: "UNDG No.",
        undgNoTooltip: "如此主提單須以 EDI 發出，請填寫 UNDG No.。",
        lbIMDGCode: "IMDG Code",
        imdgCodeTooltip: "如此主提單須以 EDI 發出，請填寫 IMDG Code。",
        lbShowFreight: "顯示運費",
        showFreightTooltip: "如此主提單須以 EDI 發出，請按實際需要勾選或取消勾選此核取方塊。如此主提單不會以 EDI 發出，請保持此核取方塊未勾選。",
        lbGetTelFax: "取得電話及傳真",
        getTelFaxTooltip: "如此主提單須以 EDI 發出，請按實際需要勾選或取消勾選此核取方塊。如此主提單不會以 EDI 發出，請保持此核取方塊未勾選。",
        lbRemarks: "備註",
        lbPOR: "收貨地點（POR）",
        lbPORNameMBL: "MBL 內收貨地點（POR）名稱",
        lbPORCountryNameMBL: "MBL 內 POR 國家／地區",
        lbPOL: "起運港（POL）",
        lbPOLNameMBL: "MBL 內起運港（POL）名稱",
        lbPOLCountryNameMBL: "MBL 內 POL 國家／地區",
        lbPOD: "卸貨港（POD）",
        lbPODNameMBL: "MBL 內卸貨港（POD）名稱",
        lbPODCountryNameMBL: "MBL 內 POD 國家／地區",
        lbPLD: "交貨地點（PLD）",
        lbPLDNameMBL: "MBL 內交貨地點（PLD）名稱",
        lbPLDCountryNameMBL: "MBL 內 PLD 國家／地區",
        lbMotherVessel: "母船",
        motherVesselTooltip: "如要更改 MBL 內的母船，請於所選主要 SO 的主要子提單文件中編輯。",
        lbMotherVesselIMONo: "母船 IMO 編號",
        lbMotherVoyage: "母航次",
        motherVoyageTooltip: "如要更改 MBL 內的母航次，請於所選主要 SO 的主要子提單文件中編輯。",
        lbVessel: "船名",
        vesselTooltip: "如要更改 MBL 內的船隻，請於所選主要 SO 的主要子提單文件中編輯。",
        lbVesselIMONo: "船隻 IMO 編號",
        lbVoyage: "航次",
        voyageTooltip: "如要更改 MBL 內的航次，請於所選主要 SO 的主要子提單文件中編輯。",
        lbShipper: "主提單付貨人",
        lbShipperToolTip: "付貨人是發出書面落貨紙的一方，不一定是貨物的供應商。\n\n如公司 A 發出落貨紙，要求簽發顯示公司 B 為付貨人的提單，必須提供公司 B 的書面同意；或公司 A 必須證明其獲公司 B 授權，得以公司 A 的名義運送貨物。",
        lbShipperCityToolTip: "請輸入城市以搜尋合適的城市。如找不到結果，請輸入國家及省份，例如 China Hebei、Viet Nam An Giang，然後便可從城市清單中選擇。\n所選城市將用於報關（如適用），並不會顯示於 HBL。",
        lbShipperRegionCountryCode: "國家／地區",
        lbContactPhone: "電話",
        lbFax: "傳真",
        lbConsignee: "主提單收貨人",
        lbConsigneeToolTip: "提單上必須按付貨人的指示顯示收貨人名稱及地址。收貨人不一定是貨件的實際收件人。例如貨件由 A 點運往 B 點，但提單上的收貨人可能位於 C 點。",
        lbConsigneeRegionCountryCode: "國家／地區",
        lbEORINoTooltip: "EORI# 是所有位於歐盟的「經濟運營者」均可取得的代碼。\nEORI# 屬強制性，適用於為進口貨物至歐盟報關或從歐盟出口的經濟運營者。\n非位於歐盟的經濟運營者，如將貨物進口至歐盟或從歐盟出口，亦必須申請 EORI#。\n非位於歐盟的經濟運營者，如其運入貨物僅途經歐盟過境，則不應申請 EORI#。\n非位於歐盟但向歐盟銷售貨物／出口貨物至歐盟的經濟運營者，不應申請 EORI#。\nEORI# 的格式應為 2 個字母，後接最多 15 個字母數字字符（例如：DE123456789012345）。\n由於 EORI# 不適用於瑞士、挪威及北愛爾蘭，請輸入識別編號（如當地稅務 ID）作為 EORI#。",
        lbSameAsConsigneeToolTip: "通知人會收到目的地收貨代理發出的裝運通知及／或到貨通知副本。通知人除接收資訊外，對貨件並無任何權利。\n\n如沒有指定通知人，慣例是在提單上顯示 \"SAME AS CONSIGNEE\"，而非留空。",
        lbSameAsConsignee: "與主提單收貨人相同",
        lbNotifyPartyToolTip: "通知人會收到目的地收貨代理發出的裝運通知及／或到貨通知副本。通知人除接收資訊外，對貨件並無任何權利。\n\n如沒有指定通知人，慣例是在提單上顯示 \"SAME AS CONSIGNEE\"，而非留空。",
        lbNotifyParty: "主提單通知人",
        lbCopyFromConsignee: "從主提單收貨人複製",
        msgShipperAddressRequired: "請輸入主提單付貨人地址",
        msgCityRequired: "請輸入城市",
        msgPhoneRequired: "請輸入電話",
        msgConsigneeRequired: "請選擇主提單收貨人",
        msgConsigneeAddressRequired: "請輸入收貨人地址",
        msgNotifyPartyRequired: "請選擇主提單通知人",
        msgWarningHBLNameNotAlign: "HBL 內的名稱（{{hbl_name}}）與所選的 {{party_type}} 代碼不符。請確保選擇正確的 {{party_type}} 代碼。",
        msgNotifyPartyAddressRequired: "請輸入通知人地址",
        smartSOSearchTooltip: "輸入 SO# 或 Job# 以搜尋。\n\n在此欄位輸入關鍵字後，你可按 'Tab' 鍵再按 'Enter' 鍵進行搜尋。",
        smartConsolSearchTooltip: "輸入 Consol# 或 Job# 以搜尋。\n\n在此欄位輸入關鍵字後，你可按 'Tab' 鍵再按 'Enter' 鍵進行搜尋。",
        lbAlsoNotify: "主提單亦通知人",
        msgAlsoNotifyPartyRequired: "請選擇主提單亦通知人",
        msgAlsoNotifyPartyAddressRequired: "請輸入亦通知人地址",
        smartSearchTooltip: "輸入 Master BL#、SO# 以搜尋。點擊「自訂篩選」以進行進階搜尋。\n\n在此欄位輸入關鍵字後，你可點擊「搜尋」或按 'Enter' 鍵進行搜尋。",
        msgSureToReactivateMasterBL: "確定復原主提單樣本？",
        miReactivateMasterBL: "復原主提單樣本",
        msgSureToCancelMasterBL: "確定取消主提單樣本？",
        msgMasterBLActionSuccess: "Master BL# {{master_bl_no}} 已成功 {{action}}。",
        miCancelMasterBL: "取消主提單樣本",
        lbPrintSample: "列印樣本",
        lbSendMasterSIEDI: "傳送 Master SI EDI",
        msgPOLNotAlign: "{{so_no}} 的起運港（POL）與主提單 POL 不一致",
        msgPODNotAlign: "{{so_no}} 的卸貨港（POD）與主提單 POD 不一致",
        msgPLDNotAlign: "{{so_no}} 的交貨地點（PLD）與主提單 PLD 不一致",
        msgMotherVesselNotAlign: "{{so_no}} 的母船與主提單母船不一致",
        msgMotherVoyageNotAlign: "{{so_no}} 的母航次與主提單母航次不一致",
        msgReleaseAgentNotAlign: "{{so_no}} 的放貨代理與主提單收貨人／通知人／亦通知人不一致",
        msgRemoveContainer: "請移除貨櫃 {{container_no}}",
        msgHDOfficeNotSupport: "「傳送 Master SI EDI」不適用於主提單處理辦事處 {{handling_office_party_code}}。",
        msgMissingContainerData: "貨櫃 {{container_no}} 缺少 {{field}}",
        msgMasterPartyDetailExceedCharLimit: "{{party_type}} 名稱及地址應在 35 個字符以內",
        msgMissingContainerPackageQtyGWCBM: "貨櫃 {{container_no}} 的 {{field}} 必須大於 0",
        msgMissingContainerPackageQtyUnit: "貨櫃 {{container_no}} 缺少包裝數量單位",
        msgMissingSOTotalPackageQtyGWCBM: "SO# {{so_no}} 的 {{field}} 必須大於 0",
        msgMissingSOTotalPackageQtyUnit: "SO# {{so_no}} 缺少包裝數量單位",
        msgCargoItemMissingDescOrMarksAndNo: "貨櫃 {{container_no}} 缺少 {{field}}",
        msgCargoItemDescExceedLineLimit: "貨櫃 {{container_no}} 的貨物描述應在 99 行以內",
        msgCargoItemMarksAndNoExceedLineLimit: "貨櫃 {{container_no}} 的嘜頭（Marks & No.）應在 50 行以內",
        msgCargoItemPackageQtyUnitLimit: "貨櫃貨物項目的包裝數量單位不可為 \"EACH\"（貨櫃 {{container_no}}）",
        msgMissingCarrierSoNo: "SO# {{so_no}} 缺少承運人 S/O 編號",
        msgNoMasterSIEDISetUp: "主提單處理辦事處 {{handling_office_party_code}} 及承運人 {{carrier_names}} 不允許傳送 Master SI EDI。",
        lbEDISent: "已傳送 EDI",
        lbSendEDI: "傳送 EDI",
        lbEDIFail: "EDI 失敗",
        lbEDINotSent: "未傳送 EDI",
        lbSendEDIButtonTitle: "Master SI EDI 最後傳送：{{titleForLastSent}}\nEDI 狀態：{{titleForLastEDI}}",
        lbSureToSend: "確定傳送？",
        lbTelexRelease: "待電放",
        telexReleaseTooltip: "在 MBL 樣本列印及 EDI 中加入電放（Telex Release）備註。",
        remarkTooltip: "如有需要，請輸入備註（例如：電放／聯絡電話／付款地點等），供承運人參考。",
    },
    menu: {
        Home: "主頁",
        Dashboard: "儀表板",
        Booking: "訂艙",
        "New e-Booking Pending": "新電子訂艙待處理",
        "Cancel e-Booking Pending": "取消電子訂艙待處理",
        "Amend e-Booking Pending": "修改電子訂艙待處理",
        "New Manual Booking Pending": "新人手訂艙待處理",
        "Booking Confirmed": "已確認訂艙",
        "Booking Approval": "訂艙審批",
        "Request For Approval": "要求審批",
        "Pending For Customer Approval": "待客戶審批",
        "Booking Rejected": "訂艙被拒",
        "Booking Advice": "訂艙通知",
        Setting: "設置",
        "User Profile": "用戶設定檔",
        "User Maintenance": "用戶維護",
        "Change Password": "更改密碼",
        Admin: "系統管理",
        "Party Maintenance": "相關方維護",
        "Party Group Maintenance": "客戶群組維護",
        "Sailing Schedule Maintenance": "船期維護",
        "Sign Out": "登出",
        ChangeUser: "變更用戶",
        "TradeLane Maintenance": "貿易航線維護",
        "AP Upload Document": "AP 上傳文件",
        "AP Pending Creation": "AP 待建立",
        "AP Pending Approval": "AP 待審批",
        "AP Released": "AP 已放行",
        "AP Pending Posting": "AP 待過帳",
        "AP Posted": "AP 已過帳",
        "AP Voided": "AP 已作廢",
        "AP Settled": "AP 已結算",
        "Account Payable (AP)": "應付帳款（AP）",
        "AR Pending Creation": "AR 待建立",
        "AR Pending Printing": "AR 待列印",
        "AR Pending Posting": "AR 待過帳",
        "AR Posted": "AR 已過帳",
        "AR Reversed": "AR 已沖銷",
        "AR Settled": "AR 已結算",
        "Account Receivable (AR)": "應收帳款（AR）",
        "Search Invoice": "搜尋發票",
        "Search AP": "搜尋 AP",
        "Create New AP": "建立新 AP",
        "AP Pending Preparation": "AP 待準備",
        "AP Pending Approval (1st level)": "AP 待審批（第一級）",
        "AP Pending Approval (2nd level)": "AP 待審批（第二級）",
        "AP Pending AP Ref to be entered": "AP 待輸入 AP Ref",
        "AR / AP Pending Account Period Close": "AR／AP 待會計期間結帳",
        "AR / AP Pending Account Period New Close": "AR／AP 待會計期間新結帳",
        "AP Reversed": "AP 已沖銷",
        "AP Account Period Closed": "AP 會計期間已結帳",
        "AP Unsettled": "AP 未結算",
        "Search AR": "搜尋 AR",
        "Create New AR": "建立新 AR",
        "AR Pending Preparation": "AR 待準備",
        "AR Account Period Closed": "AR 會計期間已結帳",
        "AR Unsettled": "AR 未結算",
        "Search AP / AR": "搜尋 AP／AR",
        Analytics: "分析",
        "Web Invoice GP": "Web Invoice GP",
        "Template Library": "範本庫",
        "New e-Booking": "New e-Booking",
        "Cancel e-Booking": "Cancel e-Booking",
        "New Manual Booking": "New Manual Booking",
    },
    so: {
        msgMainHouseDocIcon: "當 OPMS 指派 Job# 後，OPMS 會根據主要子提單文件，將貨件資料傳送至 SIS（其他應用程式／EDI 會使用 SIS 所收到的資料）。\n至於其他建立的子提單文件（如有），則不會傳送至 SIS，亦不會用於任何其他應用程式或 EDI。",
        msgPayableAtCountryCity: "除非付貨人明確要求顯示特定國家／地區／城市（即 \"Switzerland\" 或 \"Basel\" 等），否則運費支付地應保持為 'DESTINATION' 或 'ORIGIN'。",
        lbPayableAtCountryCity: "特定國家／地區／城市",
        msgCannotRemoveJob: "無法移除 Job#。請確保所有已開立發票已在 Web Invoice 中刪除及／或沖銷並過帳。",
        lbMainHouseDoc: "主要子提單文件",
        lbAMSSCAC: "AMS SCAC",
        lbAMSHBLNo: "AMS HBL No.",
        lbManualSailing: "人手船期",
        lbTBCSailing: "TBC 航次",
        lblHeader: "表頭",
        lblDetails: "詳細資料",
        lblISF: "ISF",
        lblFiling: "報關",
        lblDocumentUpload: "文件",
        lblDocumentUploadHistory: "文件上傳歷史",
        lbVGMEDIHistory: "VGM EDI 歷史",
        lblSI: "裝船指示",
        lblConfirmBooking: "確認訂艙",
        lblCarrierBooking: "承運人訂艙",
        lblShippingOrder: "落貨紙",
        lblShipper: "托運人",
        lblShipperToolTip: "付貨人是發出書面落貨紙的一方，不一定是貨物的供應商。\n\n如公司 A 發出落貨紙，要求簽發顯示公司 B 為付貨人的提單，必須提供公司 B 的書面同意；或公司 A 必須證明其獲公司 B 授權，得以公司 A 的名義運送貨物。",
        lblShipperCityToolTip: "請輸入城市以搜尋合適的城市。如找不到結果，請輸入國家及省份，例如 China Hebei、Viet Nam An Giang，然後便可從城市清單中選擇。\n所選城市將用於報關（如適用），並不會顯示於 HBL。",
        lblShipperRegionCountryCode: "國家／地區",
        lblShipperPlaceHolder: "付貨人（代碼）",
        msgShipperRequired: "請選擇付貨人！",
        msgShipperAddressRequired: "請輸入付貨人地址",
        msgShipperCityRequired: "請輸入付貨人城市",
        msgPhoneRequired: "請輸入電話",
        lbConsigneeNo: "收貨人編號",
        lbIORNo: "IOR#",
        lblCustomer: "客戶",
        lblCustomerTooltip: "請在此欄位選擇此訂艙的客戶（例如 Key Account）。如不適用，請輸入 'Other'。",
        lblCustomerPlaceHolder: "客戶（代碼）",
        msgCustomerRequired: "請選擇客戶！",
        lblConsignee: "收貨人",
        lblConsigneeToolTip: "提單上必須按付貨人的指示顯示收貨人名稱及地址。收貨人不一定是貨件的實際收件人。例如貨件由 A 點運往 B 點，但提單上的收貨人可能位於 C 點。",
        lblConsigneePlaceHolder: "收貨人（代碼）",
        msgConsigneeRequired: "請選擇收貨人！",
        msgConsigneeAddressRequired: "請輸入收貨人地址",
        msgConsigneeCityRequired: "請輸入收貨人城市",
        lblMOT: "運輸模式 (tc)",
        msgMOTRequired: "請選擇運輸模式！",
        lblMOTSea: "海運",
        lblMOTAir: "空運",
        lblMOTRail: "鐵路",
        lblService: "托運類別",
        msgServiceRequired: "請選擇服務！",
        lblServiceFCL: "FCL",
        lblServiceLCL: "LCL",
        lblServiceBulk: "散貨",
        lblPODDelivery: "港口／門到門交貨 (tc)",
        msgPODDeliveryRequired: "請選擇港口／門到門交貨 (tc)！",
        lblPODDeliveryP2p: "港到港",
        lblPODDeliveryP2d: "港到門",
        lblPODDeliveryD2p: "門到港",
        lblPODDeliveryD2d: "門到門",
        lblShipperReference: "付貨人參考編號",
        lblShipperReferenceTooltip: "付貨人的參考編號",
        lblShipperReferencePlaceHolder: "付貨人參考編號",
        lblAgentReference: "代理參考編號",
        lblAgentReferenceTooltip: "代理的參考編號",
        lblAgentReferencePlaceHolder: "代理參考編號",
        lblConsigneeReference: "收貨人參考編號",
        lblConsigneeReferenceTooltip: "收貨人的參考編號",
        lblConsigneeReferencePlaceHolder: "收貨人參考編號",
        lblMRReference: "M+R 參考編號",
        lblMRReferenceTooltip: "M+R 的參考編號",
        lblMRReferencePlaceHolder: "M+R 參考編號",
        lblBusinessType: "業務類型 (tc)",
        msgBusinessTypeRequired: "請選擇業務類型！",
        lblBusinessTypeNomination: "指定貨",
        lblBusinessTypeFreehand: "自攬貨",
        lblNominationAgent: "指定代理 (tc)",
        msgNominationAgentRequired: "請選擇指定代理！",
        lblAgentPlaceHolder: "代理（代碼）",
        lblReleaseAgent: "放貨代理 (tc)",
        msgReleaseAgentRequired: "請選擇放貨代理！",
        lblSalesman: "銷售員",
        msgSalesmanRequired: "請選擇銷售員",
        lbSOPInstruction: "SOP 指示（中文）",
        lbSOPInstructionContainerTitle: "貨櫃使用（中文）",
        lbSOPInstructionContainerContent: "使用 20' 需經客戶批准........",
        lbSOPInstructionRoutingTitle: "路線指示（中文）",
        lbSOPInstructionRoutingContent: "首選船公司為........",
        msgFillInRequiredFields: "請填寫所有必填欄位。",
        errSONotFound: "找不到落貨紙（{{sono}}）。(tc)",
        msgIncorrectCnsIORFormat: "請輸入 {{input_type}}，最大長度為 {{max_len}}",
        msgRateExternalContractTypeRequired: "請選擇外部合約類型",
        lblItemNo: "項目#",
        lbColor: "顏色",
        lbSubItemSize: "子項目／尺碼",
        lblRemark: "備註",
        lblItemQty: "項目數量",
        lblItemQtyUnit: "項目數量單位",
        lblPackageQty: "件數",
        lblPackageQtyUnit: "件數單位",
        lblGrossWeight: "毛重",
        lblNetWeight: "淨重",
        lblCBM: "立方米",
        lblDocumentType: "文件類型 (tc)",
        lblFile: "檔案 (tc)",
        lblFileSource: "檔案來源",
        lblDragOrUpload: "選擇／拖曳檔案 (tc)",
        lblTiming: "時間按客戶要求 (tc)",
        lblSubmitBooking: "提交訂艙",
        msgISFMustComplete: "對於出口至美國的貨物，請提供美國海關所需的 ISF 資料",
        lblSeller: "銷售商",
        lblManufacturer: "生產商",
        lblBuyer: "買方",
        lblShipTo: "運至",
        lblContainerStuffingLocation: "貨櫃裝箱地",
        lblConsolidator: "集運商",
        lblConsignmentRefNo: "貨件參考編號",
        lblGoodsContainerized: "貨物已貨櫃化",
        lblDelivery: "送貨地點",
        lblCityProvincePostal: "城市 / 省份 / 郵遞區號",
        lblCountryRegion: "國家 / 地區",
        lblEMANIFESTSpecialInstruction: "特別指示",
        lblISFCompanyName: "公司全稱",
        msgSellerNameRequired: "請輸入賣方名稱！",
        lblSellerPlaceHolder: "銷售商公司全稱",
        msgManufacturerNameRequired: "請輸入製造商名稱！",
        lblManufacturerNamePlaceHolder: "生產商公司全稱",
        msgBuyerNameRequired: "請輸入買方名稱！",
        lblBuyerPlaceHolder: "買方公司全稱",
        msgShipToNameRequired: "請輸入送貨對象名稱！",
        lblShipToPlaceHolder: "公司全稱 ",
        msgContainerStuffingLocationNameRequired: "請輸入裝櫃地點名稱！",
        lblContainerStuffingLocationPlaceHolder: "裝櫃地點",
        msglblConsolidatorNameRequired: "請輸入集運商名稱！",
        lbllblConsolidatorPlaceHolder: "集運商名稱",
        lblAddress1: "地址一",
        msgAddress1Required: "請輸入地址 1！",
        lblAddress1PlaceHolder: "地址一",
        lblAddress2: "地址二",
        msgAddress2Required: "請輸入地址 2！",
        lblAddress2PlaceHolder: "地址二",
        lbCityStateZip: "城市／州／郵遞區號",
        lbCityStateZipTooltip: "關於 STATE（州），\n如國家 = \"US\"：必填，長度 = 2\n如國家 = \"CA\"：必填，長度 = 2\n其他：選填\n\n關於 ZIP（註：格式中 9 代表數字，A 代表字母）\n如國家 = \"US\"：必填，2 種格式 — 5 位數字 \"99999\"（例如 18235），或 5 位數字＋連字符＋4 位數字 \"99999-9999\"（例如 18235-2239）\n如國家 = \"CA\"：必填，格式 \"A9A 9A9\"（例如 M4L 1V2）\n如國家 = \"CN\"：必填，6 位數字 \"999999\"（例如 200070）\n如國家 = \"JP\"：選填。如輸入 ZIP，格式為 3 位數字＋連字符＋4 位數字 \"999-9999\"（例如 100-0005）\n其他：選填，不作驗證",
        lblCity: "城市",
        lblState: "州",
        lblZip: "郵遞區號",
        lbEORINoTooltip: "EORI# 是所有位於歐盟的「經濟運營者」均可取得的代碼。\nEORI# 屬強制性，適用於為進口貨物至歐盟報關或從歐盟出口的經濟運營者。\n非位於歐盟的經濟運營者，如將貨物進口至歐盟或從歐盟出口，亦必須申請 EORI#。\n非位於歐盟的經濟運營者，如其運入貨物僅途經歐盟過境，則不應申請 EORI#。\n非位於歐盟但向歐盟銷售貨物／出口貨物至歐盟的經濟運營者，不應申請 EORI#。\nEORI# 的格式應為 2 個字母，後接最多 15 個字母數字字符（例如：DE123456789012345）。\n由於 EORI# 不適用於瑞士、挪威及北愛爾蘭，請輸入識別編號（如當地稅務 ID）作為 EORI#。",
        msgCityRequired: "請輸入城市！",
        msgStateRequired: "請輸入州，長度須為 2 個字符",
        msgIncorrectStateFormat: "州格式不正確",
        msgZipRequired: "請輸入郵遞區號",
        msgIncorrectZipFormat: "郵遞區號格式不正確",
        lblCityPlaceHolder: "城市",
        lblStatePlaceHolder: "州",
        lblZipPlaceHolder: "郵遞區號",
        lblCountry: "國家",
        msgCountryRequired: "請輸入國家！",
        lblCountryPlaceHolder: "國家",
        lblCountryOfOrigin: "原產國",
        msgCountryOfOriginRequired: "請輸入原產國！",
        lblCountryOfOriginPlaceHolder: "原產國",
        lblHTSCode: "HTS 代碼",
        msgHTSCodeRequired: "請輸入 HTS 代碼！",
        lblHTSCodePlaceHolder: "HTS 代碼",
        lblAddISFCompany: "新增{{type}}",
        lblRemoveISFCompany: "刪除{{type}}",
        lbModeOfTransportation: "運輸方式",
        lbBookingPOL: "訂艙 POL",
        lbBookingPOD: "訂艙 POD",
        lbBookingFD: "訂艙 FD",
        lbBookingDate: "訂艙日期",
        lbExpectedCargoReadyDate: "預計貨物備妥日期",
        lbETD: "ETD",
        lbPODETA: "POD ETA",
        lbFilingType: "報關類型",
        lbFilingTypeTooltip: "勾選下方核取方塊以選擇須向 Tradetech 及海關發送 EDI 的報關類型。請確保已指派 Job No. 以觸發 EDI",
        colSoNo: "SO#",
        colPoNo: "PO#",
        colModeOfTransport: "運輸方式",
        colBookingType: "訂艙類型",
        colDocumentUploaded: "已上傳文件",
        colHblNo: "HBL#",
        colJobNo: "Job#",
        colHandleBy: "處理人",
        colShipper: "付貨人",
        colShipperMaster: "付貨人（客戶主檔）",
        colConsignee: "收貨人",
        colConsigneeMaster: "收貨人（客戶主檔）",
        colConsigneeCode: "收貨人代碼",
        colReleaseAgent: "放貨代理",
        colNominationAgent: "指定代理",
        colBookingDate: "訂艙日期",
        colExFactoryDate: "出廠日期",
        colEarliestShipDate: "最早出貨日期",
        colLatestShipDate: "最晚出貨日期",
        colPortOfDischargeETA: "POD ETA",
        colBookingStatus: "訂艙狀態",
        colBookingStatusDate: "訂艙狀態日期",
        colStatusHistoryDate: "狀態歷史日期",
        colBookingApprovalStatus: "訂艙審批狀態",
        colBookingApprovalStatusDate: "訂艙審批日期",
        colCargoReadyDate: "貨物備妥日期",
        colITSCutOffDate: "ITS 截止日期",
        colContainerNo: "貨櫃編號",
        colContainerSize: "貨櫃尺寸",
        //Azure 10976: container details hover popup
        colConsolContainerSize: "集運貨櫃尺寸",
        colSealNo: "封條編號",
        colPackageQtyUnit: "件數單位",
        colContainerKgs: "貨櫃毛重（KG）",
        colContainerCBM: "貨櫃 CBM",
        colPOLineNo: "行號",
        colTransportModeCode: "運輸方式",
        colFD: "FD",
        colFDCountry: "FD 國家",
        colFDETA: "FD ETA",
        colBuyerName: "買家名稱",
        colSupplierCode: "供應商代碼",
        colDivision: "分部",
        colColor: "顏色",
        colEmptyPickupDate: "空櫃提取日期",
        colCFSReceivedDate: "CFS 收貨日期",
        colGateInPOLDate: "進閘（POL）日期",
        colLoadedPOLDate: "裝船（POL）日期",
        colDepartedPOLDate: "離港（POL）日期",
        colDischargedPODDate: "卸貨（POD）日期",
        colGateOutPODDate: "出閘（POD）日期",
        colArrivedPODDate: "到港（POD）日期",
        colEmptyReturnedDate: "空櫃歸還日期",
        colUpdatedETAPODDate: "更新 ETA（POD）日期",
        colUpdatedETAFDDate: "更新 ETA（FD）日期",
        colShipToName: "送貨對象",
        colDepartment: "部門",
        colBuyerReference: "買家參考編號",
        colSupplierReference: "供應商參考編號",
        colOtherReference: "其他參考編號",
        colBuyerContactEmail: "買家電郵",
        colITSReleaseDate: "ITS 放行日期",
        colIsPOHot: "急件",
        colFeederVessel: "駁船",
        colFeederVoyage: "駁船航次",
        colItemNo: "項目編號",
        colStyleDescription: "款式描述",
        colItemQty: "項目數量",
        colOrderQty: "訂單數量",
        colBalanceQty: "剩餘數量",
        colGW: "毛重（KG）",
        colNAgentCode: "指定代理代碼",
        colNotifyParty: "通知人",
        colNotifyPartyMaster: "通知人（客戶主檔）",
        colNotifyPartyCode: "通知人代碼",
        colHandlingOffice: "處理辦事處",
        colHandlingOfficeCode: "處理辦事處代碼",
        colPld: "PLD",
        colRAgentCode: "放貨代理代碼",
        colShipperCode: "付貨人代碼",
        colSalesmanCode: "銷售員代碼",
        colConsolidatable: "可拼櫃",
        colConsolNo: "Consol#",
        colCBM: "CBM",
        colCartonDimemsion: "紙箱尺寸",
        colKG: "KG",
        colPackageQty: "件數",
        colDangerousGoods: "是否危險品？",
        colPol: "POL",
        colEtd: "ETD",
        colPod: "POD",
        colPodEta: "POD ETA",
        colCustomer: "客戶",
        colTradelane: "貿易航線",
        colBookingCreatedBy: "訂艙建立者",
        colBookingUpdatedBy: "訂艙更新者",
        colBookingLastUpdatedTime: "訂艙最後更新時間",
        colBookingApprovalReason: "訂艙審批原因",
        colBookingApprovalRemarks: "訂艙審批備註",
        colBookingApprovalUpdatedBy: "訂艙審批更新者",
        colProposedSailingOption: "建議船期選項",
        colMotherVesselName: "船名",
        colMotherVoyageCode: "航次",
        colShipperReference: "付貨人參考編號",
        colConsigneeReference: "收貨人參考編號",
        colAgentReference: "代理參考編號",
        colMRReference: "M+R 參考編號",
        colLatestStatus: "最新狀態",
        colStatusHistory: "狀態歷史",
        colCarrier: "船公司",
        colCarrierService: "船公司服務",
        colBookingApprovalLastUpdatedByCustomer: "訂艙審批最後由客戶更新",
        colBookingApprovalLastUpdatedByMR: "訂艙審批最後由 M+R 更新",
        colSpaceStatus: "艙位狀態",
        colSailingDetails: "船期詳情",
        colSailingOptionNo: "船期選項編號",
        colVessel: "船名",
        colVoyage: "航次",
        colContractType: "合約類型",
        colContractNo: "合約編號",
        colCarrierBookingStatus: "船公司訂艙狀態",
        colStatusDate: "狀態日期",
        colBookingCondition: "訂艙條件",
        colUpdatedDatetime: "更新日期時間",
        colUpdatedBy: "更新者",
        colBookingJobAssignedBy: "Job# 分配者",
        colBookingHBLCreatedBy: "HBL# 建立者",
        miReactivateBooking: "恢復訂艙",
        msgSureToReactivateBooking: "是否確定要恢復此訂艙？",
        miAcknowledgeCancelBooking: "確認取消",
        msgSureToAcknowledgeCancelBooking: "是否確定確認此取消要求？",
        miRejectCancelBooking: "拒絕取消",
        msgSureToRejectCancelBooking: "是否確定拒絕此取消要求？",
        miCancelBooking: "取消訂艙",
        msgSureToCancelBooking: "是否確定取消此訂艙？",
        miCancelSI: "撤銷分單 SI",
        msgSureToCancelSI: "確定要撤銷分單 SI 嗎？",
        msgRemoveJobBeforeReverseSI: "撤銷分單 SI 前請先在 OPS 移除 Job/Order/Container",
        lblBookingApproval: "訂艙審批",
        lbHouseDoc: "分單",
        msgSOAdviceError: "由於有多於 1 個建議船期，狀態「Booking Advice」不適用於此訂艙。請選擇「Approved」作為審批狀態，並選擇一個船期選項作為已批准的船期。",
        colRemarks: "備註",
        colRemarkType: "備註類別",
        colVisibleTo: "可見對象",
        colApprovalStatus: "審批狀態",
        lbApprovalStatus: "審批狀態",
        lbApprovalStatusTooltip: "Request For Approval：M+R OP 用於向代理／收貨人提出審批請求\nBooking Advice：此訂艙無需審批\nPending Customer's Approval：客戶用以表示審批待處理\nApproved：客戶用以表示已給予審批\nRejected：客戶用以表示審批請求被拒絕",
        lbNewRemarks: "新備註",
        lbVisibleTo: "可見對象",
        lbReasons: "原因",
        cbSendEmailNotifyTo: "發送電郵通知予",
        msgAddBookingApprovalSuccess: "新增訂艙審批成功",
        msgAddBookingApprovalFail: "新增訂艙審批失敗",
        lbSONo: "SO#",
        lbHBLNo: "HBL#",
        lbTrader: "業務員",
        lbNotifyParty: "通知人",
        lbNotifyPartyToolTip: "通知人將收到目的地收貨代理發出的裝運通知及／或到貨通知副本。除作通知用途外，通知人對貨件並無任何權利。\n\n如未有指明通知人，慣例會在 BL 上顯示「SAME AS CONSIGNEE」而非留空。",
        lbSameAsConsignee: "與收貨人相同",
        lbSameAsConsigneeToolTip: "通知人將收到目的地收貨代理發出的裝運通知及／或到貨通知副本。除作通知用途外，通知人對貨件並無任何權利。\n\n如未有指明通知人，慣例會在 BL 上顯示「SAME AS CONSIGNEE」而非留空。",
        msgToOrderWarning: "警告：強烈不建議在 BL 上以「To Order [空白]」作為收貨人，因在文件遞送過程中一旦遺失「正本」將存在固有風險。請與付貨人商討以避免此指示。",
        lbHandlingOffice: "處理辦事處",
        msgHandlingOfficeRequired: "請選擇處理辦事處",
        lbContact: "聯絡人",
        lbContactPhone: "電話",
        lbPOR: "POR",
        lbPOL: "POL",
        lbPOD: "POD",
        lbPLD: "PLD",
        lbPOLEtd: "POL ETD",
        lbPLDEta: "PLD ETA",
        lbShipMode: "運輸模式",
        lbShipModeTooltip: "由卸貨港（POD）至交貨地（PLD）所使用的運輸模式",
        lbFD: "FD",
        lbFDEta: "FD ETA",
        lbPOAllowableETDrange: "PO 允許 ETD 範圍",
        lbSpaceStatus: "艙位狀態",
        msgSpaceStatusRequired: "請選擇艙位狀態",
        msgSpaceStatusSORelease: "艙位狀態必須為「Released SO」，方可執行「House SI Submitted」",
        msgSelectCarrierBookingRequired: "請選擇船公司訂艙",
        msgSelectNonTBCSailing: "當艙位狀態為 Released SO 時，請選擇非 TBC 的船期",
        msgSelectCarrierBooking: "當艙位狀態為 Released SO 時，請填寫已選記錄",
        msgCarrierSOReleaseDateRequired: "必須輸入船公司 SO 放艙日期",
        msgRejectReasonRequired: "必須輸入拒絕原因",
        msgCancelReasonRequired: "必須輸入取消原因",
        msgContractTypeRequired: "請選擇合約類型",
        lbSelectedSailingOption: "已選船期選項",
        msgSailingOptionRequired: "請選擇船期選項",
        lbRoutingTemplate: "路線範本",
        msgRoutingTemplateRequired: "請選擇路線範本",
        lbSelectedRecord: "已選記錄",
        lbCargoReadyDate: "貨物備妥日期",
        lbContractType: "合約類型",
        lbContractNo: "合約編號",
        msgInvalidEmail: "電郵無效",
        msgEmptyRemark: "請輸入備註詳情或關閉備註",
        msgFillRequire: "請填寫必填欄位",
        msgEmptyRemarkType: "請為 {{i}} 備註輸入新備註",
        msgUserContactEmailSuccess: "已成功刪除 {{email}}",
        msgUserContactEmailFail: "刪除 {{email}} 失敗",
        lbWarehouse: "倉庫（LCL）",
        lbWarehouseSONo: "倉庫 SO 編號",
        msgWarningEditBookingApproval: "進行訂艙審批前，請先儲存現有訂艙或取消編輯",
        msgWarningEditHouseDoc: "執行分單前，請先儲存現有的訂艙或取消編輯",
        msgDeleteISFProfileSuccess: "刪除成功",
        msgDeleteISFProfileFail: "刪除失敗",
        msgFillInRequiredTabFields: "請修訂已標示的頁籤",
        msgConfirmAcceptChangeMsg: "接受更改將取代所有貨櫃，而 PO 與貨櫃之間的所有分配將被刪除。是否確定繼續？",
        msgConfirmAcceptChangeMsg2: "接受變更將取代所有 EBooking 貨櫃，並刪除 PO 與貨櫃之間的所有分配，以及 HS Code 與貨櫃的分配。是否確定繼續？",
        colDefaultAgentCode: "代碼",
        colDefaultAgentName: "名稱",
        colDefaultAgentIsAutoFill: "預設",
        colDefaultAgentDescription: "描述",
        lblDefaultAgentConsigneeCode: "收貨人代碼",
        lblDefaultAgentCustomer: "客戶",
        lblDefaultNominationAgentCode: "相關指定代理代碼",
        lblDefaultReleaseAgentCode: "相關放貨代理代碼",
        polCfsClosingRequired: "請輸入 CFS！",
        polCyClosingRequired: "請輸入 CY！",
        polVgmClosingRequired: "請輸入 VGM！",
        polSiClosingRequired: "請輸入 SI！",
        msgSendEmailPopup: "訂艙編號 {{so_no}} 將被儲存。是否發送 BMS 訂艙電郵通知予付貨人、訂艙副本電郵及 M + R OP？",
        msgSendCancelEmailPopup: "訂艙編號 {{so_no}} 此前已獲確認並將被取消。是否向付貨人、訂艙副本電郵及 M+R OP 發送 BMS 訂艙電郵通知？",
        lbConfirmSendEmail: "是，儲存更改",
        lbConfirmNotSendEmail: "否，儲存更改",
        lbConfirmSendCancelEmail: "是，並取消訂艙",
        lbConfirmNotSendCancelEmail: "否，並取消訂艙",
        lblSOStatus: "狀態",
        pnlStatusHistory: "狀態歷史",
        colSOStatus: "狀態",
        colSOStatusAction: "動作",
        colSOStatusRemark: "備註",
        colSOStatusUser: "用戶",
        colSOStatusUpdatedTime: "更新時間",
        msgIncorrectExFactoryDate: "貨櫃# {{container_no}} 的出廠日期不可早於貨物備妥日期（{{cargo_ready_date}}）",
        msgMissingExFactoryDate: "請輸入貨櫃# {{container_no}} 的出廠日期",
        msgMissingSealNO: "請輸入貨櫃# {{container_no}} 的封條編號",
        msgMissingCarrierSONO: "請輸入貨櫃# {{container_no}} 的船公司訂艙編號",
        msgMissingPackageQTY: "請輸入貨櫃# {{container_no}} 的件數",
        msgExceedsGW: "貨櫃 #{{container_no}}：已分配毛重（{{allocatedGW}}）與貨櫃輸入毛重（{{containerGW}}）之差不可超過 1",
        msgExceedsCBM: "貨櫃 #{{container_no}}：已分配 CBM（{{allocatedCBM}}）與貨櫃輸入 CBM（{{containerCBM}}）之差不可超過 1",
        msgExceedsGWWarning: "貨櫃 #{{container_no}}：已分配 GW（{{allocatedGW}}）與貨櫃輸入 GW（{{containerGW}}）之間的差異超過 1",
        msgExceedsCBMWarning: "貨櫃 #{{container_no}}：已分配 CBM（{{allocatedCBM}}）與貨櫃輸入 CBM（{{containerCBM}}）之間的差異超過 1",
        msgPOAlloExceedsQty: "PO#{{po_no}} 項目#{{item_no}} 的 {{field_name}} 於貨櫃明細為 {{allocated_qty}}{{unit}}，但 PO 明細只有 {{qty}}{{unit}}。",
        msgHSPkgNotAlign: "貨櫃# {{container_no}}：已分配的 HS / HTS Code 總件數（{{allocatedHSPkg}}）與貨櫃（{{containerPkg}}）不一致。",
        msgHSGWNotAlign: "貨櫃# {{container_no}}：已分配的 HS / HTS Code 總毛重 (KG)（{{allocatedHSGW}}）與貨櫃（{{containerGW}}）不一致。",
        msgHSCBMNotAlign: "貨櫃# {{container_no}}：已分配的 HS / HTS Code 總 CBM（{{allocatedHSCBM}}）與貨櫃（{{containerCBM}}）不一致。",
        msgISFHSWrongFormat: "貨櫃# {{container_no}}：ISF 訂艙／拼箱的 HS / HTS code 必須為 10 位數字。",
        msgENSHSWrongFormat: "貨櫃# {{container_no}}：ENS 訂艙／拼箱的 HS / HTS code 必須為 6 位數字。",
        msgHSWrongFormat: "貨櫃# {{container_no}}：HS / HTS code 必須為 6 至 14 位數字（含）。",
        msgResendEmailSuccess: "已成功以電郵重發 S/O 單",
        lbCopyToMenufacturer: "複製至製造商",
        lbCopyToContainerStuffingLocation: "複製至裝櫃地點",
        lbCopyToShipTo: "複製至送貨對象",
        lbCopyFromConsignee: "從收貨人複製",
        lbCopyToConsolidator: "複製至集運商",
        lbShowFullHDOffice: "顯示全部處理辦事處列表",
        msgLCLContainerAmountNotPass: "貨櫃行 [#] 的「件數」、「G.W. (KG)」及「CBM」不應同時為零。如此 3 個欄位均為零，請刪除此貨櫃行以儲存變更。",
        msgETDLaterThanCargoReadyDate: "ETD 應晚於貨物備妥日期。請檢查並修訂 ETD 及／或貨物備妥日期",
        msgCYGateInDateEarlierThanPOL: "CY 進場日期必須等於或早於 ETD。",
        msgCFSRecvDateEarlierThanPOL: "CFS 收貨日期必須等於或早於 ETD。",
        msgCYGateInDateEarlierThanCFSRecvDate: "CFS 收貨日期必須等於或早於 CY 進場日期（同一貨櫃內）。",
        msgETDMoreThan14Days: "ETD 距貨物備妥日期超過 14 天。請檢查 ETD 及貨物備妥日期。點擊「確定」以繼續",
        msgContactPersonRequired: "請輸入聯絡人",
        msgContactEmailRequired: "請輸入聯絡電郵",
        msgNotifyPartyRequired: "請選擇通知人",
        msgNotifyPartyAddressRequired: "請輸入通知人地址",
        msgNotifyPartyCityRequired: "請輸入通知人城市",
        msgPORRequired: "請選擇收貨港（POR）",
        msgPORHBLRequired: "請在 HBL 中輸入收貨地（POR）",
        msgTotalPkgQtyRequired: "請輸入總件數",
        msgPkgUnitRequired: "請輸入件數單位",
        msgTotalCBMRequired: "請輸入總 CBM",
        msgTotalKGRequired: "請輸入總 KG",
        msgMarksAndNoRequired: "請輸入嘜頭",
        msgGoodsDescRequired: "請輸入貨物描述",
        msgCommodityRequired: "請選擇貨物品類",
        msgDangerousGoodsRequired: "請選擇是否含有危險品",
        msgUNNoRequired: "請輸入 UN Number",
        msgOtherCommodityRequired: "請填寫其他貨物品類",
        msgCargoReadyDateRequired: "請選擇貨物備妥日期",
        msgIncotermsRequired: "請選擇 Incoterms",
        msgIncotermsLocaionRequired: "請輸入 Incoterms 地點",
        msgIncotermsLocaionNotAlign: "Incoterms 地點似乎與路線地點不一致。",
        msgIncotermsLocaionNotAlign2: "Incoterms 地點似乎與路線地點不一致。選擇「是」後，系統將不再提醒，直至 Incoterms 或 Incoterms 地點有所變更。",
        msgFreightRequired: "請選擇到付或預付",
        msgPrepaidUptoRequired: "請輸入預付至",
        msgPrepaidUptoHBLRequired: "請在 HBL 中輸入預付至名稱",
        lbNoOfOriginal: "正本份數",
        lbTransportDoc: "運輸單據",
        lbTransportDocTooltip: "當在「分單」工作區指派了主分單時，此欄位即指主分單的類型。\n要更新運輸單據，請更新主分單的類型。",
        msgTransDocRequired: "請選擇運輸單據",
        msgNoOfOriginalRequired: "請輸入正本份數",
        msgHBLOfficeRequired: "請選擇 HBL 簽發辦事處",
        lblConsolidatable: "可拼箱",
        msgConsolidatableRequired: "請選擇此貨件是否可拼箱",
        lblConsolidatableTooltip: "是－計劃建立拼箱\n否－不會拼箱",
        lbAllowSwitchHouseDoc: "允許轉換分單",
        msgNotAllowLCLContainer: "由於服務並非 LCL，請在「詳情」分頁的貨櫃貨物部分移除貨櫃尺寸「LCL」",
        msgBookingActionSuccess: "訂艙編號 {{sono}} 已成功{{action}}。{{send_email}}",
        msgHBLDrafted: "HBL 已草擬",
        msgHBLPrinted: "HBL 已列印",
        msgSendEmailSuccess: "電郵通知已成功發送至付貨人、訂艙副本電郵地址及 OP。",
        autoUpdateTooltip: "當此船期的截止日期（來自船公司）有任何變更時，自動重新計算並更新截止日期（給付貨人）。",
        msgTransDocNoOfOriginalNotMatch: "運輸單據與正本份數不相符。請修改其中一個欄位。",
        autoUpdatePLDFDTooltip: "當此船期的 POD ETA 有任何變更時，自動重新計算並更新 PLD ETA 及 FD ETA。",
        lbToOrder: "憑指示",
        lbToOrderToolTip: "如 BL 以「TO ORDER OF [收貨人名稱]」為抬頭，收貨人可背書 BL 並將 BL 所代表貨物的權利轉讓予他人，實質上顯示新的收貨人。此做法一般用於由信用證（Letter of Credit）規管的貨件，即信用證要求 BL 以「TO ORDER OF [銀行 XYZ]」簽發。\n\n強烈不建議在 BL 上以「To Order [空白]」作為收貨人，因在文件遞送過程中一旦遺失「正本」將存在固有風險。",
        lbSameAsShipment: "與貨件相同",
        msgMissingTypeOfEntry: "請選擇 {{type}} 報關類型",
        msgSelectSailingSchedule: "請從「訂艙建議船期」中選擇",
        msgSelectRate: "請選擇一個運價以作審批。如有任何疑問，請聯絡 BMS 支援。",
        msgMissingLCLContainer: "LCL 服務必須至少有 1 個 LCL 貨櫃尺寸",
        msgMissingField: "請輸入以下欄位",
        msgPLDETARequired: "請選擇 PLD ETA",
        msgInvalidPLDETA: "PLD ETA 必須晚於或等於 POD ETA，且早於或等於 FD ETA",
        msgInvalidRateContainerHeader: "所選運價選項的貨櫃尺寸與訂艙詳情不同。請修改訂艙詳情中的貨櫃尺寸，或為此貨櫃尺寸選擇其他運價。",
        msgInvalidRateContainerContent: "{{type}}：{{container_sizes_content}}",
        msgInvalidRateContainerContent2: "運價 {{rate_container_sizes_content}}",
        msgInvalidRate: "所選船期選項中的運價無效。請重新整理或移除該運價後再試。",
        msgMissingRateContainerSelect: "請為至少一個貨櫃尺寸添加運價。",
        msgFDETARequired: "請選擇 FD ETA",
        msgInvalidFDETA: "FD ETA 必須晚於或等於 POD ETA 及 PLD ETA",
        msgMobileSiteNotFound: "請在配置中設定流動網站",
        msgInvalidUser: "無效用戶。請重新登入後再試。",
        msgAddTokenFail: "新增 Token 失敗。請再試一次。",
        viewShipmentStatus: "點擊以查看貨件狀態。",
        viewSailingScheduleDetails: "點擊以查看船期詳情。",
        msgSONotExistsInMobile: "貨件狀態尚未提供",
        lbIncludeFullHistory: "包含完整歷史",
        lbIncludeVessel: "包含船名",
        lbIncludePricing: "包含定價",
        lbIncludeRates: "包含運價",
        lbSendEmailToTooltip: "預設情況下，系統會根據收件人本身的偏好，自動向收件人發送載有所有相關通訊的每日摘要。勾選此選項後，系統將額外發送即時電郵，特別就此通訊提醒收件人。請僅在需要特別關注時才勾選此選項！",
        lbIncludeFullHistoryTooltip: "勾選以在此即時電郵通知中包含完整審批通訊歷史。請同時勾選並選擇正確的「可見對象」。",
        lbIncludePricingTooltip: "勾選以在此即時電郵通知中包含「定價」備註。選擇此選項時請格外小心，避免不當洩露機密資料！",
        lbVisibleToConfigTooltip: "勾選以在此即時電郵通知中包含相關備註。選擇此選項時請格外小心，避免不當洩露機密資料。",
        lbIncludeVesselTooltip: "勾選以在此即時電郵通知中包含船名。如未勾選「包含船名」，船名將不包括在內。",
        lbIncludeRatesTooltip: "勾選以在此即時電郵通知中包含每櫃總運價。選擇此選項時請格外小心，避免不當洩露機密資料！",
        msgDelContainerInSI: "請在裝運指示中刪除貨櫃。",
        smartSearchTooltip: "輸入 SO#、PO#、HBL#、Job# 或收貨人以進行搜尋。點擊「自訂篩選」可進行進階搜尋。\n\n在此欄位輸入關鍵字後，您可點擊「搜尋」或按「Enter」鍵執行搜尋。",
        lbTEU: "TEU",
        lbSailingSelectedInBookings: "已在訂艙中選用的船期",
        lbSailingSelectedInBookingsHover: "開啟此選項以僅搜尋其他訂艙已使用的船期。",
        msgRestorePrevSearchCriteria: "已還原上一次的搜尋條件。",
        msgEmptyPartyCode: "{{party_type}} 代碼為空，確認訂艙或提交 SI 前請輸入 {{party_type}} 代碼",
        msgPartyStatusNotActive: "{{party_type}} 狀態未啟用，確認訂艙或提交 SI 前請啟用 {{party_type}} 狀態",
        msgEmptyPartyCodeForNonMainHosueDoc: "{{party_type}} 代碼為空，請輸入 {{party_type}} 代碼。",
        msgPartyStatusNotActiveForNonMainHosueDoc: "{{party_type}} 狀態未啟用，請啟用 {{party_type}} 狀態。",
        msgWarnTBCContainers: "{{container_no}} 臨時貨櫃編號，貨櫃編號可用時請在 BMS 中更新。",
        lbToBeTelexRelease: "待電放",
        lbMasterFreight: "總單運費",
        lbMasterFreightTooltip: "船公司／協載商運費",
        msgMasterFreightRequired: "請選擇總單運費",
        lbMasterFreightPlaceholder: "選擇總單運費",
        lbCarrierMBLNo: "船公司 MBL 編號",
        lbCarrierMBLNoPlaceholder: "輸入船公司 MBL 編號",
        msgCarrierMBLNoRequired: "請輸入船公司 MBL 編號",
        lbOceanFreightRemarks: "海運運費備註",
        lbColoaderBLNo: "協載商 BL 編號",
        lbColoaderBLNoPlaceholder: "輸入協載商 BL 編號",
        msgMissingPONO: "請輸入 PO#",
        lbSearchSailing: "搜尋船期",
        lbCreateSailing: "建立手動船期",
        lbSearchRate: "搜尋運價",
        lbCreateRate: "建立手動運價",
        lbExternalContractType: "外部合約類型",
        lbExternalContractNo: "外部合約編號",
        lbInternalContractType: "內部合約類型",
        lbInternalContractNo: "內部合約編號",
        lbInternalContract: "內部合約",
        lbInternalContractTooltip: "當我們與船公司簽訂的內部合約類型，與我們告知代理／代理告知收貨人的外部合約類型不同時，請開啟此選項。「內部合約類型／編號」僅 M+R 內部用戶可見",
        msgWarningHBLNameNotAlign: "HBL 中的名稱（{{hbl_name}}）與所選的 {{party_type}} 代碼不一致。請確保選擇正確的 {{party_type}} 代碼。",
        lbDisposalOfCns: "由收貨人處置",
        lbForwardToCns: "轉交收貨人",
        lbPrecarriageBy: "前段運輸由",
        lbOceanVessel: "海運船名",
        lbPlaceOfReceipt: "收貨地",
        lbPortOfLoading: "起運港",
        lbPortOfDischarge: "卸貨港",
        lbPlaceOfDelivery: "交貨地",
        lbFreightPayableAt: "運費支付地",
        lbNoOfOriginalBL: "正本提單份數",
        lbMarksAndNo: "嘜頭",
        lbNoAndKindOfPackages: "件數及包裝種類",
        lbGoodsDescription: "貨物描述",
        lbVolume: "體積／尺碼",
        lbUpto: "預付至",
        lbShippedOnBoard: "已裝船",
        lbCargoReceived: "已收貨",
        lbIntendedVesselRouting: "預定船名及路線",
        msgWarningRemarkExceedMaxImageSize: "圖片大小不能超過 {{maxImageSize}} MB。",
        msgWarningRemarkExceedMaxHTMLTextSize: "總大小不能超過 {{maxHTMLTextSize}} MB。",
        msgFinalWarningRemarkExceedMaxHTMLTextSize: "備註總大小（目前：{{currentHTMLTextSize}}MB）不能超過 {{maxHTMLTextSize}} MB。請移除圖片。",
        msgRemarkExceedMaxTextLength: "備註總長度（目前：{{currentTextLength}} 字）不能超過 {{maxTextLength}} 字。",
        phRemarkbraftEditor: "請在此輸入備註或貼上截圖。",
        msgMissingENSBuyerName: "缺少 ENS 買方名稱",
        msgMissingENSBuyerAddress1: "缺少 ENS 買方地址 1",
        msgMissingENSBuyerCity: "缺少 ENS 買方城市",
        msgMissingENSBuyerCountry: "缺少 ENS 買方國家／地區",
        msgMissingENSBuyerPhone: "缺少 ENS 買方電話",
        msgMissingENSBuyerEmail: "缺少 ENS 買方電郵",
        msgMissingENSBuyerEORINo: "缺少 ENS 買方 EORI 編號",
        msgMissingENSSellerName: "缺少 ENS 賣方名稱",
        msgMissingENSSellerAddress1: "缺少 ENS 賣方地址 1",
        msgMissingENSSellerCity: "缺少 ENS 賣方城市",
        msgMissingENSSellerCountry: "缺少 ENS 賣方國家／地區",
        msgMissingENSSellerPhone: "缺少 ENS 賣方電話",
        msgMissingENSSellerEmail: "缺少 ENS 賣方電郵",
        msgMissingENSSellerEORINo: "缺少 ENS 賣方 EORI 編號",
        msgConfirmHideAddress: "預設情況下，分單應始終包含「付貨人地址」及「收貨人地址」。\n\n如付貨人強烈拒絕在分單上顯示「付貨人地址」及／或「收貨人地址」，M+R 應要求付貨人簽署賠償保證書（LOI），並在書中提供其完整公司名稱及地址。是否接受付貨人的要求應由 M+R 經理決定。\n\n請點擊「確定」以確認已閱讀此警告。要應用此變更，您需要列印新的草稿／正式分單，才能從分單列印本中移除「地址」。",
        lblBookingConditionToolTip: "Protected：艙位已確認，不太可能甩櫃。\nNormal：船公司沒有指明艙位會否甩櫃或受保護。\nSubject to Roll：如發生甩櫃，OP 應在原船期的船公司訂艙中選擇「Subject to Roll」，並將該船公司訂艙結轉至新船期。",
        lblCopyFromSONo: "從 SO# 複製",
        msgCopyFromSONoRequired: "請輸入 SO# 以搜尋船公司訂艙",
        lblCopyFromConsol: "從 Consol# 複製",
        msgCopyFromConsolRequired: "請輸入 Consol# 以搜尋船公司訂艙",
        lblCopyCarrierBookingRecord: "複製船公司訂艙",
        msgInvalidBuyerEORI: "買方 EORI 編號格式不正確",
        msgInvalidSellerEORI: "賣方 EORI 編號格式不正確",
        msgInvalidConsigneeEORI: "收貨人 EORI 編號格式不正確",
        msgInvalidPhone: "用於 ENS 申報的 {{party_name}} 電話號碼－請包含以「+」開頭的國家代碼，不含空格及符號。例如中國（+86）電話號碼為 +861234567890。",
        lbProjectedETD: "預計 ETD",
        msgProjectedETD: "如有緊急需要（例如：必須立即開出發票），您可為 TBC 船期表貨件分配 Job#／HBL#。「預計 ETD」將用於確定 Job# 上的作業月份及 HBL# 上的流水序號。",
        msgProjectedETD2: "輸入 TBC 船期表的預計 ETD，以覆寫 TBC 船期表的 ETD（下月最後一天）",
        msgInvalidTickFilingType: "請先在分單工作區／Consol Plan 中指派 Job#",
        msgWarningUploadFiles: "請為文件類型 {{document_Type}} 上傳檔案",
        msgIsf10_2: "請確保 S/O 收貨人為 ISF 收貨人，且已為 ISF（10+2）勾選 AMS 或「AMS 由第三方處理」",
        msgMasterParties: "總單付貨人：{{master_shipper_name}}\n總單收貨人：{{master_consignee_name}}\n總單通知人：{{master_notify_name}}\n總單另通知：{{master_also_notify_name}}",
        lbMasterShipper: "總單付貨人",
        lbMasterConsignee: "總單收貨人",
        lbMasterNotifyParty: "總單通知人",
        lbMasterAlsoNotify: "總單另通知",
        msgMasterShipperRequired: "請選擇總單付貨人",
        msgMasterConsigneeRequired: "請選擇總單收貨人",
        msgMasterNotifyRequired: "請選擇總單通知人",
        msgMovementNotAlign: "此訂艙中發現多個貨櫃動態",
        tipsShipmentHotOutlined: "點擊此圖示以將此 S/O 標記為熱門貨件",
        tipsShipmentHotFilled: "點擊此圖示以將此 S/O 從熱門貨件中移除",
        colIsHot: "熱門",
        lblISFRemark: "ISF 備註",
        msgContainerStuffingLocationRequired: "請輸入裝櫃地點，或從製造商點擊「複製到裝櫃地點」",
        msgConsolidatorRequired: "請輸入集運商，或從裝櫃地點點擊「複製到集運商」",
        msgRequiredInEnglish: "請以英文填寫所有必填欄位",
        msgPartyFieldInEnglish: "請輸入英文 {{party_field}} 名稱",
        msgAddressInEnglish1: "請輸入英文地址 1",
        msgAddressInEnglish2: "請輸入英文地址 2",
        msgCityInEnglish: "請輸入英文城市",
        msgEoriInEnglish: "請以英文／數字／符號輸入 EORI 編號",
        colReference: "Reference",
    },
    lbSOColorDesc: {
        newEBookgingRed: "待確認超過 18 小時",
        newEBookgingYellow: "待確認超過 8 小時",
        newEBookgingGreen: "待確認",
        amendEBookgingRed: "待確認超過 18 小時",
        amendEBookgingYellow: "待確認超過 8 小時",
        amendEBookgingGreen: "待確認",
        cancelEBookgingRed: "待認收超過 18 小時",
        cancelEBookgingYellow: "待認收超過 8 小時",
        cancelEBookgingGreen: "待認收",
        newManualBookgingRed: "待認收超過 18 小時",
        newManualBookgingYellow: "待認收超過 8 小時",
        newManualBookgingGreen: "待認收",
        confirmBookingRed: "已確認訂艙待訂艙審批超過 2 天",
        confirmBookingYellow: "已確認訂艙待訂艙審批超過 1 天",
        confirmBookingGreen: "已確認訂艙待訂艙審批",
        pendingSIRed: "待提交 SI 超過 7 天",
        pendingSIYellow: "待提交 SI 超過 5 天",
        pendingSIGreen: "待提交 SI",
        requestForApprovalRed: "待提出審批超過 2 天",
        requestForApprovalYellow: "待提出審批超過 1 天",
        requestForApprovalGreen: "待提出審批",
        pendingForCustomerApprovalRed: "待取得客戶審批超過 2 天",
        pendingForCustomerApprovalYellow: "待取得客戶審批超過 1 天",
        pendingForCustomerApprovalGreen: "待取得客戶審批",
        bookingRejectedRed: "訂艙被拒超過 1 天",
        bookingRejectedYellow: "訂艙被拒",
        bookingApprovedGreen: "訂艙已批准",
    },
    lbConsolColorDesc: {
        newConsolidationRed: "待確認超過 18 小時",
        newConsolidationYellow: "待確認超過 8 小時",
        newConsolidationGreen: "待確認",
        amendConsolidationRed: "待確認超過 18 小時",
        amendConsolidationYellow: "待確認超過 8 小時",
        amendConsolidationGreen: "待確認",
        cancelConsolidationRed: "待確認收悉超過 18 小時",
        cancelConsolidationYellow: "待確認收悉超過 8 小時",
        cancelConsolidationGreen: "待確認收悉",
        newManualConsolidationRed: "待確認收悉超過 18 小時",
        newManualConsolidationYellow: "待確認收悉超過 8 小時",
        newManualConsolidationGreen: "待確認收悉",
        confirmConsolidationRed: "已確認拼箱待拼箱審批超過 2 天",
        confirmConsolidationYellow: "已確認拼箱待拼箱審批超過 1 天",
        confirmConsolidationGreen: "已確認拼箱待拼箱審批",
        requestForApprovalRed: "待提出審批請求超過 2 天",
        requestForApprovalYellow: "待提出審批請求超過 1 天",
        requestForApprovalGreen: "待提出審批請求",
        pendingForCustomerApprovalRed: "待客戶審批超過 2 天",
        pendingForCustomerApprovalYellow: "待客戶審批超過 1 天",
        pendingForCustomerApprovalGreen: "待客戶審批",
        consolidationRejectedRed: "拼箱被拒絕超過 1 天",
        consolidationRejectedYellow: "拼箱被拒絕",
        amendedBookingPendingRed: "已修改訂艙待處理超過 2 天",
        amendedBookingPendingYellow: "已修改訂艙待處理超過 1 天",
        amendedBookingPendingGreen: "已修改訂艙待處理",
        loadPlanPendingAllocationRed: "ETD 前少於 3 天仍待分配",
        loadPlanPendingAllocationYellow: "ETD 前少於 7 天仍待分配",
        loadPlanPendingAllocationGreen: "待分配",
        consolidationApprovedGreen: "拼箱已批准",
    },
    lbParty: "相關方",
    lbPartyID: "相關方 ID",
    lbPartyCode: "相關方代碼",
    lbOtherCode: "其他代碼",
    lbPartyType: "相關方類別",
    lbPartyTypeRequired: "請選擇相關方類型",
    lbPartyRequired: "請輸入相關方",
    lbContactPerson: "聯絡人",
    lbCity: "城市",
    lbState: "州",
    lbShortName: "簡稱",
    lbFullName: "全名",
    lbStatus: "狀態",
    msgStatusRequired: "請選擇狀態",
    msgCostCenterCodeRequired: "請輸入成本中心代碼",
    msgUpdatePartySuccess: "更新相關方成功",
    msgUpdatePartyFail: "更新相關方失敗",
    lbTradeLaneID: "貿易航線 ID",
    lbTradeLaneName: "貿易航線名稱",
    lbTradeLaneType: "貿易航線類型",
    lbCountryUnlocode: "POD 國家／POL 國家",
    lbOfficeCode: "辦事處代碼",
    lbAccountCode: "帳戶代碼",
    lbEffectiveDate: "生效日期",
    lbTradeLane: "貿易航線",
    lbCustomerTypeID: "客戶類別 ID",
    lbCustomerCode: "客戶編號",
    warehouse: {
        lblWarehouseCode: "倉庫代碼",
        msgWarehouseRequired: "請選擇倉庫",
        lblFullName: "名稱",
        lblOffice: "辦事處",
        lblAddress1En: "英文地址 1",
        lblAddress2En: "英文地址 2",
        lblAddress3En: "英文地址 3",
        lblAddress4En: "英文地址 4",
        lblFullNameLocal: "本地名稱",
        lblAddress1Local: "本地地址 1",
        lblAddress2Local: "本地地址 2",
        lblAddress3Local: "本地地址 3",
        lblAddress4Local: "本地地址 4",
        lblTel: "電話",
        lblContactPerson: "聯絡人",
        lblContactEmail: "聯絡電郵",
        lblRemark: "備註",
        lblAttachment: "附件",
        lblStatus: "狀態",
        msgFullNameRequired: "請輸入名稱",
        msgAddress1Required: "請輸入地址 1",
        msgAddress2Required: "請輸入地址 2",
        msgDuplicate: "倉庫已存在",
        msgOfficeRequired: "請輸入辦事處",
    },
    accountGroupCode: {
        msgDuplicate: "帳戶群組代碼已存在",
    },
    sysNotice: {
        lbNoticeType: "通知類別",
        lbNoticeTitle: "通知標題",
        lbNoticeBody: "通知內容",
        lbMod: "受影響系統",
        lbValidDate: "有效日期",
        lbRemarks: "備註",
        lbCreatedBy: "建立者",
        lbCreatedDate: "建立日期",
        lbUpdatedBy: "更新者",
        lbUpdatedDate: "更新日期",
        msgUpdatedSysNoticeSuccessfully: "更新系統通知成功",
        msgUpdateSysNoticeFail: "更新系統通知失敗",
        msgConfirmDelete: "是否確定刪除此系統通知？",
        lbDelete: "刪除",
        lbCopy: "複製",
    },
    notificationCenter: {
        colModule: "模組",
        colNotificationName: "通知",
        colDescription: "描述",
        colCreationParty: "建立者",
        colSubject: "主旨",
        colParameter: "參數",
        colSendTo: "發送至",
        colModuleId: "排程 ID",
        colRecurrence: "週期",
        colStartDate: "開始日期",
        colEndTime: "結束時間",
        colCc: "Cc",
        lbNotification: "通知",
        lbModule: "模組",
        msgModuleRequired: "請輸入模組",
        msgNameRequired: "請選擇名稱",
        msgSendAtRequired: "請輸入發送時間",
        msgRecurrenceRequired: "請選擇週期",
        msgTimeRangeRequired: "請輸入時間範圍",
        msgSubjectRequired: "請輸入主旨",
        lbNotificationName: "通知",
        lbDescription: "描述",
        lbNotificationSetting: "通知設定",
        lbOwnershipSetting: "擁有權設定",
        lbParameter: "參數",
        lbDistributionSetting: "發送設定",
        lbNotificationSubject: "通知主旨",
        lbTo: "收件人",
        msgToRequired: "請輸入收件人",
        lbCc: "Cc",
        lbBcc: "Bcc",
        lbStartDate: "開始日期",
        msgStartDateRequired: "請輸入開始日期",
        lbEndDate: "結束日期",
        lbRecurrence: "週期",
        lbRecurrenceToolTip: "每日：通知將每日發出\n每週：通知將於所選的星期幾發出。例如，通知設定為每週星期一發出時，通知將於每個星期一發出",
        DaysOfWeek: "星期幾",
        lbSendTime: "發送時間",
        lbCustimizedSetting: "通知自訂設定",
        lbRemarkType: "備註類型",
        lbVisibleTo: "可見對象",
        lbTimeRange: "時間範圍",
        lbIncludeRates: "在電郵中包含運價",
        msgDeleteSuccess: "刪除成功",
        msgGetError: "發生錯誤，請重新整理頁面。",
        msgRecvTypeRequired: "請選擇接收方式",
        msgPartyTypeRequired: "請選擇相關方類型",
        msgPartyIDRequired: "請選擇相關方",
        msgRoleRequired: "請選擇角色",
    },
    messenger: {
        lbNoticeType: "公告類型",
        lbNoticeSubject: "主旨",
        lbNoticeShortDescription: "簡短描述",
        lbNoticeShortDescriptionToolTip: "僅適用於應用程式內公告",
        lbNoticeFullDescription: "完整描述",
        msgFullDesc: "請輸入完整描述",
        msgWarningFullDescExceedMaxImageSize: "圖片大小不能超過 {{maxImageSize}} MB。",
        msgWarningFullDescExceedMaxHTMLTextSize: "總大小不能超過 {{maxHTMLTextSize}} MB。",
        msgFinalWarningFullDescExceedMaxHTMLTextSize: "完整描述總大小（目前：{{currentHTMLTextSize}}MB）不能超過 {{maxHTMLTextSize}} MB。請移除圖片。",
        msgFullDescExceedMaxTextLength: "完整描述總長度（目前：{{currentTextLength}} 字）不能超過 {{maxTextLength}} 字。",
        lbInApp: "應用程式內",
        lbEmail: "電郵",
        lblNoticeReceiver: "公告接收者",
        msgNoticeReceiver: "請選擇公告接收者",
        msgNoticeReceiverInvalidEmailFormat: "電郵格式無效",
        lbCreatedBy: "建立者",
        lbCreatedDate: "建立日期",
        lbUpdatedBy: "更新者",
        lbUpdatedDate: "更新日期",
        msgSaveNoticeAndConsvationSuccessfullyInAppAndEmail: "電郵及應用程式內通知已成功發送至有效用戶。",
        msgSaveNoticeAndConsvationSuccessfullyInAppOnly: "應用程式內通知已成功發送至有效用戶。",
        msgSaveNoticeAndConsvationSuccessfullyEmailOnly: "電郵已成功發送。",
        msgSaveNoticeAndConsvationFail: "發送訊息失敗",
        lbCopy: "複製",
        msgFillRequireField: "請填寫所有必填欄位",
        msgExistingUserNotFound: "用戶 ID 無效（{{invalid_emails}}）",
        errMessageNotFound: "找不到訊息。",
    },
    routingTemplate: {
        msgDeleteSuccess: "刪除成功",
        lbRoutingTemplateName: "路線範本名稱",
        msgRoutingTemplateNameRequired: "請輸入路線範本名稱",
        lbCustomer: "客戶",
        lbConsignee: "收貨人",
        lbPOD: "卸貨港（POD）",
        lbEffectiveFrom: "生效日期起",
        lbEffectiveTo: "生效日期迄",
        lbCanBeOverWritten: "可被覆寫",
        msgConsigneeRequired: "請輸入收貨人",
        msgPODPLDFDRequire: "請輸入 POD、PLD 或 FD 其中之一",
        msgUpdateRoutingTemplateSuccess: "路線範本更新成功",
        msgCreateRoutingTemplateSuccess: "路線範本建立成功",
        lbRemarks: "備註",
        lbRoutingTemplateNameTip: "請以簡單且 OP 易於理解的字詞為路線範本命名",
        lbCustomerTip: "輸入路線範本的客戶（大客戶），以便在 BMS 路線範本維護畫面更易管理",
        autoUpdatePLDTooltip: "如可定義 POD ETA 與 PLD ETA 之間天數差的驗證，請開啟此按鈕",
        autoUpdateFDTooltip: "如可定義 POD ETA 與 FD ETA 之間天數差的驗證，請開啟此按鈕",
        lbPLDETAValidation: "PLD ETA 驗證",
        lbFDETAValidation: "FD ETA 驗證",
        msgEffectiveFromRequired: "請輸入生效日期起",
        lbEffectiveFromTip: "定義此路線範本的生效日期",
        lbEffectiveToTip: "如無結束日期，請將生效日期迄留空",
        lbCanBeOverWrittenTip: "如允許 OP 覆寫預設值（例如：已定義的 POD／PLD／FD）及 PLD／FD ETA 驗證，請開啟此按鈕",
    },
    msgUpdateTradeLaneSuccess: "更新貿易航線成功",
    msgUpdateTradeLaneFail: "更新貿易航線失敗",
    msgConfirmDeleteTradeLane: "是否確定刪除貿易航線 [{{tradelane_name}}]？",
    msgDeleteTradeLaneSuccess: "刪除貿易航線成功",
    msgDeleteTradeLaneFail: "刪除貿易航線失敗",
    lbTradelaneCountryRequired: "請選擇國家",
    lbTradelaneUnlocodeRequired: "請選擇 POL",
    lbTradelanePOLCountryRequired: "請選擇 POL 國家",
    msgUpdateSettingSuccess: "設定更新成功",
    msgCreateSettingSuccess: "設定建立成功",
    lbPartyGroup: "相關方群組",
    lbPartyGroupID: "相關方群組 ID",
    lbGroupName: "群組名稱",
    lbGroupType: "群組類別",
    lbTierGroupOnly: "僅等級群組",
    lbSubGroup: "子群組",
    lbManagedByTLM: "由 TLM 管理",
    lbPartyGroupParty: "相關方",
    msgUpdatePartyGroupSuccess: "更新相關方群組成功",
    msgUpdatePartyGroupFail: "更新相關方群組失敗",
    msgPartyGroupMissingField: "請填寫缺少的欄位",
    msgPartyGroupDuplicate: "群組名稱必須唯一。",
    msgPartyGroupPartyAlreadyAssigned: "收貨人代碼：{party_codes} 已存在於大客戶：{existing_party_group_name}。",
    colCreatedBy: "建立者",
    colCreatedDate: "建立日期",
    colUpdatedBy: "更新者",
    colUpdatedDate: "更新日期",
    lbNotSearchedYet: "請套用「自訂篩選」或點擊「搜尋」以執行搜尋",
    lbUpdatedBy: "更新者",
    lbUpdatedDtTm: "更新日期／時間",
    lbWithoutSave: "是否確定不儲存便離開？",
    lbInvModal_APRef: {
        lbTitle: "批次更新 AP Ref.",
        lbAPRef: "AP Ref.",
        lbWay1: "方式 1－請在以下文字框輸入 AP Ref.。點擊「確定」按鈕後，所輸入的 AP Ref. 將應用於（上方列出的）所有已選發票。",
        lbWay2: "方式 2－上傳 Excel 檔案以批次更新 AP Ref.。系統將從 Excel 檔案擷取 Invoice# 及 AP Ref.，並在下方顯示變更預覽。點擊「確定」按鈕以應用變更。",
        lbFile_Tooltip: "系統將讀取 Excel 檔案以擷取 Invoice# 及 AP Ref. 來批次更新 AP Ref.。請確保檔案第一行在兩個不同欄位包含 Invoice# 及 AP Ref. 字樣",
    },
    lbInvModal_PaymentRef: {
        lbTitle: "批次更新 Payment Ref.",
        lbAPRef: "Payment Ref.",
        lbRefInfo2: "Payment Ref. 標記",
        lbWay1: "方式 1－請在以下文字框輸入 Payment Ref.。點擊「確定」按鈕後，所輸入的 Payment Ref. 將應用於（上方列出的）所有已選發票。",
        lbWay2: "方式 2－上傳 Excel 檔案以批次更新 Payment Ref.。系統將從 Excel 檔案擷取 Invoice# 及 Payment Ref.，並在下方顯示變更預覽。點擊「確定」按鈕以應用變更。",
        lbFile_Tooltip: "系統將讀取 Excel 檔案以擷取 Invoice# 及 Payment Ref. 來批次更新 Payment Ref.。請確保檔案第一行在兩個不同欄位包含 Invoice# 及 Payment Ref. 字樣",
    },
    lbInvModal_SubTypeTaxRate: {
        lbTitle: "更新「發票子類型」及「稅率代碼」",
        lbInvoiceSubtype: "發票子類型",
        lbTaxRate: "稅率代碼",
    },
    lbInvModal_COD: {
        lbTitle: "是否確定將以下記錄的 COD 狀態更改為 @action？",
    },
    lbInvModal_UploadDoc: {
        lbDocTypeContent_SupportingDoc: "支援文件",
        lbDocTypeContent_IncomingInvoice: "進項發票",
        lbDocTypeContent_Statement: "Statement（結算單）",
        lbDocTypeContent_FpFzInvoice: "全電發票（Fully Digitized E-Invoice）",
        lbTitle: "批次上傳文件",
        lbDocument: "檔案",
        lbRemark: "備註",
        lbDocTypeDesc_FpFzInvoice: "Web Invoice 將讀取並擷取此上傳文件中的 AP Ref.。\n完成後將通知您。 ",
    },
    lbInvModal_CRSummary: {
        lbTitle: "列印 CR 摘要",
        lbSearchPlaceHolder: "填寫 Invoice#",
    },
    lbInvModal_StatusUpdate: {
        msgSureToChangeState: "是否確定將以下記錄的狀態更改為 @action？",
        lbRemark: "備註",
        lbPrintingFormat: "列印格式",
        lbWay1: "方式 1－點擊「確定」按鈕後，（上方列出的）所有已選發票將被過帳。",
        lbWay2: "方式 2－上傳 Excel 檔案以批次過帳。系統將從 Excel 檔案擷取 Invoice#，並在下方顯示 Invoice# 以供預覽。點擊「確定」按鈕以過帳（Excel 檔案所列的）發票。",
        lbFile_Tooltip: "系統將讀取 Excel 檔案以擷取 Invoice# 來批次過帳。請確保檔案第一行包含 Invoice# 字樣。",
    },
    lbInvModal_PrintOption: {
        lbTitle: "列印選項",
        lbDescription: "重新整理後此設定將被重設。 ",
        lbSea: "海運",
        lbAir: "空運",
    },
    lbInvModal_Email: {
        CONFIRMATION_DOCUMENT: "確認本",
        REAL_DOCUMENT: "正式本",
    },
    lbInvModal_GroupPanel: {
        lbSearchPlaceHolder: "填寫 Group#",
    },
    lbInvModal_QuickCreate: {
        lbTitle_BlankInv: "快速建立發票",
        lbTitle_ReferenceInv: "複製發票至",
        lbSearchPlaceHolder: "填寫 Job#",
        lbPasteSearchCurrentJob: "從已選發票貼上並搜尋 Job#",
        lbRefInvoice_Tooltips: "填寫現有發票編號，以將其發票頭資料及費用資料複製到新建立的發票。",
        lbRefInvoice: "參考發票編號：",
        lbErrorMessageTitle: "無法建立／複製發票",
    },
    lbInvModal_PrintHistory: {
        lbTitle: "合併列印",
        lbType: "文件類型",
        lbAutoMerge: "自動合併 PDF",
        lbNextNumber: "下一個列印編號",
        lbDocType999: "發票",
        lbDocType9: "7026 稅務發票",
        lbDoc_Type999_PrintParams1_Label: "Job#",
        lbDoc_Type9_PrintParams1_Label: "Invoice# / 政府發票編號",
        lbJob_Tooltip: "如要搜尋多個 Job#，請以逗號（,）分隔輸入多個 Job#，例如 (0001,0002)。",
    },
    lbInvErr: {
        lbNoPermission: "您沒有權限",
        lbPleaseSelect: "請選擇！",
        lbPleaseInput: "請輸入！",
        lbOutOfRangeErr: "請輸入介於 (minNum) 與 (maxNum) 之間的數值",
        lbJobNoNotFound: "找不到此工作編號。",
        lbMissingExchangeRate: "找不到總帳（ledger）的匯率。 ",
        lbJobDataNotExist: "此 Job 編號無法取得足夠資料。",
        lbAccountCodeNotFound: "無法從已選 Job 取得「帳戶代碼」及／或「作業辦事處」。 ",
        lbMissingAPReference: "過帳前請填寫 AP Ref.。",
        lbMissingAPReference2: "請填寫 AP Ref.",
        lbMissingJobNo: "請輸入至少 1 個 Job#。",
        lbMissingHBLNoInJob: "缺少 HBL#。請確保已在 Job#（jobNo）中輸入 HBL#。",
        lbUnexpectedJob: "此發票中混入非預期的 Job#（jobNo）內容。",
        lbMissingIssueForm: "請輸入開立方。",
        lbMissingSO: "試中文",
        lbMissingCurrency: "請輸入發票貨幣。 ",
        lbCannotUseTempCode: "不應使用臨時收貨人代碼。請更新收貨人代碼。",
        lbDNResultInDR: "DN 及 IDN 應有 DR 結果。 ",
        lbCNResultInCR: "CN 及 ICN 應有 CR 結果。 ",
        lbMissPLRecord: "請輸入至少 1 個 P&L 費用項目。",
        lbMissGCRecord: "請輸入至少 1 個一般費用項目。",
        lbMissCRRecord: "請輸入至少 1 個支票申請項目。",
        lbMissingGovInvoiceNo: "請填寫政府發票編號。",
        lbMissingInvoiceDate: "請填寫發票日期。",
        lbMissingHeader: "請填寫表頭所有必填欄位。",
        lbMissingPLDetails: "請填寫 P&L 費用明細所有必填欄位。",
        lbMissingGCDetails: "請填寫一般費用明細所有必填欄位。",
        lbMissingCRDetails: "請填寫支票申請明細所有必填欄位。",
        lbCheckPLDetails: "請檢查並重新儲存 P&L 費用。 ",
        lbCheckGCDetails: "請檢查並重新儲存一般費用。 ",
        lbCheckCRDetails: "請檢查並重新儲存支票申請。 ",
        lbMissingDocUpload: "請選擇／拖曳檔案以作文件上載。",
        lbARChargeCodeError: "請確保已於一般費用分頁正確選擇費用代碼及 DR/CR。AR 費用代碼應為 DR 結果，而 AP 費用代碼應為 CR 結果。",
        lbAPChargeCodeError: "請確保已於一般費用分頁正確選擇費用代碼及 DR/CR。AR 費用代碼應為 CR 結果，而 AP 費用代碼應為 DR 結果。",
        lbMixedJob_SeaAir: "所有已選 Job 的運輸方式必須相同。",
        lbMixedJob_HdOff: "所有已選 Job 的所屬辦事處必須相同。",
        lbMixedJob_JobPeriod: "所有已選 Job 的 Job 期間必須相同。",
        lbMixedJob_JobType: "所有已選 Job 的進口／出口必須相同。",
        lbWaitForContainerDetailsLoad: "Job 的貨櫃資料正下載至 Web Invoice。請於數秒後點擊「儲存」按鈕。",
        lbLogisticJobNoPL: "Logistic Job 不能建立利潤分成發票",
        lbMismatchGCItem: "一般費用總額與一般費用明細金額不符。",
        lbMismatchPLItem: "PL 總額與 PL 明細金額不符。",
        lbMismatchCRItem: "CR 總額與 CR 明細金額不符。",
        lbJobNoEditLock: "Job# (jobNo) 不能更改。",
        lbJobRelatedSO: "Job No. (jobNo)：已存在相關 SO 編號 [(soNo)]。請先移除該 SO 才更改 Job#。 ",
        lbJobRelatedPLHBL: "Job No. (jobNo)：已存在相關 PL HBL 行 [Line (lineNo)]。 ",
        lbJobRelatedPLHBL_reverse: "請在此行移除 Job No. (jobNo) 的關聯。 ",
        lbPostChectError: "因資料缺失，無法過帳記錄。",
        lbMissingJobData: "Job 資料缺失。",
        lbNotInSelectionList: "所選值無效，不存在於選項清單中。請從選項清單中選擇數值。",
        lbAdoptTmplib_GC: "\"(template_name)\" 已套用。費用項目#(fromRow) - (toRow) 已加入一般費用明細表。",
        lbAdoptTmplib_GC_Nothing: "\"(template_name)\" 已套用。沒有項目加入一般費用明細表。",
        lbUndoTmplib_GC: "(counter) 個費用項目已從一般費用明細表中移除。",
        lbAdoptTmplib_CR: "\"(template_name)\" 已套用。費用項目#(fromRow) - (toRow) 已加入支票申請明細表。",
        lbAdoptTmplib_CR_Nothing: "\"(template_name)\" 已套用。沒有項目加入支票申請明細表。",
        lbUndoTmplib_CR: "(counter) 個費用項目已從支票申請明細表中移除。",
        lbStatusUpdateTimeLag: "狀態無法更新。請再試一次。",
        lbStatusUpdateAccountLock: "此帳戶已鎖定（結帳程序正在執行中）。請數分鐘後再試。",
        lbAccountCodeNotForPost: "會計科目代碼[(account_code)] 不支援過帳。發票 ID[(invoice_id)] 無法過帳。請聯絡管理員。",
        lbSaveSuccess: "發票儲存成功。",
        lbSaveError: "變更未儲存，因為系統發現此發票正被其他用戶／工作階段同時更新。請再試一次。",
        lbStatusSuccess: "狀態更新成功。",
        lbSOPMS_ChargeCodeNotFound: "規則集 (template_section_id) 設定的費用代碼有衝突。 ",
        lbSOPMS_MinChargeConflict: "規則集 (template_section_id) 設定的最低費用代碼有衝突。 ",
        lbSOPMS_MaxChargeConflict: "規則集 (template_section_id) 設定的最高費用代碼有衝突。 ",
        ActionItem_RedoGCChargeCode: "找不到有效的費用代碼資料。",
        lbExportExcelOver: "無法匯出所有記錄，每次最多可匯出 10,000 筆記錄。請縮小搜尋範圍。",
        lbSameCurrencyExchangeRate1: "如一般費用的貨幣與表頭的發票貨幣相同，一般費用的匯率應為 1。",
        lbLastestFilterSettingAdopt: "已還原上次的搜尋條件。請點擊「搜尋」以重新整理／載入搜尋結果。",
        lbPrintingInfoLoading: "列印資料仍在載入中。請稍候。 ",
        lbPrintingInfoLoadFailure: "無法取得列印資料。請再試一次。 ",
        lbPLRTChanged: "由於 UOM 已更改，\"P & L Charge At HBL Level\" 中行號 #(LineNo) 的數量已更新",
        lbGCCRRTChanged: "由於 UOM 已更改，費用項目行號 #(LineNo) 的數量已更新",
        lbInvoiceTotalAmountErr: "發票總額（含稅）不應超過 (ledgerCurrency) (maxNum)（或任何其他貨幣的等值金額）。",
        lbCheckCurrentGroupError: "請檢查目前群組的錯誤。",
        lbMixSubtypeError: "匯出 FP/FZ 不能與其他發票子類型混合",
        lbExchangeRateUpdated: "匯率已更新為預設值。 ",
        lbPrintDescriptionErr: "列印說明不符。",
        lbMissingTaxCode: "請填寫稅率代碼。",
        lbMissingInvoiceSubType: "請填寫發票子類型。",
        lbFutureJobPeriod: "Job 月份為未來月份。匯出前請仔細檢查。",
        lbQuickPreviewSwitchTab: "切換至另一張發票前，請先儲存或取消變更。",
        lbQuickPreviewClosePanel: "要關閉「快速預覽」面板，請先儲存或取消變更",
        lbCRSummaryMixAccountCode: "支票申請摘要不能跨會計科目代碼列印。 ",
        lbPrintMixAccountCode: "不能跨會計科目代碼列印。 ",
        lbPrintMixARAP: "不能跨 AR 及 AP 列印。 ",
        lbNoInvoiceAccountingPrint: "請選擇發票以進行批次會計列印／放行／作廢。",
        lbNoSign: "至少 1 名編製或審批此發票的用戶沒有電子簽署。",
        lbSelectAccountCode: "請選擇會計科目代碼。",
    },
    lbInvLoadingMsg: {
        lbLoading: "載入中…",
        lbServerValidation: "伺服器驗證中…",
        lbSaving: "儲存中…",
        lbServerValidation1: "載入中…伺服器驗證 (1) 完成",
        lbServerValidation2: "載入中…伺服器驗證 (2) 完成",
        lbCheckAccountLock: "載入中…帳戶已可過帳",
        lbPrinting: "載入中…列印發票編號(invoice_no)",
        lbSignPrinting: "載入中…於發票編號(invoice_no) 簽署",
    },
    lbInvMenu: {
        lbSearchAR: "搜尋應收帳款",
        lbCreateAR: "新增應收帳款",
        lbViewAR: "檢視應收帳款",
        lbAmendAR: "修改應收帳款",
        lbSearchAP: "搜尋應付帳款",
        lbCreateAP: "新增應付帳款",
        lbViewAP: "檢視應付帳款",
        lbAmendAP: "修改應付帳款",
    },
    lbInvARAP: {
        lbAGENT: "代理",
        lbCNS: "收貨人",
        lbSHIPPER: "付貨人",
        lbCARRIER: "船公司",
        lbSUPPLIER: "供應商",
        lbInvoice: "發票編號",
        lbPreviewInvoice: "預覽發票",
        lbPrintOption: "發票列印選項設定",
        lbPreviewPLSheet: "預覽 PL 報表",
        lbPrint703XDNCN: "列印 703X DN/CN",
        lbPrintReverseInvoice: "列印沖銷發票",
        lbReprintInvoice: "重新列印發票",
        lbPrint7028IDNICN: "列印 7028 IDN/ICN",
        lbPrintDNCN: "列印 DN/CN",
        lbPrintIDNICN: "列印 IDN/ICN",
        lbDebitNote: "借項通知單",
        lbCreditNote: "貸項通知單",
        lbConfirmDoc: "發票確認件",
        lbInvoiceAttachment: "發票附件",
        lbPrintInvoice: "列印文件",
        lbTaxInvoice: "稅務發票",
        lbPreviewTaxInvoice: "預覽 7026 稅務發票",
        lbReceipt: "收據",
        lbPreviewReceipt: "預覽 7026 收據",
        lbMore: "更多",
        lbCopyInvoice: "複製發票",
        lbAutoInvoice: "建立 DN 以收取 M+R HKG 處理費",
        lbInvoiceTnx2: "產生跨帳戶交易發票",
        lbStatusControlPanel: "狀態更新",
        lbUpdateFromWebInvoiceCore: "從 Web Invoice Core 更新",
        lbUpdateFromOPS: "從 OPS 更新",
        lbHeader: "表頭",
        lbOffice: "辦事處",
        lbPreviewExcel: "預覽 Excel",
        lbInvoiceIssuingOffice: "發票開立辦事處",
        lbAccountCode: "會計科目代碼",
        lbAPRef: "AP 參考編號",
        lbARType: "AR 類型",
        lbAPType: "AP 類型",
        lbJob: "Job#",
        lbIssueTo: "開立予",
        lbIssueFrom: "開立自",
        lbOverseas: "海外／本地",
        lbSo: "SO#",
        lbNominationAgent: "指定代理",
        lbReleaseAgent: "放貨代理",
        lbConsignee: "收貨人",
        lbNotifyParty: "通知人",
        lbShipper: "付貨人",
        lbModeofTransport: "運輸方式",
        lbJobType: "Job 類型",
        lbService: "服務",
        lbInvoiceCurrency: "發票貨幣",
        lbExchangeRate: "匯率",
        lbRemarks: "備註",
        lbDocUpload: "文件上載",
        lbDocType: "文件類型",
        lbFile: "檔案",
        lbTimingAsPerRequirement: "時間按需求而定",
        lbPL: "P&L",
        lbGeneralCharge: "一般費用",
        lbChequeRequest: "支票申請",
        lbStatus: "狀態",
        lbLatestStatus: "最新狀態",
        lbGP: "GP",
        lbAccountPeriod: "會計期間",
        lbAccountLock: "會計鎖定",
        lbLocked: "已鎖定",
        lbPreviewClose: "預覽／執行結帳",
        lbPreview: "預覽",
        lbRunClosing: "執行結帳",
        lbClosedPeriod: "已結帳期間",
        lbRunClosingBy: "結帳執行者",
        lbRunClosingDate: "結帳日期",
        lbRunClosingExcel: "結帳 Excel",
        lbDownload: "下載",
        lbNewRowHotkey: "新增列（Alt+N）",
        lbTaxRate: "稅率代碼",
        lbSendTaxInvoiceTo: "稅務發票發送至",
        lbSendTaxInvoiceTo_Tooltip: "「稅務發票發送至」留空或輸入最多 3 個電郵地址。",
        lbRemarkOption: "備註格式",
        lbRemarkOption_Tooltip: "請選擇合適的備註格式，該備註格式將用於稅務發票上",
        lbRemarkOption1: "預設款",
        lbRemarkOption1_Remark: "",
        lbRemarkOption2: "預設款-簡潔版",
        lbRemarkOption2_Remark: "簡潔版不包含運輸資料及不適用於月結發票。",
        lbRemarkOption3: "貨物運輸服務款",
        lbRemarkOption3_Remark: "請在 Reference 1 填寫車牌，Reference 2 填寫運輸貨物名稱。\n如需在發票上使用指定的起運地和到達地，請在 Reference 輸入「DEP@XXX」（例如：DEP@NINGBO -- 將起運地修改為 NINGBO）和／或「ARR@XXX」，\n否則一律使用 Job／SO 資料來預設起運地和到達地",
        lbRemarkOption4: "貨物運輸服務款-簡潔版",
        lbRemarkOption4_Remark: "簡潔版不包含運輸資料及不適用於月結發票。請在 Reference 1 填寫車牌，Reference 2 填寫運輸貨物名稱。\n如需在發票上使用指定的起運地和到達地，請在 Reference 輸入「DEP@XXX」（例如：DEP@NINGBO -- 將起運地修改為 NINGBO）和／或「ARR@XXX」，\n否則一律使用 Job／SO 資料來預設起運地和到達地",
        lbGovernmentInvoiceNo: "政府發票編號",
        lbInvoiceDate: "發票日期",
        lbCODNotRequired: "無需 COD",
        lbCODRejected: "COD 已被拒",
        lbCODRequestForApproval: "COD 審批請求",
        lbCODApproved: "COD 已批准",
        lbCODPaymentDate: "COD 付款日期",
        lbCODStatus: "COD 狀態",
        lbCODRemarks: "COD 備註",
        lbCODPaymentDate_Tooltip: "如屬貨到付款（Cash on Delivery），請輸入「COD 付款日期」，以指示 M+R 清繳此發票的最後付款日期，\n並提交「COD 審批請求」。管理層將審核並批准該 COD 請求，以決定是否繼續進行。\n\n如非貨到付款，請將「COD 付款日期」留空。",
        lbCODRemarks_Tooltip: "請填寫以下資料以供 COD 審批。此等資料不會用於或顯示於列印文件及報表。                                \n1. COD 付款的費用類型，例如：本地費用、海運費、空運費、進口目的地費用等。                                \n2. 供應商的一般背景資料                                \n3. 選擇 COD 作為付款模式的原因。 ",
        lbTaxInvoicePrintDate: "稅務發票列印日期",
        lbInvoiceSubtype: "發票子類型",
        lbInterTranscation: "跨帳戶交易",
        lbPaymentRef: "付款參考編號",
        lbPaymentRef_placeholder: "填寫付款參考編號。如未收到付款參考編號，請留空",
        lbPaymentRef_infoTooltip: "如開票方將會／已向我們發出付款參考編號，請勾選此按鈕。",
        lbLocalName: "名稱（本地）",
        lbENName: "名稱（英文）",
        lbRole: "角色",
        lbTaxID: "公司編號／稅務編號",
        lbCompanyPhone: "公司電話",
        lbVATAddress: "VAT 地址（本地）",
        lbVATAddressEN: "VAT 地址（英文）",
        lbLocalMainInvoicingAddress: "主要開票地址（本地）",
        lbENMainInvoicingAddress: "主要開票地址（英文）",
        lbLocalMainAddress: "主要地址（本地）",
        lbENMainAddress: "主要地址（英文）",
        lbBankDetails: "銀行資料",
        lbSunAccountCode: "Sun 會計科目代碼",
        lbSunAccountCode4: "Sun 4 A/C 代碼",
        lbSunAccountCode6: "Sun 6 A/C 代碼",
        lbNotAssigned: "(content_name) 未被指派。請聯絡相關方建立。",
        lbUpdateExchangeRate: "更新為預設匯率",
        lbInterAccountTransaction: "開啟此按鈕：如需要在過帳此發票時，系統於指定會計科目（例如 7021）自動建立傳入借項通知單（如此發票為借項通知單）／傳入貸項通知單（如此發票為貸項通知單）。\n\n關閉此按鈕：如不需要上述功能。",
        lbSetDefaultExchangeRateTooltip: "匯率不在可接受範圍內，因此不正確。請點擊「更新為預設匯率」按鈕，將匯率更新為預設值。",
        lbReference: "參考",
        lbReferenceTooltip: "您可在此欄位填寫此發票的參考資料，以作日後參考。此資料不會用於或顯示於列印文件及報表。",
        lbReferenceTooltip_7048: "請輸入車牌號碼作為第一個參考資料，以供傳送至稅務部門",
        lbSEQRelease: "放行",
        lbSEQVoid: "作廢",
        lbSEQReassign: "重新指派",
        lbSEQTransfer: "重用",
        lbCRSummaryHistory: "支票申請摘要歷史",
        lbSnapshotStatus_no_history: "無快照",
        lbSnapshotStatus_data_processing: "處理中",
        lbSnapshotStatus_generate_excel: "快照已建立",
        lbSnapshotStatus_completed: "快照連 Excel 已建立",
        lbSnapshotStatus_generate_excel_old_download_file: "快照已建立",
        lbOptimizeOptions_refresh: "重新整理快照",
        lbOptimizeOptions_bestOptimize: "使用上次快照",
    },
    lbInvPL: {
        lbContainerLv: "貨櫃層級 P&L 費用",
        lbHBLLv: "(HBL_HAWB) 層級 P&L 費用",
        lbHBL: "HBL",
        lbHAWB: "HAWB",
        lbContainerSize: "貨櫃／尺寸",
        lbChargeDesc: "費用",
        lbPrintDesc: "列印說明",
        lbPL: "盈虧",
        lbPLAgentPerc: "代理 %",
        lbPLTotal: "總計",
        lbPLAgent: "代理",
        lbPLMR: "M + R",
        lbAgentCollect: "代理",
        lbMRPrepaid: "M+R",
        lbBuyCost: "買入（成本）",
        lbSellingIncome: "賣出（收入）",
        lbTotal: "總計",
        lbAmountDR: "金額（DR）",
        lbAmountCR: "金額（CR）",
        lbLedgerAmountDR: "金額（DR）\n（基本貨幣）",
        lbLedgerAmountCR: "金額（CR）\n（基本貨幣）",
        lbCBM: "CBM",
        lbUOM: "UOM",
        lbCW: "C.W",
        lbTotal_Sym: "總計：",
        lbTotalInvAmt: "發票總額（不含稅）： ",
        lbTotalInvTaxAmount: "發票稅額總計： ",
        lbTotalInvAmtTax: "發票總額（含稅）： ",
    },
    lbInvGC: {
        lbGeneralChargesDetails: "一般費用明細",
        lbLine: "#",
        lbRefSB: "參考",
        lbDRCR: "DR/ CR",
        lbChargeDesc: "費用",
        lbPrintDesc: "列印說明",
        lbCurrency: "貨幣",
        lbUnitPrice: "單價",
        lbExchangeRate: "匯率",
        lbQty: "數量",
        lbUOM: "UOM",
        lbAmountDR: "金額（DR）",
        lbAmountCR: "金額（CR）",
        lbLedgerAmountDR: "金額（DR）\n（基本貨幣）",
        lbLedgerAmountCR: "金額（CR）\n（基本貨幣）",
        lbTotal: "總計：",
        lbTotalGeneralChargesExclusive: "一般費用總額（不含稅）：",
        lbTotalGeneralChargesTaxAmount: "一般費用稅額總計：",
        lbTotalGeneralChargesInclusive: "一般費用總額（含稅）：",
        lbJobNo: "Job 編號",
        lbHbl: "(hbl_hawb) 編號 / SO 編號 / (cbm_cw) / 包裝",
        lbContainer: "貨櫃編號／尺寸（(hbl_hawb) 編號）",
        lbTaxCode: "稅率代碼",
        lbTaxRate: "稅率",
        lbTaxAmount: "稅額",
        lbLedgerTaxAmount: "稅額\n（基本貨幣）",
        lbAmount: "金額",
        lbLedgerAmount: "金額\n（基本貨幣）",
        lbAll: "全部",
        lbTaxExclusive: "不含稅",
        lbTaxInclusive: "含稅",
        lbInterTran: "跨帳戶交易",
        lbPrintDescriptionTooltip: "列印說明（如適用）將用於每個費用項目並列印於發票列印文件上",
        lbCurrencyTooltip: "費用項目行的貨幣",
        lbUnitPriceTooltip: "以所選貨幣計的不含稅單價",
        lbUnitPriceExchangedTooltip: "以「發票表頭貨幣」計的含稅單價",
        lbAmountDebitTooltip: "不含稅金額 = 不含稅單價 x 匯率 x 數量",
        lbAmountCreditTooltip: "不含稅金額 = 不含稅單價 x 匯率 x 數量",
        lbTaxCodeTooltip: "每個費用項目行適用的稅率代碼。「稅率」將根據所選稅率代碼重新整理。",
        lbTaxRateTooltip: "根據所選「稅率代碼」的稅率。（系統根據所提供的「稅額」計算實際稅率。）",
        lbUnitPriceTaxTooltip: "以發票表頭貨幣計的含稅單價",
        lbAmountDebitTaxTooltip: "含稅金額 = 不含稅金額 + 稅額",
        lbAmountCreditTaxTooltip: "含稅金額 = 不含稅金額 + 稅額",
        lbAmountTaxTooltip: "稅額為系統根據所選「稅率代碼」為每個費用項目行計算的稅額，或由用戶指定的稅額。\n\n稅額（由系統計算）= 不含稅金額 x 稅率",
        lbInterAccountTransactionTooltip: "開啟此按鈕：如需要此費用項目行向指定會計科目收費。當此發票（首次）被審批時，系統會於同一會計科目（例如 703X）自動建立借項通知單。或者，當此發票處於「已編製」狀態時，您可點擊「更多動作 > 產生跨帳戶交易發票」以觸發自動建立程序。\n註：如此發票涉及多個 Job，則無法執行此動作。\n\n關閉此按鈕：如不需要上述功能。",
        lbInterAccountTransactionWarningTooltip: "標準 \"Invoice 2\" 程序（建立 DN 以向相關 M+R 分行收費）不適用於中國本地攬貨業務。\n 繼續前請仔細核實。",
        lbChargeDesc_View: "列印說明 [代碼]",
        lbViewModeTooltip: "您可切換至不同的檢視模式，以不同格式檢視不同資料，方便工作。 \n\nAlt+A：編輯發票時隱藏每個費用項目行上的功能按鈕 \nAlt+L：顯示以基本貨幣計的詳細金額",
        lbViewMode: "檢視模式",
        lbAlt_T: "Alt+T 切換單價含稅模式",
        lbAlt_QW: "Alt+Q：切換至上一個檢視模式\nAlt+W：切換至下一個檢視模式",
        lbPrediction_Info: "點擊機械人按鈕以套用「費用明細」預測，支援預測參考、費用代碼及行稅率代碼。",
        lbPrediction_All: "套用「費用明細」預測",
        lbPrediction_HighRate: "僅對高可能性項目套用「費用明細」預測",
        lbPrediction_Remove: "復原「費用明細」預測（如該費用行尚未被 OP 編輯）",
    },
    lbInvCR: {
        lbCRDetails: "支票申請明細",
        lbCRChargeSummary: "支票申請快速摘要",
        lbCRDetailsItem: "支票申請費用明細",
        lbAvailableDate: "可用日期：",
        lbFreeToCombine: "可合併",
        lbFreeToCombineTooltips: "勾選此核取方塊，以讓會計部知道可將此支票申請與其他支票申請合併，\n即開立予同一對象及由同一操作員編製的支票申請，以開立一張支票付款。",
        lbPaymentMarker: "付款標記：",
        lbForeignCurrency: "外幣 ",
        lbLine: "#",
        lbJob: "Job#",
        lbReference: "參考",
        lbChargeCode: "費用代碼",
        lbChargeDesc: "費用說明",
        lblRemarks: "備註",
        lbUnitPriceBaseCurrency: "單價\n（基本貨幣）",
        lbUnitPriceForeignCurrency: "單價\n（外幣）",
        lbQuantity: "數量",
        lbUOM: "UOM",
        lbAmtBaseCurrency: "金額\n（基本貨幣）",
        lbAmtForeignCurrency: "金額\n（外幣）",
        lbChequeCurrency: "支票貨幣",
        lbTotal: "總計：",
        lbExchangeRate: "兌 (base_currency) 匯率",
        lbTaxAmountBaseCurrency: "稅額\n（基本貨幣）",
        lbTaxAmountForeignCurrency: "稅額\n（外幣）",
        lbLedgerTotalAmountBaseCurrency: "金額\n（換算為基本貨幣）",
        lbLedgerAmountTaxBaseCurrency: "稅額\n（換算為基本貨幣）",
        lbTotalAmount: "金額",
        lbAmountTax: "稅額",
        lbVatPeriod: "VAT 期間",
        lbFormatTypeNo: "格式代號",
        lbCompanyID: "公司編號",
        lbTaxCreditNo: "扣抵代號",
        lbLocalInvoiceNo: "本地發票編號",
    },
    lbInvARAPType: {
        lbPL: "利潤分成發票",
        lbDN: "借項通知單",
        lbCN: "貸項通知單",
        lbIDN: "傳入借項通知單",
        lbICN: "傳入貸項通知單",
        lbCR: "支票申請",
        lbNON_TRADE: "非貿易發票",
        lbAP: "應付帳款",
        lbAR: "應收帳款",
    },
    lbInvSubType: {
        lbP: "普通發票或其他發票",
        lbZ: "增值稅專用發票",
        lbEP: "電子普票",
        lbEZ: "電子專票",
        lbFP: "全電普票",
        lbFZ: "全電專票",
        lbTY: "統一發票",
        lbR: "收據",
        lbTRANSFER: "轉賬",
        lbCHEQUE: "支票",
        lbTY31: "三聯式",
        lbTY32: "二聯式",
        lbDSDF: "代收代付",
        lbSTAMP: "印花稅",
        lbNSD: "免印花稅",
        lbWCT: "有信用期",
        lbNCT: "無信用期",
    },
    lbInvStatus: {
        lbAction: "操作",
        lbStatus: "狀態",
        lbLine: "#",
        lbType: "",
        lbAccountCode: "會計科目代碼",
        lbInvoice: "發票編號",
        lbAPRef: "AP 參考編號",
        lbLatestStatus: "最新狀態",
        lbStatusRemarks: "狀態備註",
        lbInvoicceToFrom: "發票開立予／開立自",
        lbInvAmtInvCurrency: "發票金額\n（發票貨幣）",
        lbExchangeRate: "匯率",
        lbInvAmtBaseCurrency: "發票金額\n（基本貨幣）",
        lbIncomeBaseCurrency: "收入\n（基本貨幣）",
        lbCostBaseCurrency: "成本\n（基本貨幣）",
        lbSettledAmount: "已結算金額\n（發票貨幣）",
        lbTotal: "總計：",
        lbGP_Title: "GP",
        lbGP: "GP：",
        lbGP_SO: "按 SO 的 GP",
        lbStatusHistory: "狀態歷史",
        lbARAP: "AR / AP#",
        lbPosition: "職位",
        lbUser: "用戶",
        lbDateTime: "更新時間",
        lbRemarks: "備註",
        NewReversedInvoiceBtn: "新增（沖銷）",
        NewInvoiceBtn: "新增",
        ApprovedInvoiceBtn: "審批",
        ClosedInvoiceBtn: "關閉",
        ClosedReversedInvoiceBtn: "關閉",
        DeletedInvoiceBtn: "刪除",
        PostedInvoiceBtn: "過帳",
        PostReversedInvoiceBtn: "過帳",
        PreparedInvoiceBtn: "編製",
        PrintedInvoiceBtn: "列印",
        RejectedInvoiceBtn: "拒絕",
        ReleasedInvoiceBtn: "放行",
        ReversedInvoiceBtn: "沖銷",
        ExportedInvoiceBtn: "匯出",
        ImportedInvoiceBtn: "匯入",
        PendingExportAutoBtn: "待自動匯出",
        SupvApprovedInvoiceBtn: "審批（第一級）",
        SupvRejectedInvoiceBtn: "拒絕（第一級）",
        MgrApprovedInvoiceBtn: "審批（第二級）",
        MgrRejectedInvoiceBtn: "拒絕（第二級）",
        NewReversalGroupBtn: "審批（第二級）",
        PreparedReversalInvoiceBtn: "編製（沖銷）",
        ExportReversalGroupBtn: "匯出",
        ImportReversalGroupBtn: "匯入",
        PostReversalGroupBtn: "過帳",
        ExportedAutoBtn: "已匯出（自動）",
        AccountingPrintedInvoiceBtn: "會計列印",
        lbInvoiceBtn: "發票",
        lbReSignInvoiceBtn: "於發票簽署",
        lbSignedInvoiceBtn: "附電子簽署的發票",
        lbPLSheetBtn: "PL 報表",
        lbExportFileBtn: "匯出檔案",
        lbTaxInvoiceBtn: "稅務發票",
        lbReceiptBtn: "收據",
        lbGPAmount: "GP 金額",
        lbGPAmountTooltip: "全部 - 同時顯示不含稅 GP 及含稅 GP\n不含稅 - 只顯示不含稅 GP\n含稅 - 只顯示含稅 GP",
        lbExchangeRateUpdated: "匯率已由 (updated_by_name) 從 (origin_exchange_rate) 更新至 (new_exchange_rate)。 ",
        lbGrouped: "已匯出作批次發票（Group# (group_no)）",
        lbGroupedWithCount: "已匯出作批次發票（Group# (group_no)）（發票數量：(group_invoice_count)）",
        lbGroupedAuto: "Group# (group_no)（發票數量：(group_invoice_count)）",
        lbInvoicceToFromLocal: "發票開立予／開立自（本地）",
        lbGovernmentInvoiceNo: "政府發票編號",
        lbRollbackExport: "從已匯出回復",
        lbRollbackImport: "從已匯入回復 [政府發票編號：(gov_invoice_no)、發票日期：(invoice_dt) 已重設為空]",
        lbRollbackAccountingPrinted: "從 (Accounting_Printed) 回復 [政府發票編號：(gov_invoice_no)、發票日期：(invoice_dt) 已重設為空]",
        lbProcess_pending: "待處理",
        lbProcess_empty: "不適用",
        lbProcess_fail: "失敗",
        lbProcess_success: "成功",
        lbSalesCode: "營業員代碼",
        lbShipperName: "付貨人名稱",
        lbSO: "SO#",
    },
    lbInvGPSummary: {
        lbSummaryTable: "Job# 的 GP 快速摘要：",
        lbCurrency: "貨幣",
        lbTotalIncome: "總收入",
        lbTotalCost: "總成本",
        lbGP: "GP",
        lbGPPercent: "GP%",
    },
    lbInvColorDesc: {
        JobOutstandingPending1: "待完成，超過 2 個 Job 月份",
        JobOutstandingPending2: "待完成，於 1 個 Job 月份內",
        JobOutstandingPending3: "待完成，少於 1 個 Job 月份",
        ARPendingCreation1: "ETD 後超過 2 天仍未建立",
        ARPendingCreation2: "ETD 後 2 天內仍未建立",
        ARPendingCreation3: "ETD 當日或之前仍未建立",
        ARNewInvoice1: "ETD 後超過 2 天仍未編製",
        ARNewInvoice2: "ETD 後 2 天內仍未編製",
        ARNewInvoice3: "ETD 當日或之前仍未編製",
        ARPreparedInvoice1: "列印後超過 3 天仍未列印",
        ARPreparedInvoice2: "列印後 3 天內仍未列印",
        ARPreparedInvoice3: "ETD 當日或之前仍未列印",
        ARReleasedInvoice1: "AR 已放行",
        ARPrintedInvoice1: "列印後超過 2 天仍未過帳",
        ARPrintedInvoice2: "列印後 2 天內仍未過帳",
        ARPrintedInvoice3: "列印當日仍未過帳",
        ARNewReversedInvoice1: "列印後超過 2 天仍未過帳",
        ARNewReversedInvoice2: "列印後 2 天內仍未過帳",
        ARNewReversedInvoice3: "列印當日仍未過帳",
        ARPostedInvoice1: "AR 建立月份後 10 天仍未結帳",
        ARPostedInvoice2: "AR 建立月份後 10 天內仍未結帳",
        ARPostedInvoice3: "同一日曆月內建立的 AR 仍未結帳",
        ARReversedInvoice1: "AR 建立月份後 10 天仍未結帳",
        ARReversedInvoice2: "AR 建立月份後 10 天內仍未結帳",
        ARReversedInvoice3: "同一日曆月內建立的 AR 仍未結帳",
        ARPostReversedInvoice1: "AR 建立月份後 10 天仍未結帳",
        ARPostReversedInvoice2: "AR 建立月份後 10 天內仍未結帳",
        ARPostReversedInvoice3: "同一日曆月內建立的 AR 仍未結帳",
        ARPendingApproval1: "編製後超過 2 天仍未審批",
        ARPendingApproval2: "編製後 2 天內仍未審批",
        ARPendingApproval3: "編製當日仍未審批",
        ARPendingExport3: "待匯出",
        ARPendingImport3: "待匯入",
        ARPostedFailure3: "AR 過帳至 SUN 失敗",
        ARPostedSuccess3: "AR 過帳至 SUN 成功",
        ARPostedPending3: "AR 待 SUN 確認",
        APPendingCreation1: "ETD 後超過 5 天仍未建立",
        APPendingCreation2: "ETD 後 5 天內仍未建立",
        APPendingCreation3: "ETD 當日或之前仍未建立",
        APNewInvoice1: "ETD 後超過 30 天仍未編製",
        APNewInvoice2: "ETD 後 30 天內仍未編製",
        APNewInvoice3: "ETD 當日或之前仍未編製",
        UploadDocMissing1: "ETD 後超過 30 天仍未上載文件",
        UploadDocMissing2: "ETD 後 30 天內仍未上載文件",
        UploadDocMissing3: "ETD 當日或之前仍未上載文件",
        APRefMissing1: "ETD 後超過 30 天仍未有 AP 參考編號",
        APRefMissing2: "ETD 後 30 天內仍未有 AP 參考編號",
        APRefMissing3: "ETD 當日或之前仍未有 AP 參考編號",
        APPreparedInvoice1: "超過 2 天仍未第一級審批",
        APPreparedInvoice2: "2 天內仍未第一級審批",
        APPreparedInvoice3: "編製後仍未第一級審批",
        APSupvApprovedInvoice1: "第一級審批後超過 2 天仍未第二級審批",
        APSupvApprovedInvoice2: "待二級審批（一級審批後 2 天內）",
        APSupvApprovedInvoice3: "待二級審批（一級審批當日）",
        APReleasedInvoice1: "AP 已放行",
        APSupvRejectedInvoice1: "AP 已拒絕",
        APMgrRejectedInvoice1: "AP 已拒絕",
        APMgrApprovedInvoice1: "待過帳（審批後超過 2 天）",
        APMgrApprovedInvoice2: "待過帳（審批後 2 天內）",
        APMgrApprovedInvoice3: "待過帳（審批當日）",
        APNewReversedInvoice1: "待過帳（審批後超過 2 天）",
        APNewReversedInvoice2: "待過帳（審批後 2 天內）",
        APNewReversedInvoice3: "待過帳（審批當日）",
        APPostedInvoice1: "待期末結帳（AR 建立月份後 10 天）",
        APPostedInvoice2: "待期末結帳（AR 建立月份後 10 天內）",
        APPostedInvoice3: "待期末結帳（AR 於同一日曆月內建立）",
        APReversedInvoice1: "待期末結帳（AR 建立月份後 10 天）",
        APReversedInvoice2: "待期末結帳（AR 建立月份後 10 天內）",
        APReversedInvoice3: "待期末結帳（AR 於同一日曆月內建立）",
        APPostReversedInvoice1: "待期末結帳（AR 建立月份後 10 天）",
        APPostReversedInvoice2: "待期末結帳（AR 建立月份後 10 天內）",
        APPostReversedInvoice3: "待期末結帳（AR 於同一日曆月內建立）",
        tooltips998: "不適用",
        tooltips999: "因缺少資料而無法顯示顏色",
        APPostedFailure3: "AP 過帳至 SUN 失敗",
        APPostedSuccess3: "AP 成功過帳至 SUN",
        APPostedPending3: "AP 待 SUN 確認",
    },
    lbInvSearch: {
        lbMenuItem_OPEN: "未清",
        lbMenuItem_REOPEN: "未清",
        lbMenuItem_LOCK: "已完成",
        lbMenuItem_LOCKGP: "已完成 - GP 已鎖定",
        lbMenuItem_UpdateAPRef: "更新 AP 參考編號",
        lbMenuItem_UpdatePaymentRef: "更新付款參考編號",
        lbMenuItem_UploadDoc: "上載文件",
        lbMenuItem_CRSummary: "列印 CR 摘要",
        lbMenuItem_UpdateSubTypeTaxRate: "更新「發票子類型」及「稅率代碼」",
        lbMenuItem_NoNextActivity: "無下一項活動",
        lbMenuItem_RePost: "重新過帳",
        lbMenuItem_CODApprove: "COD 審批",
        lbMenuItem_CODReject: "COD 拒絕",
        lbMenuItem_CODNotRequired: "毋須 COD",
        lbMenuItem_CODRequestForApproval: "COD 要求審批",
        lbMenuItem_UpdateCODPaymentDate: "更新 COD 付款日期",
        lbMenuItem_CODCompleted: "COD 完成",
        lbCreateNewAP: "建立新 AP",
        lbCreateNewAR: "建立新 AR",
        lbExportToExcel: "匯出至 Excel",
        lbColumnOption: "欄位選項",
        lbQuickPreview: "快速預覽",
        lbQuickPreviewTooltips: "在彈出視窗中預覽已選取的發票",
        lbQuickPreviewHeader: "快速預覽 [invoice_no] ",
        lbQuickPreviewHeaderTooltips: "在快速預覽中，您無法編輯發票或更新發票狀態。請點擊「在新分頁開啟」，於新分頁開啟發票以進行編輯或更新狀態（如適用）。",
        lbQuickPreviewHeaderNewTabButton: "在新分頁開啟",
        lbType: "類型",
        lbAccountCode: "帳戶代碼",
        lbGP: "GP\n（基本貨幣）",
        lbGPPercent: "GP%",
        lbForeignGP: "GP\n（參考）",
        lbJob: "Job 編號",
        lbJobPeriod: "Job 月份",
        lbFutureJobMonth: "未來 Job 月份",
        lbJobCreatedBy: "Job 建立人",
        lbJobCreatedDate: "Job 建立日期",
        lbSearchJobCreatedBy: "搜尋 Job 建立人",
        lbInvoicceToFrom: "發票對象",
        lbInvoicceToFromLocal: "發票對象（本地）",
        lbSearchIssueParty: "搜尋發票對象",
        lbInvoice: "發票編號",
        lbAPRef: "AP 參考編號",
        lbAPRefInputted: "已輸入 AP 參考編號標記",
        lbSearchAPRef: "搜尋 AP 參考編號",
        lbReversingInvoice: "沖銷發票編號",
        lbSO: "SO#",
        lbHBL: "HBL# / HAWB#",
        lbMBL: "MBL# / MAWB#",
        lbConsignee: "收貨人",
        lbSearchConsignee: "搜尋收貨人",
        lbReleaseAgent: "放貨代理",
        lbSearchReleaseAgent: "搜尋放貨代理",
        lbNominationAgent: "指定代理",
        lbSearchNominationAgent: "搜尋指定代理",
        lbJobService: "Job 服務",
        lbCostCentre: "成本中心代碼",
        lbModeOfTransport: "運輸模式",
        lbJobType: "Job 類型",
        lbSearchJobService: "搜尋 Job 服務",
        lbVessel: "船名",
        lbVoyage: "航次",
        lbFlightNo: "航班編號",
        lbFeederETD: "駁船 ETD",
        lbETD: "ETD",
        lbETA: "ETA",
        lbCarrier: "船公司",
        lbSearchCarrier: "搜尋船公司",
        lbLatestStatus: "發票狀態",
        lbJobInvoicingStatus: "Job 開票狀態",
        lbInvUpdatedBy: "發票更新人",
        lbSearchInvUpdatedBy: "搜尋發票更新人",
        lbInvUpdatedDate: "發票最後更新時間",
        lbStatusUpdatedDate: "狀態最後更新時間",
        lbInvOffice: "Job 辦事處",
        lbCreatorOffice: "發票建立辦事處",
        lbInvAmtInvCurrency: "發票金額\n（發票貨幣）",
        lbSettledAmount: "發票已結算金額\n（發票貨幣）",
        lbInvoiceFullySettled: "發票已全數結算",
        lbSettled: "已結算",
        lbClosePeriod: "期末結帳",
        lbSalesCode: "銷售代碼",
        lbPaymentMarker: "付款標記",
        lbSearchSalesCode: "搜尋銷售代碼",
        lbSunFile: "Sun Account 檔案",
        lbAction: "動作",
        lbExportExcelTooltips: "每次最多可匯出 10,000 筆記錄。",
        lbSmartSearchTooltips: "輸入 Invoice#、Job 編號、SO#、HBL#/ HAWB#、MBL#/ MAWB#、開票對象名稱、貨櫃編號或群組編號進行搜尋。點擊自訂篩選以進行進階搜尋。\n\n在此欄位輸入關鍵字後，您可按「Tab」再按「Enter」執行搜尋。",
        msgSureToChangeState: "是否確定將以下記錄的狀態更改為 @action？",
        msgSureToChangeState_COD: "是否確定將以下記錄的 COD 狀態更改為 @action？",
        lbGovernmentInvoiceNo: "政府發票編號",
        lbInvoiceDate: "發票日期",
        lbInvoiceSubtype: "發票子類型",
        lbPaymentRefFlag: "付款參考編號標記",
        lbPaymentRef: "付款參考編號",
        lbTaxCode: "稅率代碼",
        lbARInterTran: "AR 跨帳戶交易",
        lbAPInterTran: "AP 跨帳戶交易",
        lbGroupNo: "群組編號",
        lbExportFile: "匯出檔案",
        lbTaxAmount: "稅項金額",
        lbBatchPaymentARTooltips: "此開票對象已啟用批次發票",
        lbClosed: "已關閉標記",
        lbReference: "參考",
        lbJobMonth: "Job 月份",
        lbContainersNo: "貨櫃編號",
        lbExchangeRate: "匯率",
        lbInvAmtBaseCurrency: "發票金額\n（基本貨幣）",
        lbHasUploadDoc: "文件",
        lbBatchPayment: "AR 批次發票",
        lbProcessStatus: "Sun 處理狀態",
        lbJournalNumber: "日記帳編號",
        lbSumbitXML: "最新提交 XML",
        lbReturnXML: "最新回應 XML",
        lbInv_coloader_bl: "Coloader BL#",
        lbInv_mso_no: "船公司訂艙編號",
        lbInv_so_ref: "S/O 參考編號",
        lbInv_shp_name: "HBL 付貨人名稱",
        lbInv_job_min_eta: "最早 ETA",
        lbInv_o_ag_name: "起運代理名稱",
    },
    lbInvGroup: {
        lbTitle: "批次發票 - ",
        lbBatchTaxInvTitle: "批次稅務發票 - ",
        lbGroup: "群組編號",
        lbAccountCode: "帳戶代碼",
        lbCurrency: "貨幣",
        lbInvoiceSubType: "發票子類型",
        lbTaxRateCode: "稅率代碼",
        lbNoOfSelectedInvoice: "已選發票數目",
        lbTotalAmountofSelectedInvoice: "已選發票總金額\n（發票貨幣）",
        lbCurrenctGroup: "目前匯出分組",
        lbCurrenctGroup_TaxInvoice: "目前稅務發票分組",
        lbHistory: "歷史（最近 2 個月）",
        lbNoOfGroupedInvoice: "已分組發票數目",
        lbTotalAmountofGroupedInvoice: "已分組發票總金額\n（發票貨幣）",
        lbGroupedDate: "分組日期",
        lbExportDate: "匯出時間",
        lbExportBy: "匯出人",
        lbExportFile: "匯出檔案",
        lbPrintedDate: "列印時間",
        lbPrintedBy: "列印人",
        lbPrintedFile: "列印檔案",
        lbCurrentGroupDescription: "下表顯示屬於上述對象且尚未匯出資料的發票。屬於相同帳戶且相同發票貨幣的發票，將視為同一批次發票群組。\n請選擇需要以群組形式匯出資料作批次發票的發票。完成選擇後，請按上方的「匯出」按鈕。 ",
        lbCurrentGroupDescription_TaxInvoice: "下表顯示屬於上述對象且尚未匯出資料的發票。屬於相同帳戶且相同發票貨幣的發票，將視為同一批次列印稅務發票群組。\n請選擇需要以群組形式匯出資料作批次發票的發票。完成選擇後，請按上方的「會計列印」按鈕。 ",
    },
    lbInvImport: {
        lbTitle: "匯入文件",
        lbIdx: "#",
        lbInvoiceNo: "發票編號",
        lbGovernmentInvoiceNo: "政府發票編號",
        lbInvoiceDate: "發票日期",
        lbImportId: "匯入參考編號",
        lbImportIdTooltip: "當您將匯入檔案上載至 Web Invoice 系統後，系統會產生「匯入參考編號」。此編號僅供參考及支援用途。",
        lbGroupNo: "群組發票編號",
    },
    lbFinance: {
        lbSearch_invoice_total_amount: "總金額\n（發票貨幣）",
        lbSearch_outstanding_amount: "未清金額\n（發票貨幣）",
        lbSearch_settled_amount: "已結算金額\n（發票貨幣）",
        lbSearch_ledger_total_amount: "總金額\n（基本貨幣）",
        lbSearch_ledger_settled_amount: "已結算金額\n（基本貨幣）",
        lbSearch_ledger_outstanding_amount: "未清金額\n（基本貨幣）",
        lbSearch_last_status: "狀態",
        lbSearch_invoice_no: "Web Invoice 的發票編號",
        lbSearch_invoice_type: "類型",
        lbSearch_office_party_code: "辦事處對象代碼",
        lbSearch_finance_invoice_no: "發票編號",
        lbSearch_voucher: "傳票",
        lbSearch_journal_no: "",
        lbSearch_journal_line: "",
        lbOverdue_credit_limit: "信貸限額",
        lbOverdue_usd_amount_ar: "AR 總金額",
        lbOverdue_usd_amount_ap: "AP 總金額",
        lbOverdue_net_usd_amount: "總淨額",
        lbOverdue_credit_amount: "信貸金額",
        lbSearch_f_outstanding_30: "本期",
        lbSearch_f_outstanding_31_60: "31-60 日",
        lbSearch_f_outstanding_61_90: "61-90 日",
        lbSearch_f_outstanding_91_120: "91-120 日",
        lbSearch_f_outstanding_120: "超過 120 日",
        lbSearch_f_outstanding_sub_total: "小計（USD）",
        lbTAccountCode: "T 字帳代碼",
        lbAccountType: "帳戶類型",
        lbFinanceStatement: "財務報表",
        lbExportExcelTooltips: "每次最多可匯出 10,000 筆記錄。",
    },
    lbAnalytics: {
        lbWebInvoiceGP: "Web Invoice GP",
        lbWebInvoiceGP1: "按 Job 月份、服務及運輸模式的 GP",
        lbWebInvoiceGP2: "按 POL 及辦事處的 GP",
        lbWebInvoiceGP3: "按 CBM、貨櫃、CW 及貨件的 GP",
        lbWebInvoiceGP4: "按發票及貨件明細的 GP",
        lbWebInvoiceSalesGP: "Web Invoice 銷售 GP",
    },
    lbTmplibAdoptPenal: {
        lbApply: "套用一次",
        lbUndo: "復原一次",
        lbFavorite: "最愛",
        lbEdit: "編輯",
        lbView: "檢視",
        lbCreateNewTemplate: "建立範本",
        lbRefresh: "重新整理清單",
        lbInfo: "請選擇要套用的範本。",
        lbInfoForRate: "請選擇要套用的一次性費用範本。",
    },
    lbTmplibSearch: {
        lbMyTemplate: "我的範本",
        lbMarket: "市集",
        lbModule: "模組",
        lbCategory: "類別",
        lbTemplateName: "範本名稱",
        lbDescriptionOfTemplate: "範本描述",
        lbOwner: "擁有者",
        lbLastUpdate: "最後更新",
        lbTemplateId: "範本 ID",
        lbTagCould: "熱門標籤：",
        lbTags: "標籤",
        lbRecordUpdatedMsg: "[TemplateName] 已更新，您可以繼續使用。",
        lbCreateNewTemplate: "建立範本",
        lbAdded: "已加入",
        lbMenuItem_Delete: "刪除",
        lbMenuItem_AddToMyTemplate: "加入我的範本",
        lbMenuItem_RemoveFormMyTemplate: "從我的範本移除",
        lbPrivate: "私人",
        lbSharingInMarket: "於市集分享",
        lbShareByOffice: "按辦事處分享",
        lbAddedFromMarket: "從市集加入",
        lbToMainOffice: "您的總辦事處",
        lbGlobal: "全球",
        lbTooltips_Favorite: "最愛",
        lbTooltips_Active: "生效",
        lbTooltips_Inactive: "停用",
        lbCreatedFromMyTemplate: "從我的範本建立",
        lbAddedIntoMyTemplate: "已加入我的範本",
        lbTooltips_MyTemplate: "由您建立或從市集加入的範本",
        lbTooltips_Market: "瀏覽及取得由其他用戶建立並與您分享的市集範本",
        lbSmartSearchTooltips: "此搜尋可搜尋 [範本名稱、範本描述及標籤]",
    },
    lbTmplibActionModal: {
        lbTitle_: "",
        lbTitle_Delete: "是否確定刪除以下範本？",
        lbTitle_AddToMyTemplate: "是否確定將以下範本加入我的範本？",
        lbTitle_RemoveFormMyTemplate: "是否確定從我的範本移除以下範本？",
        lbDelete_Text1: "確定刪除已選範本？",
        lbDelete_Text2: "確定刪除已選範本？刪除後，此已分享範本將從所有用戶的範本庫中移除",
    },
    lbTmplibDetails: {
        lbModule: "模組",
        lbCategory: "類別",
        lbTmpLib: "[#(Tmplib_id)]",
        lbTmpName: "範本名稱",
        lbTmpId: "範本 ID",
        lbTmpCreatedBy: "建立人",
        lbTmpDescription: "描述",
        lbReleaseNote: "版本說明",
        lbShareLink: "分享連結",
        lbShareOffice: "分享辦事處",
        lbPrivacy: "分享",
        lbPrivate: "私人",
        lbPublic: "市集",
        lbByOffice: "市集（指定辦事處）",
        lbToMainOffice: "您的總辦事處",
        lbGlobal: "全球",
        lbShareToOffice: "分享至辦事處",
        lbLinkShare: "連結分享",
        lbEnabled: "已啟用",
        lbHashTag: "標籤",
        lbColor: "顯示顏色",
        lbColorScheme1: "金色",
        lbColorScheme2: "淺藍色",
        lbColorScheme3: "藍色",
        lbColorScheme4: "深藍色",
        lbColorScheme5: "紫藍色",
        lbTmpStatus: "範本狀態",
        lbTooltips_Favorite: "最愛",
        lbTooltips_Active: "生效",
        lbTooltips_Inactive: "停用",
        lbTooltips_PrivacySettings: "私人：範本僅您本人可見\n\n市集：範本將於市集分享及提供，其他用戶可從市集加入此範本並使用\n\n市集（指定辦事處）：範本將於市集分享及提供，指定辦事處的用戶可從市集加入此範本並使用\n\n您的總辦事處：範本將與您總辦事處的所有用戶分享，他們可直接使用（毋須先從市集加入此範本）\n\n全球：範本將與所有用戶分享，他們可直接使用（毋須先從市集加入此範本） ",
        lbTooltips_ShareLink: "您可以透過 URL 與隊友／其他用戶分享此範本。他們可開啟此 URL 以取得此範本。",
        lbTooltips_ReleaseNote: "由於此範本會與其他用戶分享，儲存範本時請填寫「版本說明」，說明您所作的更新，方便其他用戶參考。",
        lbTooltips_Hashtag: "標籤讓用戶以最簡單的方式整理大量範本。用戶可透過套用標籤搜尋，快速篩選並搜尋特定範本。",
        lbTooltips_DisplayColor: "套用範本時，由此範本建立的記錄會標示為您所選的顯示顏色，方便您參考。",
        lbTooltips_SelectCounter: "已選選項的數目",
    },
    lbTmplibEditError: {
        lbDuplicateName: "此範本名稱已被使用。",
        lbUpdateFailure: "範本庫更新失敗。請聯絡管理員。",
        lbSaveSuccess: "範本庫儲存成功。",
        lbNoPermission: "您沒有權限",
        lbFillInRequiredFields: "請填寫「範本內容」中的所有必填欄位。",
        lbCopyToClipboard: "分享連結已複製。",
        lbGetTemplateFailure: "此範本為私人範本，無法加入您的範本庫。",
        lbGetTempalteSuccess: "此範本已加入您的範本庫。",
    },
    lbTmplibModule: {
        WebInvoice: "Web Invoice",
        BMS: "BMS",
        SailingScheduleRate: "搜尋船期及運價",
    },
    lbTmplibCategory: {
        INV_7023: "7021",
        INV_7024: "7024",
        INV_7025: "7025",
        INV_7026: "7026",
        INV_7028: "7028",
        INV_7030: "7030",
        INV_703X: "703X",
        INV_7048: "7048",
        INV_7055: "7055",
        INV_GCSOPMS: "SOPMS 一般費用",
        INV_GCSOPMS_7048: "SOPMS 一般費用 7048",
        INV_PRINT_OPT: "列印選項",
        BMS_MARKS_GOODS: "嘜頭及貨品描述",
        CostToSummarizedRateList: "新增一次性費用至運價",
        CostToSummarizedRateList_Batch: "新增費用至摘要運價表",
    },
    lbTmplibStep: {
        INV_7023_step1: "範本設定",
        INV_7023_step2: "範本內容",
        INV_7024_step1: "範本設定",
        INV_7024_step2: "範本內容",
        INV_7025_step1: "範本設定",
        INV_7025_step2: "範本內容",
        INV_7026_step1: "範本設定",
        INV_7026_step2: "範本內容",
        INV_7028_step1: "範本設定",
        INV_7028_step2: "範本內容",
        INV_703X_step1: "範本設定",
        INV_703X_step2: "範本內容",
        INV_7030_step1: "範本設定",
        INV_7030_step2: "範本內容",
        INV_7048_step1: "範本設定",
        INV_7048_step2: "範本內容",
        INV_7055_step1: "範本設定",
        INV_7055_step2: "範本內容",
        INV_GCSOPMS_step1: "輸入",
        INV_GCSOPMS_step2: "輸出",
        INV_GCSOPMS_7048_step1: "輸入",
        INV_GCSOPMS_7048_step2: "輸出",
        CostToSummarizedRateList_step1: "範本設定",
        CostToSummarizedRateList_step2: "範本內容",
        CostToSummarizedRateList_Batch_step1: "範本設定",
        CostToSummarizedRateList_Batch_step2: "範本內容",
    },
    lbTmplibFormTitle: {
        INV_Setting: "設定",
        INV_GeneralCharge: "預設一般費用項目",
        INV_PLHBL: "「House Bill 層級 P & L 收費」表格中的預設收費項目",
        INV_ChequeRequest: "預設支票申請項目",
        INV_GCSOPMS_INPUT: "搜尋條件",
        INV_GCSOPMS_OUTPUT: "預設一般費用項目",
        INV_GCSOPMS_SETTING: "設定",
        INV_PrintOption: "列印選項",
        BMS_MARKS_GOODS: "嘜頭及貨品描述",
        RATE_Setting: "設定",
        RATE_Content: "新增費用至運價",
        RATE_Content_Onetime: "新增一次性費用至運價",
    },
    lbTmplibFormTitle_Tooltip: {
        INV_Setting: "請選擇合適的「帳戶代碼」、「辦事處」及「發票類型」，作為此範本「範本設定」的基礎。「範本設定」將用於自訂「範本內容」的欄位，以及篩選「範本內容」中選擇清單的選項。\n建議您將範本套用至發票後，務必檢查其內容。",
    },
    lbTmplibFieldTitle_Tooltip: {
        INV_GC_Reference: "告知系統如何產生一般費用項目。",
        INV_CR_Reference: "告知系統如何產生支票申請項目。",
        INV_GCSOPMS_OUT_BaseOn: "告知系統如何產生一般費用項目。",
        INV_GCSOPMS_OUT_Override: "0 = 所有用戶均可覆寫\n10 = 發票用戶、主管及經理可覆寫\n20 = 發票主管及經理可覆寫\n30 = 發票經理可覆寫\n99 = 任何人均不可覆寫",
        INV_GCSOPMS_SETTING_ValidationGroup: "請在「驗證群組」及「標籤」中填入數值，方便參考。\n若同一驗證群組內的不同 SOPMS 之間，發現「ETD 生效日期範圍」及／或「發票日期生效範圍」互相矛盾，系統將不予允許。\n\n請參閱 *** M:\\Dept\\Future\\SOPMS  *** 以取得驗證群組主清單\n\n** 如毋須驗證檢查，請填入「0」",
        INV_GC_Qty: "如範本中的 QTY 為 0，系統會在以下情況根據發票資料自動替換「Qty」。\n \n1. 參考 = 「每個 Job」；已選收費代碼；UOM = 「Bill」。 -- > Qty 將自動替換為每個 Job 的提單數目\n \n2. 參考 = 「每個 HBL/HAWB」；已選收費代碼；UOM = 「Container」。 -- > Qty 將自動替換為每個 HBL/HAWB 的貨櫃數目",
        INV_CR_Qty: "如範本中的 QTY 為 0，系統會在以下情況根據發票資料自動替換「Qty」。\n \n1. 參考 = 「每個 Job」；已選收費代碼；UOM = 「Bill」。 -- > Qty 將自動替換為每個 Job 的提單數目\n \n2. 參考 = 「每個 HBL/HAWB」；已選收費代碼；UOM = 「Container」。 -- > Qty 將自動替換為每個 HBL/HAWB 的貨櫃數目",
        INV_GC_MinTotalAmount: "如範本行涉及計算，並會在套用範本時自動填入「QTY」（例如每張提單每 KG 收費 $1，套用範本時「QTY」會自動填入 House 層級的 KG），您可為其設定最低或最高總金額。\n \n填寫「最低/ 最高總金額」後，請同時輸入相應欄位（「最低/最高收費」、「最低/最高列印描述」及「最低/最高 UOM」）。當達到最低或最高條件時，這些欄位將一併套用。",
        INV_GC_MaxTotalAmount: "如範本行涉及計算，並會在套用範本時自動填入「QTY」（例如每張提單每 KG 收費 $1，套用範本時「QTY」會自動填入 House 層級的 KG），您可為其設定最低或最高總金額。\n \n填寫「最低/ 最高總金額」後，請同時輸入相應欄位（「最低/最高收費」、「最低/最高列印描述」及「最低/最高 UOM」）。當達到最低或最高條件時，這些欄位將一併套用。",
        INV_CR_MinTotalAmount: "如範本行涉及計算，並會在套用範本時自動填入「QTY」（例如每張提單每 KG 收費 $1，套用範本時「QTY」會自動填入 House 層級的 KG），您可為其設定最低或最高總金額。\n \n填寫「最低/ 最高總金額」後，請同時輸入相應欄位（「最低/最高收費」、「最低/最高備註」及「最低/最高 UOM」）。當達到最低或最高條件時，這些欄位將一併套用。",
        INV_CR_MaxTotalAmount: "如範本行涉及計算，並會在套用範本時自動填入「QTY」（例如每張提單每 KG 收費 $1，套用範本時「QTY」會自動填入 House 層級的 KG），您可為其設定最低或最高總金額。\n \n填寫「最低/ 最高總金額」後，請同時輸入相應欄位（「最低/最高收費」、「最低/最高備註」及「最低/最高 UOM」）。當達到最低或最高條件時，這些欄位將一併套用。",
        INV_GC_PrintDescriptionSelect: "如套用範本至發票時需使用收費代碼的預設收費描述，請將「列印描述」留空",
        BMS_Prefer_Using_At: "此為 BMS（嘜頭及貨品描述）的選填欄位",
        RATE_AddCostFor: "告知系統如何在運價上加入費用，以產生摘要運價表。",
    },
    lbTmplibFieldTitle: {
        lbLine: "#",
        INV_Setting_Office: "辦事處",
        INV_Setting_AccountCode: "帳戶代碼",
        INV_Setting_InvoiceType: "發票類型",
        INV_GC_DrCr: "DR/CR",
        INV_GC_Reference: "為以下對象自動建立 1 項一般費用項目",
        INV_GC_Charge: "收費",
        INV_GC_Charge_7048: "收費",
        INV_GC_PrintDescription: "列印描述",
        INV_GC_PrintDescriptionSelect: "列印描述",
        INV_GC_Currency: "貨幣",
        INV_GC_UnitPrice: "單價",
        INV_GC_ExchangeRate: "",
        INV_GC_Qty: "QTY",
        INV_GC_UOM: "UOM",
        INV_GC_Remark: "參考",
        INV_GC_MinCharge: "最低收費",
        INV_GC_MinPrintDescription: "最低列印描述",
        INV_GC_MinPrintDescriptionSelect: "列印描述",
        INV_GC_MinUOM: "最低 UOM",
        INV_GC_MinTotalAmount: "最低總金額",
        INV_GC_MaxCharge: "最高收費",
        INV_GC_MaxPrintDescription: "最高列印描述",
        INV_GC_MaxPrintDescriptionSelect: "列印描述",
        INV_GC_MaxUOM: "最高 UOM",
        INV_GC_MaxTotalAmount: "最高總金額",
        INV_PLC_HBL: "HBL / HAWB",
        INV_PLHBL_CW: "",
        INV_PLHBL_Charge: "收費",
        INV_PLHBL_PrintDescription: "列印描述",
        INV_PLHBL_Agent: "盈虧代理",
        INV_PLHBL_Agent_BuyCBM: "",
        INV_PLHBL_Agent_BuyQTY: "",
        INV_PLHBL_Agent_SellCBM: "",
        INV_PLHBL_Agent_SellQTY: "",
        INV_PLHBL_MR_BuyCBM: "",
        INV_PLHBL_MR_BuyQTY: "",
        INV_PLHBL_MR_SellCBM: "",
        INV_PLHBL_MR_SellQTY: "",
        INV_CR_Reference: "為以下對象自動建立 1 項一般費用項目",
        INV_CR_Remark: "參考",
        INV_CR_Charge: "收費",
        INV_CR_PrintDescription: "列印描述",
        INV_CR_Description: "備註",
        INV_CR_Currency: "貨幣",
        INV_CR_UnitPrice: "單價",
        INV_CR_Qty: "QTY",
        INV_CR_UOM: "UOM",
        INV_CR_MinCharge: "最低收費",
        INV_CR_MinPrintDescription: "最低備註",
        INV_CR_MinUOM: "最低 UOM",
        INV_CR_MinTotalAmount: "最低總金額",
        INV_CR_MaxCharge: "最高收費",
        INV_CR_MaxPrintDescription: "最高備註",
        INV_CR_MaxUOM: "最高 UOM",
        INV_CR_MaxTotalAmount: "最高總金額",
        INV_GCSOPMS_SETTING_ValidationGroup: "驗證群組",
        INV_GCSOPMS_IN_AccountCode: "帳戶代碼",
        INV_GCSOPMS_IN_InvoiceType: "發票類型",
        INV_GCSOPMS_IN_OverseasLocal: "海外 / 本地",
        INV_GCSOPMS_IN_Office: "Job 辦事處",
        INV_GCSOPMS_IN_Customer: "客戶",
        INV_GCSOPMS_IN_IssueToFrom: "開票對象",
        INV_GCSOPMS_IN_NominationAgent: "指定代理",
        INV_GCSOPMS_IN_ReleaseAgent: "放貨代理",
        INV_GCSOPMS_IN_Consignee: "收貨人",
        INV_GCSOPMS_IN_NotifyParty: "通知人",
        INV_GCSOPMS_IN_MOT: "運輸模式",
        INV_GCSOPMS_IN_Service: "Job 服務",
        INV_GCSOPMS_IN_ETD_from: "ETD 生效日期起",
        INV_GCSOPMS_IN_ETD_to: "ETD 生效日期至",
        INV_GCSOPMS_IN_InvoiceDt_from: "發票日期生效起",
        INV_GCSOPMS_IN_InvoiceDt_to: "發票日期生效至",
        INV_GCSOPMS_OUT_DrCr: "DR/CR",
        INV_GCSOPMS_OUT_BaseOn: "為以下對象自動建立 1 項一般費用項目",
        INV_GCSOPMS_OUT_Charge: "收費",
        INV_GCSOPMS_OUT_PrintDescription: "列印描述",
        INV_GCSOPMS_OUT_Currency: "貨幣",
        INV_GCSOPMS_OUT_UnitPrice: "單價",
        INV_GCSOPMS_OUT_Qty: "QTY",
        INV_GCSOPMS_OUT_UOM: "UOM",
        INV_GCSOPMS_OUT_Reference: "參考",
        INV_GCSOPMS_OUT_MinCharge: "最低收費",
        INV_GCSOPMS_OUT_MinPrintDescription: "最低列印描述",
        INV_GCSOPMS_OUT_MinUOM: "最低 UOM",
        INV_GCSOPMS_OUT_MinTotalAmount: "最低總金額",
        INV_GCSOPMS_OUT_MaxCharge: "最高收費",
        INV_GCSOPMS_OUT_MaxPrintDescription: "最高列印描述",
        INV_GCSOPMS_OUT_MaxUOM: "最高 UOM",
        INV_GCSOPMS_OUT_MaxTotalAmount: "最高總金額",
        INV_GCSOPMS_OUT_Override: "可覆寫者",
        INV_GC_UnitPriceTax: "單價",
        INV_PrintOption_Sea: "海運列印選項",
        INV_PrintOption_Air: "空運列印選項",
        BMS_Prefer_Using_At: "偏好使用位置",
        BMS_Description: "嘜頭 / 貨品描述",
        RATE_AddCostFor: "新增費用依據",
        RATE_Carrier: "船公司",
        RATE_ContainerSize: "貨櫃尺寸",
        RATE_ContainerSize_Onetime: "貨櫃尺寸",
        RATE_POL: "POL",
        RATE_POD: "POD",
        RATE_Value: "值",
        RATE_CostName: "費用名稱",
        RATE_Currency: "貨幣",
        RATE_Cost: "費用",
        RATE_OthersValue: "",
        RATE_CalculationMethod: "計算方法",
    },
    Tmplib_INV_GC_Reference_ValueTo: {
        lb_1TO1: "Job 編號（如只有 1 個 Job）",
        lb_PERJOB: "Job 編號",
        lb_PERHBL: "HBL/HAWB 編號（如 UOM = \"KG\"/\"CBM\" 且 Qty = 0，QTY 將被替換）",
        lb_PERCONTAINER: "貨櫃編號/ 尺寸",
        lb_PERCONTAINERSIZE: "貨櫃編號/ 尺寸",
        lb_PERCONTAINERSIZE_20: "貨櫃編號/ 尺寸",
        lb_PERCONTAINERSIZE_40: "貨櫃編號/ 尺寸",
        lb_PERCONTAINERSIZE_40HC: "貨櫃編號/ 尺寸",
        lb_PERCONTAINERSIZE_45: "貨櫃編號/ 尺寸",
        lb_PERCONTAINERSIZE_LCL: "貨櫃編號/ 尺寸",
        lb_PERCONTAINERSIZE_20HC: "貨櫃編號/ 尺寸",
        lb_PERCONTAINERSIZE_10: "貨櫃編號/ 尺寸",
        lb_PERCONTAINERSIZE_48: "貨櫃編號/ 尺寸",
        lb_PERCONTAINERSIZE_53: "貨櫃編號/ 尺寸",
        lb_GROUPBYHBL: "Job 編號（QTY 將被替換）",
        lb_GROUPBYHBL_PERMBL: "Job 編號（QTY 將被替換）",
        lb_GROUPBYCONTAINER: "Job 編號（QTY 將被替換）",
        lb_GROUPBYCONTAINERSIZE_20: "Job 編號（QTY 將被替換）",
        lb_GROUPBYCONTAINERSIZE_40: "Job 編號（QTY 將被替換）",
        lb_GROUPBYCONTAINERSIZE_40HC: "Job 編號（QTY 將被替換）",
        lb_GROUPBYCONTAINERSIZE_45: "Job 編號（QTY 將被替換）",
        lb_GROUPBYCONTAINERSIZE_LCL: "Job 編號（QTY 將被替換）",
        lb_GROUPBYCONTAINERSIZE_20HC: "Job 編號（QTY 將被替換）",
        lb_GROUPBYCONTAINERSIZE_10: "Job 編號（QTY 將被替換）",
        lb_GROUPBYCONTAINERSIZE_48: "Job 編號（QTY 將被替換）",
        lb_GROUPBYCONTAINERSIZE_53: "Job 編號（QTY 將被替換）",
    },
    dashboardBar: {
        lbApply: "套用一次",
        lbSave: "儲存",
        lbDelete: "刪除",
        lbNewFilter: "儲存篩選器",
        lbEditFilter: "編輯篩選器",
        lbDeleteFilter: "刪除篩選器",
        lbFilterName: "篩選器名稱",
        lbDateInputOption1: "1 天",
        lbDateInputOption2: "2 天",
        lbDateInputOption3: "1 星期",
        lbDateInputOption4: "2 星期",
        lbDateInputOption5: "1 個月",
        lbDateInputOption6: "2 個月",
        lbDateInputOption7: "3 個月",
        lbBgColors: "背景顏色",
        msgDeletePreference: "是否確定刪除此自訂儀表板卡片？",
        msgMissingFilterDetail: "請填寫自訂篩選器中所有必填欄位。",
        msgForPOLPOD: "請選擇用於搜尋 POL、POD 的自訂篩選器。",
        msgForListView: "請選擇篩選器以在「清單」檢視中顯示自訂欄位。",
    },
    filterBar: {
        tlImgBtnFilter: "自訂篩選器",
        msgClearCustomFilter: "是否確定清除所有自訂篩選器？",
        lbField: "欄位",
        lbOperator: "運算子",
        lbValue: "數值",
        lbDateInputOption1: "1 天",
        lbDateInputOption2: "2 天",
        lbDateInputOption3: "1 星期",
        lbDateInputOption4: "2 星期",
        lbDateInputOption5: "1 個月",
        lbDateInputOption6: "2 個月",
        lbDateInputOption7: "3 個月",
        msgMissingFilterDetail: "請填寫自訂篩選器中所有必填欄位。",
        msg3CharactersRequired: "數值必須至少包含 3 個字元。",
    },
    userMaintenance: {
        msgWarningDuplicateOPSID: "以下 OPS ID 已存在於其他使用者帳戶。請確認此帳戶的 OPS ID 及辦事處輸入正確。按「確定」可忽略此警告並繼續儲存變更。",
        msgListDuplcaiteOPSID: "辦事處「{{party_office_code}}」的 OPS ID「{{ops_user_id}}」：{{login_id}}",
    },
    consolidation: {
        lblConsolPlan: "拼櫃計劃",
        lblConsolApproval: "拼櫃審批",
        lblLoadPlan: "裝櫃計劃",
        lblShippingInstruction: "貨櫃-PO 分配",
        lblDocumentUpload: "文件上載",
        msgFillInRequiredFields: "請填寫所有必填欄位。",
        lbConsolPlanInformation: "拼櫃計劃資料",
        lbShipmentsTable: "已選訂艙",
        lbConsolidationType: "拼櫃類型",
        msgConsolidationTypeRequired: "請選擇拼櫃類型",
        lbOriginAgentContactOffice: "M+R 聯絡辦事處",
        lbOriginAgentContactOfficePlaceHolder: "M+R 聯絡辦事處",
        msgOriginAgentContactOfficeRequired: "請選擇 M+R 聯絡辦事處",
        lbConsolidationTypeToolTip: "代理拼櫃：付貨人於起運地將 LCL 貨物交付 M+R 貨倉 (CFS)，與其他適用貨件作實體拼櫃。代理拼櫃內的 HBL 交付「不同」收貨人，但全部由「同一」放貨代理處理。\n\n買家拼櫃：付貨人於起運地將 LCL 貨物交付 M+R 貨倉 (CFS)，與其他適用貨件作實體拼櫃。買家拼櫃內的 HBL 均交付「同一」收貨人。\n\n付貨人拼櫃：付貨人於起運地在自身場所自行裝櫃（即非經 M+R 的 CFS 實體處理），加封後以「據稱內裝」(said to contain) 基準將付貨人拼櫃交付 CY。付貨人必須提供保函，並須為此運作方式承擔全部責任。\n\nLCL／共載拼櫃：付貨人將 LCL 貨物交付 M+R 委任共載商的貨倉 (CFS)，由共載商拼櫃。HBL 交付「同一」收貨人及／或由「同一」放貨代理處理。",
        lbOriginAgentContactOfficeToolTip: "聯絡辦事處負責就拼櫃事宜與 CFS 協調，並會作為列印文件上的聯絡辦事處。",
        msgFillInRequiredTabFields: "請修訂以高亮顯示的頁籤",
        lbConsolidationHandlingOffice: "拼櫃處理辦事處",
        lbConsolidationHandlingOfficePlaceHolder: "拼櫃處理辦事處",
        lbConsolidationHandlingOfficeToolTip: "請選擇負責處理此拼櫃計劃及就拼櫃事宜與 CFS 協調的 M+R 辦事處。通常為 POL 所屬的 M+R 辦事處。",
        msgConsolidationHandlingOfficeRequired: "請輸入拼櫃處理辦事處",
        lbHBLOffice: "HBL 簽發辦事處",
        lbHBLOfficePlaceHolder: "HBL 簽發辦事處",
        lbHBLOfficePlaceToolTip: "簽發 HBL 的 M+R 辦事處",
        lbConsolidationPOL: "起運港 (POL)",
        lbConsolidationPOLPlaceHolder: "起運港 (POL)",
        msgConsolidationPOLRequired: "請選擇起運港 (POL)",
        lbConsolidationPOD: "卸貨港 (POD)",
        lbConsolidationPODPlaceHolder: "卸貨港 (POD)",
        msgConsolidationPODRequired: "請選擇卸貨港 (POD)",
        lbMRConsolReference: "M+R 拼櫃參考",
        lbMRConsolReferencePlaceHolder: "M+R 拼櫃參考",
        lbAgentReference: "代理拼櫃參考",
        lbAgentReferencePlaceHolder: "代理拼櫃參考",
        lbConsigneeReference: "收貨人拼櫃參考",
        lbConsigneeReferencePlaceHolder: "收貨人拼櫃參考",
        lbBuyerReference: "買家拼櫃參考",
        lbBuyerReferencePlaceHolder: "買家拼櫃參考",
        lbContainerSummarySize: "拼櫃貨櫃尺寸",
        lbContainerSummarySizePlaceHolder: "拼櫃貨櫃尺寸",
        lbFCLContainerSummarySize: "FCL 貨櫃尺寸",
        lbFCLContainerSummarySizePlaceHolder: "FCL 貨櫃尺寸",
        msgContainerSummarySizeRequired: "請選擇貨櫃尺寸",
        lbContainerSummaryQty: "數量",
        lbContainerSummaryQtyPlaceHolder: "數量",
        msgContainerSummaryQtyRequired: "請輸入數量",
        errConsolidationNotFound: "找不到拼櫃（{{consolidation_no}}）。",
        miCancelConsolidation: "取消拼櫃",
        msgSureToCancelConsolidation: "是否確定取消此拼櫃？",
        msgRestorePrevSearchCriteria: "已還原上一次的搜尋條件。",
        msgSureToReactivateConsolidation: "是否確定恢復此拼櫃？",
        miReactivateConsolidation: "恢復拼櫃",
        colLine: "#",
        colSoHdOffName: "訂艙處理辦事處",
        colSoNo: "SO#",
        colConsolNo: "CONSOL#",
        colPoNo: "PO#",
        colCargoReadyDate: "貨物備妥日期",
        colContainerNo: "貨櫃編號",
        colLoadingSeq: "裝櫃順序",
        colTotalCbm: "總 CBM",
        colTotalKg: "總 KG",
        colTotalPackageQty: "總件數 (UOM)",
        colTotalLCLItemQty: "總項目數量 (UOM) (LCL)",
        colTotalLCLPackageQty: "總件數 (UOM) (LCL)",
        colTotalLCLCbm: "總 CBM (LCL)",
        colTotalLCLKg: "總 KG (LCL)",
        colAllocatedPackageQty: "已分配件數",
        colBookingContainer: "訂艙貨櫃",
        colDangerousGoods: "危險品？",
        colShipper: "付貨人",
        colConsignee: "收貨人",
        colNotifyParty: "通知人",
        colReleaseAgent: "放貨代理",
        colReleaseAgentCode: "放貨代理代碼",
        colNominationAgent: "指定代理",
        colPor: "POR",
        colPol: "POL",
        colEtd: "ETD",
        colPod: "POD",
        colConsolDate: "拼櫃日期",
        colConsolStatus: "拼櫃狀態",
        colConsolStatusDate: "拼櫃狀態日期",
        colConsolApprovalStatus: "拼櫃審批狀態",
        colConsolApprovalStatusDate: "拼櫃審批狀態日期",
        colCargoReadyDateFrom: "貨物備妥日期（由）",
        colCargoReadyDateTo: "貨物備妥日期（至）",
        colConsolUpdatedBy: "拼櫃更新者",
        colConsolLastUpdatedTime: "拼櫃最後更新時間",
        colConsolApprovalReason: "拼櫃審批原因",
        colConsolApprovalRemarks: "拼櫃審批備註",
        colConsolApprovalUpdatedBy: "拼櫃審批更新者",
        colLatestStatus: "最新狀態",
        colJobNo: "Job#",
        colPodEta: "POD ETA",
        colConsigneeReference: "收貨人拼櫃參考",
        colAgentReference: "代理拼櫃參考",
        colOriginAgentReference: "M+R 參考",
        colConsolHdOffName: "拼櫃處理辦事處",
        colAmendedBookingPending: "待處理已修改訂艙",
        colLoadPlanPendingAllocation: "裝櫃計劃待分配",
        colConsolApprovalUpdatedByProfile: "拼櫃審批更新者設定檔",
        colConsolCreatedBy: "拼櫃建立者",
        lbLoadPlanInformation: "裝櫃計劃資料",
        lbMblNo: "船公司 MBL No.",
        lbColoaderBlNo: "共載商 BL No.",
        lbColoaderBLNoPlaceholder: "輸入共載商 BL No.",
        msgColoaderBlNoEnterBySO: "按 SO 輸入",
        msgColoaderBlNoSameForAllSO: "所有 SO 相同",
        lbSameForAllSO: "所有 SO 相同",
        lbEnterBySO: "按 SO 輸入",
        lbMovementPlaceholder: "請選擇運輸方式",
        lbWarehouse: "貨倉",
        lbWarehouseContactPerson: "貨倉聯絡人",
        lbOriginAgentContactPerson: "M+R 聯絡人",
        lbWarehouseTel: "貨倉聯絡電話",
        lbOriginAgentTel: "M+R 聯絡電話",
        lbWarehouseFax: "貨倉聯絡傳真",
        lbOriginAgentFax: "M+R 聯絡傳真",
        lbWarehouseEmail: "貨倉聯絡電郵",
        lbOriginAgentEmail: "M+R 聯絡電郵",
        lbWarehouseRemarks: "給貨倉的指示及備註",
        lbRemarks: "致目的地備註",
        lbSOContainerAllocation: "SO-貨櫃分配",
        lbContainerSize: "貨櫃尺寸",
        msgContainerSizeRequired: "請選擇貨櫃尺寸",
        lbContainerTypeOwnership: "貨櫃類型／擁有權",
        lbContainerType: "貨櫃類型",
        lbContainerOwnership: "貨櫃擁有權",
        msgContainerOwnershipRequired: "請選擇貨櫃擁有權",
        lbContainerNo: "貨櫃編號",
        lbSealNo: "封條編號",
        msgSealNoRequired: "請輸入封條編號",
        lbContainerActualPackageQty: "貨櫃實際件數",
        lbContainerActualCBM: "貨櫃實際 CBM",
        lbContainerActualKG: "貨櫃實際 KG",
        lbCarrierSONo: "船公司訂艙編號",
        lbMovement: "運輸方式",
        lbPartOf: "所屬",
        lbCYGateIn: "CY 進閘",
        lbCFSReceived: "CFS 已收貨",
        msgCarrierSONoRequired: "請輸入船公司訂艙編號",
        msgActualKGRequired: "請輸入貨櫃實際 KG",
        lbVGM: "VGM",
        lbSOContainerAllocationRemarks: "備註",
        lbPackageQty: "件數",
        lbCBM: "CBM",
        lbKG: "KG",
        lbSandFill: "填沙",
        tlAppendDetailPackageInRemarkBtn: "將詳細件數及 UOM 附於備註",
        tlLoadPlanAllocationRecycleBin: "將已分配的 SO 從貨櫃拖放到垃圾桶以取消分配",
        tlAddAllUnallocatedBookings: "點擊以將所有未分配訂艙加入貨櫃",
        msgAllocateAllRemainPackage: "是否確定將所有未分配訂艙加入貨櫃？",
        tlResetContainer: "點擊以清除貨櫃內所有已分配訂艙",
        msgResetContainer: "是否確定清除貨櫃內所有已分配訂艙？",
        lbSOContainerDetailPackageWarning: "由於不同 SO 選取了多個 UOM，此拼櫃貨櫃的件數 UOM 已設為「Unit」。",
        lbAllocationPreference: "分配偏好",
        lbExcludeFullyAllocatedSO: "排除已完全分配的貨件",
        lbDoor: "上門",
        msgInvalidContainerNo: "貨櫃編號無效",
        msgInvalidConsolidationContainerSize: "M+R 所選船期選項中沒有 {{consolidation_container_size}} 的可用運價。請選擇其他貨櫃尺寸，或先於拼櫃計劃重新整理運價！",
        msgWarningUpdateSelectedRateContainers: "M+R 所選船期選項之運價貨櫃尺寸將會更新。如有需要，請緊記就更新後的運價再次申請拼櫃審批。\n現時：{{origin_size}}\n更新：{{update_size}}",
        msgDuplicateContainerNo: "貨櫃編號重複",
        msgInvalidShipment: "於 {{so_no}}，SO 中的{{- field_name}}與此拼櫃計劃的{{- field_name}}不相符。請檢查並調整 SO 中的{{- field_name}}。",
        msgInvalidOMSShipment: "OMS 貨件 {{oms_so_no}} 不可與其他貨件類型 {{so_no}} 拼櫃，請移除其中一項",
        msgShipmentAlreadyConsol: "{{so_no}} 已連結至其他拼櫃計劃 {{consolidation_no}}。",
        msgShipmentNotConsolidatable: "於 {{so_no}}，「服務」必須為 LCL，且「可拼櫃」必須為「是」。",
        msgInvalidAmount: "PO 明細與貨櫃明細的件數／毛重 (KG)／CBM 必須一致",
        msgInvalidAmountForOMS: "OMS 貨件的項目數量、件數、毛重 (KG) 及 CBM 必須全數分配",
        lbAllocationPreferenceTitle: "分配偏好",
        lbAllocationPreference1: "拖放以分配",
        lbAllocationPreference2: "點擊「+」以分配",
        lbAllocateAllRemainedPackageQty: "分配所有剩餘件數",
        lbAlwaysAskMe: "每次詢問我",
        lbPleaseSelect: "請選擇",
        msgMissingLCLContainer: "SO# {{so_no}}：LCL 服務必須至少有 1 個 LCL 貨櫃尺寸",
        msgMovementNotAlign: "SO# {{so_no}} 中發現多個貨櫃運輸方式",
        lbPDATitle: "調整件數、CBM、KGS",
        lbPDASONo: "SO#",
        lbPDAContainerNo: "貨櫃編號",
        lbPDASequenceNo: "裝櫃順序",
        lbPDAApproximateCBMAndKGS: "根據件數估算 CBM 及 KGS",
        lbPDAPackageQty: "件數",
        lbPDACBM: "CBM",
        lbPDAKGS: "KGS",
        lbLegend: "圖例",
        lbPDALegend1: "本次裝櫃正在分配的數量",
        lbPDALegend2: "尚待分配的剩餘數量",
        lbPDALegend3: "已分配至其他裝櫃／貨櫃的數量",
        msgIncorrectPackageQty: "件數不可為 0。",
        msgIncorrectCBM: "CBM 不可為 0。",
        msgIncorrectKGS: "KGS 不可為 0。",
        msgIncorrectCBM2: "當剩餘件數已完全分配時，剩餘 CBM 並未完全分配。",
        msgIncorrectKGS2: "當剩餘件數已完全分配時，剩餘 KGS 並未完全分配。",
        msgConsolAdviceError: "由於有多於 1 個建議船期，狀態「拼櫃計劃建議」不適用於此拼櫃計劃。請選擇「已審批」作為審批狀態，並選擇一個船期選項作為已審批船期。",
        colFile: "檔案",
        colVisibleTo: "開放予",
        lbVisibleTo: "開放予",
        colApprovalStatus: "審批狀態",
        lbApprovalStatus: "審批狀態",
        lbNewRemarks: "新增備註",
        lblTiming: "時間根據客戶要求",
        colRemarks: "備註",
        colRemarkType: "備註類型",
        lblRemark: "備註",
        lblDocumentType: "文件類型",
        lblFile: "檔案",
        lblFileSource: "檔案來源",
        lblDragOrUpload: "選擇／拖曳檔案",
        msgWarningEditConsolApproval: "進行拼櫃審批前，請先儲存現有拼櫃或取消編輯",
        msgConsolShipmentAllocationSuccess: "已成功將 {{bookings}} 個訂艙加入拼櫃計劃。",
        lbAutoRefreshShipmentAllocationTitle: "發現最新訂艙資料",
        lbAutoRefreshShipmentAllocationContent1: "系統偵測到訂艙資料有更新。所有已選訂艙的最新訂艙資料現已顯示於此拼櫃計劃。請重新檢查此拼櫃計劃。\n",
        lbAutoRefreshShipmentAllocationContent2: "「再次儲存」拼櫃計劃 ",
        lbAutoRefreshShipmentAllocationContent3: "如您於編輯此拼櫃計劃期間曾作出任何變更。",
        lblPrintOption: "列印選項",
        lblAgentRef: "代理參考編號",
        lblBuyerRef: "買家參考編號",
        lblWarehouseInfo: "貨倉資料",
        lblRemarkDestination: "致目的地備註",
        lblGenerate: "產生",
        lblOutputFormat: "輸出格式",
        lblGenerateLoadPlan: "產生裝櫃計劃",
        lblLoadPlanHistory: "裝櫃計劃歷史",
        msgSelectSailingSchedule: "請從「拼櫃計劃建議船期」中選擇",
        msgSelectRate: "請選擇一個運價以作審批。如有任何疑問，請聯絡 BMS 支援。",
        smartSearchTooltip: "輸入 CONSOL#、SO# 或 Job# 以搜尋。點擊自訂篩選器進行進階搜尋。\n\n在此欄位輸入關鍵字後，您可點擊「搜尋」或按「Enter」鍵執行搜尋。",
        msgWarningRemarkExceedMaxImageSize: "圖片大小不可超過 {{maxImageSize}} MB。",
        msgWarningRemarkExceedMaxHTMLTextSize: "總大小不可超過 {{maxHTMLTextSize}} MB。",
        msgFinalWarningRemarkExceedMaxHTMLTextSize: "備註總大小（現時：{{currentHTMLTextSize}}MB）不可超過 {{maxHTMLTextSize}} MB。請移除圖片。",
        msgRemarkExceedMaxTextLength: "備註總長度（現時：{{currentTextLength}} 字元）不可超過 {{maxTextLength}} 字元。",
        phRemarkbraftEditor: "請在此輸入備註或貼上截圖。",
        msgWarningUploadFiles: "請為文件類型 {{document_Type}} 上載檔案",
        msgAddConsolApprovalSuccess: "新增拼櫃審批成功",
        msgAddConsolApprovalFail: "新增拼櫃審批失敗",
        msgConsolidationActionSuccess: "拼櫃計劃編號 {{consolidation_no}} 已成功{{action}}。變更將套用至所有相關 SO，並可能需時數分鐘。完成後將另行通知。",
        msgISFHSWrongFormat: "SO#: {{so_no}}，貨櫃 {{container_no}}：ISF 訂艙／拼櫃的 HS / HTS 編碼必須為 10 位數字。",
        msgENSHSWrongFormat: "SO#: {{so_no}}，貨櫃 {{container_no}}：ENS 訂艙／拼櫃的 HS / HTS 編碼必須為 6 位數字。",
        msgHSWrongFormat: "SO#: {{so_no}}，貨櫃 {{container_no}}：HS / HTS 編碼必須為 6 至 14 位數字（含首尾）。",
        tipsConsolidationHotOutlined: "點擊此圖示將此拼櫃標記為熱門貨件",
        tipsConsolidationHotFilled: "點擊此圖示取消此拼櫃的熱門貨件標記",
        colIsHot: "熱門",
    },
    consolPlanSummary: {
        lbSelectedBookingsSummary: "已選訂艙摘要",
        lblBookings: "訂艙",
        lblCBM: "CBM",
        lblKG: "KG",
        lblPackageQty: "件數",
        lblLCLCBM: "CBM (LCL)",
        lblLCLKG: "KG (LCL)",
        lblLCLPackageQty: "件數 (LCL)",
        lblCargoReadyDate: "貨物備妥日期",
        lblConsignee: "收貨人",
        lblReleaseAgent: "放貨代理",
        lblNominationAgent: "指定代理",
        lblShipper: "付貨人",
        lblDangerousGoods: "危險品？",
        lblResetBtn: "重設選擇",
        lblCreateConsolBtn: "建立拼櫃計劃",
        lblAddToConsolBtn: "加入 {{consolidation_no}}",
        lblTotalCBM: "總 CBM",
        lblTotalKG: "總 KG",
        lblTotalPackageQty: "總件數",
    },
    lbConsolidationColorDesc: {
        SelectedBookingsYellow: "此訂艙與使用者辦事處不相符",
        SelectedBookingsOrange: "SO 已於 [{{updated_date}}]（拼櫃計劃最後儲存之後）被修改",
        SelectedBookingsRed: "發現 SO 資料與拼櫃資料有矛盾。除非矛盾已解決，否則 SO 不可加入此拼櫃計劃。",
        SILCLContainerLineRed: "剩餘的 LCL 數量未透過「裝櫃計劃」分配至拼櫃貨櫃",
        SILCLConsolContainerLineRed: "此拼櫃貨櫃中此 SO 的總數量、重量及／或體積與已分配 PO 的總和不相同",
        SILCLConsolContainerLineGreen: "此拼櫃貨櫃中此 SO 的總數量、重量及體積與已分配 PO 的總和相同",
        SIFCLContainerRed: "此貨櫃的總數量、重量及／或體積與已分配 PO 的總和不相同",
        SIFCLContainerGreen: "此貨櫃的總數量、重量及體積與已分配 PO 的總和相同",
    },
    ConsolidationShippingInformation: {
        msgPOColumnRed: "此 PO 未完全分配／過度分配。",
        msgPOColumnGreen: "此 PO 已完全分配。",
    },
    consolidationSelectedBookingMenuOption: {
        lblNoOption: "無下一個活動",
        lblRemoveShipment: "從拼櫃計劃移除",
        lblSearchShipmentByConsignee: "按收貨人尋找相關訂艙",
        lblSearchShipmentByCustomer: "按客戶尋找相關訂艙",
        lblSearchShipmentByNominationAgent: "按指定代理尋找相關訂艙",
        lblSearchShipmentBySailing: "按船期尋找相關訂艙",
    },
    prs: {
        msgDuplicatePartyDetected: "偵測到可能重複的客戶。是否確定建立新客戶？",
        headerShortName: "簡稱",
        headerPartyCodeStatus: "客戶代碼狀態",
        headerPartyAccountCodeStatus: "客戶帳戶代碼狀態",
        headerPartyStatus: "客戶狀態",
        btnSearchDuplicate: "搜尋重複",
        duplicateform: {
            lblName: "名稱",
        },
        lblGeneral: "一般",
        lblPartyDetail: "客戶詳情",
        lblFullNameLocal: "本地語言全名",
        lblRequesterRemark: "申請人備註",
        msgRequesterRemarkRequired: "請輸入申請人備註。",
        lblManagementRemark: "管理層備註",
        lblNameLock: "名稱鎖定",
        lblAddressLock: "地址鎖定",
        lblNoHBL: "不允許列印 HB/L",
        lblURL: "URL",
        tipsRequestBy: "建立此客戶的申請人",
        lblRequestBy: "申請人",
        lblRequestOffice: "申請辦事處",
        lblRequestDate: "申請日期",
        lblAddressDetail: "地址詳情",
        lblAddressType: "地址類型",
        msgAddressType: "請選擇地址類型",
        lblAddressLangType: "地址語言類型",
        msgAddressLangType: "請選擇地址語言",
        lblState: "州／省",
        lblContact: "聯絡人",
        lblContactType: "聯絡人類型",
        msgContactType: "請選擇聯絡人類型",
        lblPosition: "職位",
        lblPhone: "電話",
        msgPhone: "請輸入電話號碼",
        lblLedger: "帳套",
        btnFinanceApprove: "財務審批",
        btnFinanceReject: "財務拒絕",
        lblLedgerDetail: "帳套詳情",
        tipsSunSuffix: "在 SUN 4.x，帳戶代碼由 SUN 帳套前綴（例如 HKG 為 0129、WOFE 為 1121）及指派予特定客戶的唯一後綴組成。同一客戶在多個帳套的帳戶代碼均使用相同的 Sun 後綴。",
        lblSunSuffix: "Sun 後綴",
        tipsLedgerCode: "指指派予辦事處的帳套代碼（例如 HKG 為 7021、WOFE 分行為 703x）。",
        lblLedgerCode: "帳套代碼",
        lblInvoiceDetail: "發票詳情",
        msgLedgerCode: "請選擇帳套代碼。",
        lblSunacCode: "Sun 帳戶代碼",
        lblReject: "已拒絕",
        lblPending: "待處理",
        lblCancelled: "已取消",
        tipsApproveBtnWhileCancellingRole: "不可同時取消及審批客戶角色。",
        tipsRejectBtnWhileCancellingRole: "不可同時取消及拒絕客戶角色。",
        lblBatchPaymentAR: "批量發票 AR",
        lblBatchPaymentAP: "批量發票 AP",
        lblBankDetail: "銀行詳情",
        lblOpeningOffice: "銀行名稱",
        msgOpeningOffice: "請輸入銀行名稱。",
        lblAccountNo: "銀行帳戶號碼",
        msgAccountNo: "請輸入銀行帳戶號碼。",
        lblAccountCurrency: "銀行帳戶貨幣",
        msgAccountCurrency: "請選擇銀行帳戶貨幣",
        lblCreditLimit: "信貸限額",
        lblPaymentTermAR: "付款條款代碼 AR",
        lblPaymentTermAP: "付款條款代碼 AP",
        lblUnsettledAmountAR: "AR 未結金額",
        lblUnsettledAmountAP: "AP 未結金額",
        lblCreditReminder: "信貸提示",
        tipsCreditReminder: "當此客戶於此帳套的 AR 未結金額超過信貸提示值時，使用者在 Web Invoice 更新 AR 發票狀態時會彈出警告訊息。",
        lblCreditAmount: "信貸限額",
        msgCreditAmount: "請輸入信貸限額",
        lblCreditDeadline: "信貸到期日",
        lblCompanyID: "公司編號",
        lblTaxTypeID: "編號類型",
        lblTaxID: "稅務編號",
        msgTaxID: "請輸入編號",
        lblCoRegNo: "公司註冊編號",
        lblSSTRegNo: "SST 登記編號",
        lblBusinessLocation: "營業地點",
        lblNITKU: "NITKU",
        lblNPWPNIK: "NPWP/NIK",
        lblTaxRate: "稅率 %",
        lblInvoiceSubType: "發票子類型",
        lblOPSOffice: "OPS 辦事處",
        btnSelectAll: "全選",
        lblTargetOffice: "目標辦事處",
        tipsHeaderTargetOffice: "請將滑鼠移至其上以查看各目標辦事處已啟用的付貨人、供應商及船公司角色。",
        tipsTargetOffice: "只適用於本地客戶，例如付貨人、供應商。只有此類客戶會下載至目標辦事處 OPS，且只有此類客戶可用於 Web Invoice。",
        lblRole: "角色",
        btnSave: "儲存",
        btnMgtApprove: "管理層審批",
        btnMgtReject: "管理層拒絕",
        btnAdminApprove: "管理員審批",
        btnAdminReject: "管理員拒絕",
        lblAgent: "代理",
        lblAgentCode: "代理代碼",
        lblAgencyType: "代理類型",
        msgAgencyType: "正代理指列於正式代理紀錄中的代理。分代理指由正代理指示接收委託貨物的代理。如屬其他，請於備忘／備註中說明詳情。",
        lblSubAgent: "所屬正代理",
        lblISF: "ISF",
        lblISFAutoExcel: "ISF Auto Excel",
        lblISFEmail: "ISF Auto Excel 電郵",
        lblISFRemark: "ISF 備註",
        lblConsignee: "收貨人",
        lblConsigneeCode: "收貨人代碼",
        lblKeyAccount: "主要客戶",
        tipsKeyAccount: "此收貨人所屬的主要客戶。",
        lblCutomer: "客戶 (SIS)",
        tipsCustomer: "套用於 SIS 電子訂艙的客戶驗證設定檔。",
        lblIsModeBooking: "啟用自動註冊 (SIS)",
        tipsIsModeBooking: "讓系統根據已確認的電子訂艙自動連結 SIS 客戶驗證設定檔。",
        lblSelfRegistration: "啟用自行註冊 (SIS)",
        lblEORI: "EORI #",
        tipsEORI: "- EORI# 是所有設於歐盟的「經濟營運商」均可取得的代碼。\n\n- 凡為進口貨物至歐盟申報報關或由歐盟出口的經濟營運商，均必須持有 EORI#。\n\n- 非設於歐盟的經濟營運商，如將貨物進口至歐盟或由歐盟出口，亦必須申請 EORI#。\n\n- 非設於歐盟的經濟營運商，如其貨物僅過境歐盟，則不應申請 EORI#。\n\n- 非設於歐盟但向歐盟銷售／出口貨物至歐盟的經濟營運商，不應申請 EORI#。\n\n- EORI# 格式應為 2 個字母後加最多 15 個字母數字字元（例如：DE123456789012345）。\n\n- 由於 EORI# 不適用於瑞士、挪威及北愛爾蘭，請輸入識別編號（如當地稅務編號）作為 EORI#。",
        msgInvalidEORI: "請輸入有效的 EORI#！有效 EORI# 格式：2 個大寫字母 + 最多 15 個字母數字字元（例如 DE12345678901234）",
        colDocumentUploaded: "已上載文件",
        colConfiguration: "設定",
        lblDocumentUpload: "文件上載",
        lblDocumentUploadHistory: "文件上載歷史",
        lblDocumentType: "文件類型",
        lblFile: "檔案",
        lblAppliedTo: "套用於",
        tipsAppliedTo: "套用至客戶群組的文件，對所有加入該客戶群組的客戶均可見（不論其加入時間）。反之，如客戶被移離客戶群組，指派予該客戶群組的文件將不再可見，即使該文件是由該客戶上載。",
        lblDragOrUpload: "選擇／拖曳檔案",
        lblRemark: "備註",
        lbVisibleTo: "開放予",
        msgBeneficiaryNameContainsInvalidCharacter: "請輸入有效的受益人名稱！有效受益人名稱：可使用除 &_öä;<>#!\"%=\\`´*~ 以外的任何字元",
        msgBeneficiaryBicExccedsLenLimit: "請輸入有效的受益人 BIC！有效受益人 BIC 格式：8 或 11 個字元（例如 12345678、12345678910）",
        msgMissingEoriNo: "EORI # 為此客戶的必填資料，請填寫。",
        msgMissingUploadFile: "請上載檔案",
        msgEORIReminder: "歐盟、瑞士、挪威及北愛爾蘭的代理及收貨人必填",
        msgInvalidContactPhone: "用於 ENS 申報的電話號碼——請包含以「+」開頭的國家代碼，不含空格及符號。例如中國 (+86) 電話號碼為 +861234567890。",
        msgInvalidUSAssignedType: "請於「一般」頁面輸入稅務編號類型",
        msgInvalidUSAssignedID: "請於「一般」頁面輸入有效的稅務編號",
        msgInvalidDetailTaxType: "請輸入稅務編號類型",
        msgInvalidDetailTaxID: "請輸入有效的稅務編號",
        tipsDetailTaxID: "此稅務編號僅供 ISF 申報之用。如開立發票需要稅務編號，請參閱帳套頁面所維護的稅務編號。",
    },
    notification: {
        lblFollow: "跟進",
        lblFollowing: "跟進中",
        lblUserDefaultSettingTitle: "用戶預設通知設定",
        lblShipperOrderSettingTitle: "落貨紙的通知設定： ",
        lblMasterSettingTitleBooking: "訂艙",
        lblMasterSettingTitleConsolidation: "拼櫃",
        lblMasterSettingTitleWebInvoice: "Web Invoice",
        lblMasterSettingTitleNotificationCenter: "通知中心",
        lblFollowTitle: "您可選擇以下方式更改設定：",
        lblFollowOption1: "用戶預設",
        lblFollowOption2: "自訂",
        lblDefaultSelection: "預設選項",
        lblSettingDesc1: "下列事件會通知您",
        lblSettingDesc2: "方式：",
        lblEventTableColumnEvent: "事件",
        lblNotificationMethodOption1: "應用程式內通知",
        lblNotificationMethodOption2: "電郵通知",
        bellButtonToolTip: "通知",
        lblNotificationListTitle: "通知",
        smartSearchTooltip: "輸入 SO# 或 CONSOL# 以搜尋。 \n\n在此欄位輸入關鍵字後，您可按「Tab」鍵然後按「Enter」鍵執行搜尋。",
        lblNotificationListReadAll: "全部",
        lblNotificationListUnread: "未讀",
        lblNotificationListMenuOption1: "全部標記為已讀",
        lblNotificationListMenuOption2: "全部刪除",
        lblNotificationListMenuOption3: "重新整理",
        lblNotificationListMenuOption4: "用戶預設設定",
        lblNotificationListItemMenuOption1a: "標記為已讀",
        lblNotificationListItemMenuOption1b: "標記為未讀",
        lblNotificationListItemMenuOption2: "刪除通知",
        lblNotificationListItemMenuOption3a: "取消跟進 SO# ",
        msgSureToDeleteAll: "是否確定刪除所有通知？",
        lblNotificationViewAll: "查看全部",
        msgUnfollowSuccess: "取消跟隨成功。",
        msgUnfollowFail: "取消跟隨失敗。請聯絡系統管理員。",
        lblMasterSettingErrorMessageHeaderBooking: "訂艙工作階段",
        lblMasterSettingErrorMessageHeaderConsolidation: "拼櫃工作階段",
        lblMasterSettingErrorMessageHeaderWebInvoice: "Web Invoice 工作階段",
        lblMasterSettingErrorMessageHeaderNotificationCenter: "通知中心工作階段",
        msgSaveSettingSuccess: "設定已儲存",
        msgSaveSettingFail: "儲存設定失敗。請聯絡系統管理員。",
        msgAtLeastOneEvent: "請選擇至少 1 項通知事件。",
        msgAtLeastOneNotificationMethod: "請選擇至少 1 種通知方式。",
        msgMissingEmailAddress: "請填寫電郵地址。",
        msgInvalidEmailAddress: "電郵無效",
        lblEditUserDefaultSettingTooltip: "編輯",
        lblResetBtn: "重設選項",
        msgBookingNew: "{{updated_by_name}} 建立了 SO# {{so_no}}。",
        msgBookingAmend: "{{updated_by_name}} 修改了 SO# {{so_no}}。",
        msgBookingConfirm: "{{updated_by_name}} 已確認 SO# {{so_no}}。",
        msgBookingSubmitSI: "{{updated_by_name}} 已提交 SO# {{so_no}} 的 SI。",
        msgBookingCancelPending: "付貨人已取消 SO# {{so_no}}。",
        msgBookingCancelBooking: "{{updated_by_name}} 已取消 SO# {{so_no}}。",
        msgBookingRecoverBooking: "{{updated_by_name}} 已恢復 SO# {{so_no}}。",
        msgBookingChangeCargoReadyDate: "{{updated_by_name}} 將 SO# {{so_no}} 的貨物備妥日期由 {{original_cargo_ready_date}} 更改為 {{new_cargo_ready_date}}",
        msgBookingChangeHandlingOffice: "{{updated_by_name}} 將 SO# {{so_no}} 的處理辦事處由 {{original_handling_office_name}} 更改為 {{new_handling_office_name}}",
        msgBookingUpdateSailingA1: "{{updated_by_name}} 更新了 SO# {{so_no}} 的船期。\n已改選另一個 M+R 建議船期選項。",
        msgBookingUpdateSailingA2: "{{updated_by_name}} 更新了 SO# {{so_no}} 的船期。\n{{field_names}} {{is_or_are}} 已更改。",
        msgBookingUpdateSailingA2b: "{{updated_by_name}} 更新了 SO# {{so_no}} 的船期。",
        msgBookingUpdateSailingA2Detail: "{{field_name}} 已由 {{original_value}} 更改為 {{new_value}}。",
        msgBookingUpdateRouting: "{{updated_by_name}} 更新了 SO# {{so_no}} 的路線（{{field_names}}）。",
        msgBookingUpdateRoutingDetail: "{{field_full_name}} 已由 {{original_value}} 更改為 {{new_value}}。",
        msgBookingUploadBMSDocument: "{{updated_by_name}} 已為 SO# {{so_no}} 上載文件（{{document_types}}）",
        msgBookingDeleteBMSDocument: "{{updated_by_name}} 已為 SO# {{so_no}} 刪除文件（{{document_types}}）",
        msgBookingUpdateRate: "{{updated_by_name}} 更新了 SO# {{so_no}} 所選的{{rate_type}}。如有需要，請於 BMS 重新整理運價。",
        msgBookingUpdateTotalRate: "{{updated_by_name}} 更新了 SO# {{so_no}} 所選的總運價。如有需要，請於 BMS 重新整理運價。",
        msgBookingUpdateTotalRateDetail: "每個 {{container_size}} 貨櫃的總運價已由 {{old_total_rate_currency}} {{old_total_rate}} 更改為 {{new_total_rate_currency}} {{new_total_rate}}。",
        msgBookingUpdateRateOP: "{{updated_by_name}} 更新了 SO# {{so_no}} 所選的{{rate_type}}。",
        msgBookingUpdateRateOPA1: "{{updated_by_name}} 更新了 SO# {{so_no}} 所選的建議運價選項。\n已為該船期改選另一個建議運價選項。",
        msgBookingUpdateRateOPA234: "{{updated_by_name}} 更新了 SO# {{so_no}} 所選的建議運價選項。\n{{field_names}} {{is_or_are}} 已更改。",
        msgBookingUpdateRateOPA2Detail: "{{container_size}} 貨櫃的運價已{{change}}。",
        msgBookingUpdateRateOPA3Detail: "每個 {{container_size}} 貨櫃的總運價已由 {{old_total_rate_currency}} {{old_total_rate}} 更改為 {{new_total_rate_currency}} {{new_total_rate}}。",
        msgBookingUpdateRateOPA4FieldDetail: "{{field_name}} 已由 {{old_value}} 更改為 {{new_value}}。",
        msgBookingUpdateRateOPA4TabDetail: "{{field_name}} 已更新。請前往「{{tab_name}}」頁籤查看最新資料。",
        msgBookingCheckGoodDesc: "於 SO# {{so_no}} 偵測到不可接受的貨物描述。請檢查以確保訂艙描述符合申報要求，並按需要修訂，以免描述含糊。",
        msgBookingNewOperationRemark: "{updated_by_name} 於 SO# {so_no} 留下操作備註。<br/><br/>{remark}",
        msgBookingNewPricingRemark: "{updated_by_name} 於 SO# {so_no} 留下運價備註。<br/><br/>{remark}",
        msgBookingRequestForApproval: "{{updated_by_name}} 已將 SO# {{so_no}} 更新為「要求審批」。",
        msgBookingPendingCustomerApproval: "{{updated_by_name}} 已將 SO# {{so_no}} 更新為「待客戶審批」。",
        msgBookingApproved: "{{updated_by_name}} 已審批 SO# {{so_no}}。",
        msgBookingRejected: "{{updated_by_name}} 已拒絕 SO# {{so_no}}。",
        msgBookingBookingAdvice: "{{updated_by_name}} 已將 SO# {{so_no}} 更新為「訂艙通知」。",
        msgBookingLinkToAConsolPlan: "{{updated_by_name}} 已將 SO# {{so_no}} 連結至拼櫃計劃 {{consolidation_no}}",
        msgBookingDislinkToAConsolPlan: "{{updated_by_name}} 已將 SO# {{so_no}} 從拼櫃計劃 {{consolidation_no}} 解除連結",
        msgConsolidationUpdateSailingA1: "{{updated_by_name}} 更新了拼櫃 {{consolidation_no}} 的船期。\n已改選另一個 M+R 建議船期選項。",
        msgConsolidationUpdateSailingA2: "{{updated_by_name}} 更新了拼櫃 {{consolidation_no}} 的船期。\n{{field_names}} {{is_or_are}} 已更改。",
        msgConsolidationUpdateSailingA2b: "{{updated_by_name}} 更新了拼櫃 {{consolidation_no}} 的船期。",
        msgConsolidationUpdateSailingA2Detail: "{{field_name}} 已由 {{original_value}} 更改為 {{new_value}}。",
        msgConsolidationUpdateRate: "{{updated_by_name}} 更新了拼櫃 {{consolidation_no}} 所選的{{rate_type}}。如有需要，請於 BMS 重新整理運價。",
        msgConsolidationNewOperationRemark: "{updated_by_name} 於拼櫃 {consolidation_no} 留下拼櫃操作備註。<br/><br/>{remark}",
        msgConsolidationNewPricingRemark: "{updated_by_name} 於拼櫃 {consolidation_no} 留下拼櫃運價備註。<br/><br/>{remark}",
        msgConsolidationRequestForConsolApproval: "{{updated_by_name}} 已將拼櫃 {{consolidation_no}} 更新為「要求拼櫃審批」。",
        msgConsolidationPendingCustomerConsolApproval: "{{updated_by_name}} 已將拼櫃 {{consolidation_no}} 更新為「待客戶拼櫃審批」。",
        msgConsolidationApproved: "{{updated_by_name}} 已審批拼櫃 {{consolidation_no}}。",
        msgConsolidationRejected: "{{updated_by_name}} 已拒絕拼櫃 {{consolidation_no}}。",
        msgConsolidationConsolPlanAdvice: "{{updated_by_name}} 已將拼櫃 {{consolidation_no}} 更新為「拼櫃計劃建議」。",
        msgConsolidationUpdateTotalRate: "{{updated_by_name}} 更新了拼櫃 {{consolidation_no}} 所選的總運價。如有需要，請於 BMS 重新整理運價。",
        msgConsolidationUpdateTotalRateDetail: "每個 {{container_size}} 貨櫃的總費率已由 {{old_total_rate_currency}} {{old_total_rate}} 更改為 {{new_total_rate_currency}} {{new_total_rate}}。",
        msgConsolidationUpdateRateOP: "{{updated_by_name}} 已更新於 Consol# {{consolidation_no}} 中所選擇的 {{rate_type}}。",
        msgConsolidationUpdateRateOPA1: "{{updated_by_name}} 已更新於 Consol# {{consolidation_no}} 中所選擇的建議費率選項。\n此航次已改為選擇另一個建議費率選項。",
        msgConsolidationUpdateRateOPA234: "{{updated_by_name}} 已更新於 Consol# {{consolidation_no}} 中所選擇的建議費率選項。\n{{field_names}} {{is_or_are}} 已更改。",
        msgConsolidationUpdateRateOPA2Detail: "{{container_size}} 貨櫃的費率為 {{change}}。",
        msgConsolidationUpdateRateOPA3Detail: "每個 {{container_size}} 貨櫃的總費率已由 {{old_total_rate_currency}} {{old_total_rate}} 更改為 {{new_total_rate_currency}} {{new_total_rate}}。",
        msgConsolidationUpdateRateOPA4FieldDetail: "{{field_name}} 已由 {{original_value}} 更改為 {{new_value}}。",
        msgConsolidationUpdateRateOPA4TabDetail: "{{field_name}} 已更新。請前往「{{tab_name}}」頁籤查看最新資料。",
        msgPartyGroupSyncFileToParty: "{{document_types}} {{is_or_are}} 正在同步至 {{party_group_name}}。此過程可能需時較長。完成後將顯示通知。",
        msgPartyGroupSyncFileToPartyFinish: "文件已同步至 {{party_group_name}}。",
        msgSyncConsolidationDataToShipmentFinish: "Consol# {{consolidation_no}} 的更改已成功套用至 SO# {{so_nos}}。",
        msgWebInvoiceApReferenceRecognized: "已根據上傳的文件（檔案名稱：{{file_name}}）將 AP Ref. {{ap_reference}} 套用至 {{invoice_no}}",
        msgWebInvoiceApReferenceRecognizeError: "系統無法從 {{invoice_no}} 的上傳文件（檔案名稱：{{file_name}}）找到並擷取任何 AP Ref.，請檢查並手動更新 AP Ref.",
        msgWebInvoiceMissingSunac: "如要過帳 {{invoice_no}}，請在 PRS 的 Ledger 頁籤為 {{issued_party_code}} 申請 {{account_code}} Sun A/C Code，並確保申請能及時獲相關方審批。請採取相應必要行動。",
        msgWebInvoiceGroupFailure1: "GPE#{{group_no}} 匯出失敗，原因為基本貨幣總金額為負數（Invoice#{{invoice_no}}）",
        msgWebInvoiceGroupFailure2: "GPE#{{group_no}} 匯出失敗，原因為 {{invoice_no}} 的備註過長。請縮短備註，或於 Header 使用「簡潔版」備註格式，然後重新匯出。",
        msgWebInvoiceAccountingPrintCompleted: "{{invoice_no}}（開立予：{{issued_party_name}}）的列印本已可供下載。",
        msgMessengerMessage: "{{notice_short_desc}}",
        lblMasterSettingTitleBookingApproval: "Booking Approval",
    },
    oi: {
        colCustomerCode: "客戶編號",
        colCustomerType: "客戶類別",
        colSubscriptionRequestType: "訂閱請求類別",
        colRemark: "備註",
        colEffectiveDate: "生效日期",
        colExpiryDate: "到期日期",
        colLastUpdatedTime: "最後更新時間",
        colLastUpdatedBy: "最後更新者",
        colShipmentStatusToSIS: "至 SIS 的貨件狀態",
        colDaysToRaiseDelayStatus: "觸發延誤狀態日數",
        lblCustomerCode: "客戶編號",
        lblCustomerType: "客戶類別",
        lblSubscriptionRequestType: "訂閱請求類別",
        lblRemark: "備註",
        lblEffectiveDate: "生效日期",
        lblExpiryDate: "到期日期",
        lblLastUpdatedTime: "最後更新時間",
        lblLastUpdatedBy: "最後更新者",
        lblShipmentStatusToSIS: "至 SIS 的貨件狀態",
        lblDaysToRaiseDelayStatus: "觸發延誤狀態日數",
        msgCustomerCodeRequired: "必須輸入客戶編號。",
        msgCustomerTypeRequired: "請輸入客戶類別。",
        msgSubscriptionRequestTypeRequired: "必須輸入訂閱請求類別。",
    },
    carrier: {
        colMRCarrierCode: "M+R 船公司代碼",
        colIsSCAC: "是否 SCAC 代碼",
        colAlliance: "聯盟",
        colSCAC: "SCAC 代碼",
        colCBSA: "CBSA 代碼",
        colNACCS: "NACCS 代碼",
        colDisplayName: "顯示名稱",
        colFullName: "全名",
        colIsSailingSchedule: "是否船期",
        colEffectiveFrom: "生效日期由",
        colEffectiveTo: "生效日期至",
        colStatus: "狀態",
        colSFMCarrierSCAC: "SFMCarrier SCAC 代碼",
        colCarrierType: "船公司類別",
        colWebsite: "網站",
        lblMRCarrierCode: "M+R 船公司代碼",
        lblIsSCAC: "是否 SCAC 代碼",
        lblSCAC: "SCAC 代碼",
        lblCBSA: "CBSA 代碼",
        lblNACCS: "NACCS 代碼",
        lblDisplayName: "顯示名稱",
        lblFullName: "全名",
        lblIsSailingSchedule: "是否船期",
        lblAlliance: "聯盟",
        lblEffectiveFrom: "生效日期由",
        lblEffectiveTo: "生效日期至",
        lblStatus: "狀態",
        lblSFMCarrierCode: "SFMCarrier SCAC 代碼",
        lblCarrierType: "船公司類別",
        lblSea: "海運",
        lblWebsite: "網站",
        msgDuplicateMRCarrierCode: "M+R 船公司代碼必須唯一。",
        msgMRCarrierCodeRequired: "請輸入 M+R 船公司代碼。",
        msgMRCarrierCodeLenLtd: "M+R 船公司代碼長度必須為 2-4 個字元。",
        msgDuplicateCBSA: "CBSA 已存在。",
        msgCBSALenLtd: "CBSA 代碼長度必須為 4 個字元。",
        msgDuplicateNACCS: "NACCS 已存在。",
        msgNACCSLenLtd: "NACCS 代碼長度必須為 4 個字元。",
        msgDisplayNameRequired: "請輸入顯示名稱",
        msgFullNameRequired: "請輸入全名",
        msgDuplicateDisplayName: "船公司顯示名稱已存在。",
        msgDuplicateFullName: "船公司全名已存在。",
        msgAllianceRequired: "請選擇聯盟。",
        msgDuplicate: "M+R 船公司代碼必須唯一。",
        msgRecordNotLatest: "此記錄未更新。該記錄已被其他用戶更改。",
        msgInvalidEffectiveDate: "生效日期至不可早於生效日期由。",
    },
    sailingSchedule: {
        lbCreateAdditionalSailing: "新增額外航次",
        lbSelect: "選擇",
        msgHardStopDuplicateSailing: "系統已存在此船期，請從系統中選擇。",
        msgWarningDuplicateSailing: "找到以下已存在的船期。\n請點擊「選擇」以選用該現有船期。",
        msgWarningDuplicateSailing2: "僅當上述航次均不合適時，才點擊「新增額外航次」繼續。",
    },
    cargosphere: {
        lbEnvironmentCode: "環境代碼",
        lbLoginId: "登入 ID",
        lbPassword: "登入密碼",
        lbLoginStatus: "登入狀態",
        msgLoading: "載入中...",
        msgEnterPassword: "請輸入 cargosphere 登入密碼",
        msgInvalidLogin: "登入無效",
        msgValidLogin: "成功",
    },
    rate: {
        msgUpdateLoginInfo: "請點擊此處更新運價登入資料，以解鎖 Cargosphere 運價搜尋。",
        msgAddRateBeforeSave: "儲存前請先新增運價",
        msgLocalDealActionSuccess: "Local Deal 已成功{{action}}。",
        msgLocalDealSaveError: "Local Deal 儲存失敗，請重試。{{error_message}}",
        msgLocalDealValidating: "Local Deal 驗證中...",
    },
    mbl: {
        lblHeader: "表頭",
        lblStatus: "狀態",
        pnlSelectedContainer: "已選貨櫃",
        pnlMBLInfo: "Master BL 資料",
        pnlMBLRouting: "Master BL 路線",
        pnlMBLParty: "Master BL 相關方",
    },
    mblSelectedContainerMenuOption: {
        lblNoOption: "無下一項活動",
        lblRemoveContainer: "從 Master BL 樣本中移除",
    },
};

export default tc;
